const DerivableLogo = () => {
  return (
    <svg width="138" height="34" viewBox="0 0 1698 413" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_166_7744" fill="white">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M107 217C107 212.582 110.582 209 115 209H176.3C180.719 209 184.3 212.582 184.3 217V268.847L224.227 301.76H315.441C319.859 301.76 323.441 305.342 323.441 309.76V401.981C323.441 406.399 319.859 409.981 315.441 409.981H218.067C213.649 409.981 210.067 406.399 210.067 401.981V322.046L166.704 286.3H115C110.582 286.3 107 282.719 107 278.3V217Z"/>
      </mask>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M107 217C107 212.582 110.582 209 115 209H176.3C180.719 209 184.3 212.582 184.3 217V268.847L224.227 301.76H315.441C319.859 301.76 323.441 305.342 323.441 309.76V401.981C323.441 406.399 319.859 409.981 315.441 409.981H218.067C213.649 409.981 210.067 406.399 210.067 401.981V322.046L166.704 286.3H115C110.582 286.3 107 282.719 107 278.3V217Z" fill="#87DEB5"/>
      <path d="M184.3 268.847H183.109V269.409L183.543 269.766L184.3 268.847ZM224.227 301.76L223.47 302.679L223.799 302.951H224.227V301.76ZM210.067 322.046H211.258V321.484L210.825 321.127L210.067 322.046ZM166.704 286.3L167.462 285.381L167.132 285.109H166.704V286.3ZM115 207.809C109.924 207.809 105.809 211.924 105.809 217H108.191C108.191 213.239 111.239 210.191 115 210.191V207.809ZM176.3 207.809H115V210.191H176.3V207.809ZM185.491 217C185.491 211.924 181.376 207.809 176.3 207.809V210.191C180.061 210.191 183.109 213.239 183.109 217H185.491ZM185.491 268.847V217H183.109V268.847H185.491ZM183.543 269.766L223.47 302.679L224.985 300.841L185.058 267.928L183.543 269.766ZM315.441 300.569H224.227V302.951H315.441V300.569ZM324.632 309.76C324.632 304.684 320.517 300.569 315.441 300.569V302.951C319.201 302.951 322.25 306 322.25 309.76H324.632ZM324.632 401.981V309.76H322.25V401.981H324.632ZM315.441 411.172C320.517 411.172 324.632 407.057 324.632 401.981H322.25C322.25 405.741 319.201 408.79 315.441 408.79V411.172ZM218.067 411.172H315.441V408.79H218.067V411.172ZM208.876 401.981C208.876 407.057 212.991 411.172 218.067 411.172V408.79C214.306 408.79 211.258 405.741 211.258 401.981H208.876ZM208.876 322.046V401.981H211.258V322.046H208.876ZM210.825 321.127L167.462 285.381L165.947 287.219L209.31 322.965L210.825 321.127ZM115 287.491H166.704V285.109H115V287.491ZM105.809 278.3C105.809 283.376 109.924 287.491 115 287.491V285.109C111.239 285.109 108.191 282.061 108.191 278.3H105.809ZM105.809 217V278.3H108.191V217H105.809Z" fill="#2A2A2A" mask="url(#path-1-inside-1_166_7744)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M191.232 410H8C3.58173 410 0 406.418 0 402V7.99999C0 3.58171 3.58172 0 8 0H315C319.418 0 323 3.58172 323 8V100.017C323 104.435 319.418 108.017 315 108.017H160.582C156.164 108.017 152.582 111.599 152.582 116.017V147C152.582 151.418 156.164 155 160.582 155H233C237.418 155 241 158.582 241 163V245.725C241 250.143 237.418 253.725 233 253.725H204.3V217C204.3 201.536 191.764 189 176.3 189H115C99.536 189 87 201.536 87 217V278.3C87 293.764 99.536 306.3 115 306.3H159.523L190.067 331.479V401.981C190.067 404.768 190.474 407.46 191.232 410Z" fill="#87DEB5"/>
      <mask id="path-4-outside-2_166_7744" maskUnits="userSpaceOnUse" x="349" y="153" width="1350" height="261" fill="black">
      <rect fill="white" x="349" y="153" width="1350" height="261"/>
      <path d="M512.878 158.676H582.75V410H512.878L419.835 269.544V410H349.963V158.676H419.835L512.878 300.915V158.676ZM714.881 158.676C795.091 158.676 846.069 210.367 846.069 284.16C846.069 356.883 795.091 410 714.881 410H615.421V158.676H714.881ZM685.293 348.328H709.534C749.817 348.328 775.128 325.512 775.128 284.16C775.128 242.451 749.817 219.279 709.534 219.279H685.293V348.328ZM869.366 304.48V158.676H938.881V304.48C938.881 330.503 950.645 346.902 977.025 346.902C1003.41 346.902 1015.88 330.503 1015.88 304.48V158.676H1085.75V304.48C1085.75 376.134 1035.85 412.495 975.599 412.495C914.996 412.495 869.366 376.134 869.366 304.48ZM1250.06 243.164C1250.06 227.478 1240.44 217.14 1221.55 217.14H1186.97V269.544H1221.55C1240.44 269.544 1250.06 260.275 1250.06 243.164ZM1117.09 158.676H1227.25C1289.63 158.676 1321.01 194.325 1321.01 239.242C1321.01 272.039 1303.18 300.558 1265.75 311.966L1322.43 410H1244.36L1194.45 317.313H1186.97V410H1117.09V158.676ZM1345.65 410V158.676H1415.52V410H1345.65ZM1697.37 283.447C1697.37 359.022 1639.97 412.495 1568.68 412.495C1497.38 412.495 1439.63 359.022 1439.63 283.447C1439.63 207.871 1497.38 154.755 1568.68 154.755C1640.33 154.755 1697.37 207.871 1697.37 283.447ZM1510.92 283.447C1510.92 322.304 1532.31 347.615 1568.68 347.615C1604.68 347.615 1626.43 322.304 1626.43 283.447C1626.43 243.877 1604.68 218.923 1568.68 218.923C1532.31 218.923 1510.92 243.877 1510.92 283.447Z"/>
      </mask>
      <path d="M512.878 158.676H582.75V410H512.878L419.835 269.544V410H349.963V158.676H419.835L512.878 300.915V158.676ZM714.881 158.676C795.091 158.676 846.069 210.367 846.069 284.16C846.069 356.883 795.091 410 714.881 410H615.421V158.676H714.881ZM685.293 348.328H709.534C749.817 348.328 775.128 325.512 775.128 284.16C775.128 242.451 749.817 219.279 709.534 219.279H685.293V348.328ZM869.366 304.48V158.676H938.881V304.48C938.881 330.503 950.645 346.902 977.025 346.902C1003.41 346.902 1015.88 330.503 1015.88 304.48V158.676H1085.75V304.48C1085.75 376.134 1035.85 412.495 975.599 412.495C914.996 412.495 869.366 376.134 869.366 304.48ZM1250.06 243.164C1250.06 227.478 1240.44 217.14 1221.55 217.14H1186.97V269.544H1221.55C1240.44 269.544 1250.06 260.275 1250.06 243.164ZM1117.09 158.676H1227.25C1289.63 158.676 1321.01 194.325 1321.01 239.242C1321.01 272.039 1303.18 300.558 1265.75 311.966L1322.43 410H1244.36L1194.45 317.313H1186.97V410H1117.09V158.676ZM1345.65 410V158.676H1415.52V410H1345.65ZM1697.37 283.447C1697.37 359.022 1639.97 412.495 1568.68 412.495C1497.38 412.495 1439.63 359.022 1439.63 283.447C1439.63 207.871 1497.38 154.755 1568.68 154.755C1640.33 154.755 1697.37 207.871 1697.37 283.447ZM1510.92 283.447C1510.92 322.304 1532.31 347.615 1568.68 347.615C1604.68 347.615 1626.43 322.304 1626.43 283.447C1626.43 243.877 1604.68 218.923 1568.68 218.923C1532.31 218.923 1510.92 243.877 1510.92 283.447Z" fill="#F2F2F2"/>
      <path d="M512.878 158.676V157.89H512.092V158.676H512.878ZM582.75 158.676H583.536V157.89H582.75V158.676ZM582.75 410V410.786H583.536V410H582.75ZM512.878 410L512.223 410.434L512.456 410.786H512.878V410ZM419.835 269.544L420.49 269.11L419.049 266.934V269.544H419.835ZM419.835 410V410.786H420.621V410H419.835ZM349.963 410H349.177V410.786H349.963V410ZM349.963 158.676V157.89H349.177V158.676H349.963ZM419.835 158.676L420.493 158.246L420.26 157.89H419.835V158.676ZM512.878 300.915L512.22 301.345L513.664 303.552V300.915H512.878ZM512.878 159.462H582.75V157.89H512.878V159.462ZM581.964 158.676V410H583.536V158.676H581.964ZM582.75 409.214H512.878V410.786H582.75V409.214ZM513.534 409.566L420.49 269.11L419.18 269.978L512.223 410.434L513.534 409.566ZM419.049 269.544V410H420.621V269.544H419.049ZM419.835 409.214H349.963V410.786H419.835V409.214ZM350.749 410V158.676H349.177V410H350.749ZM349.963 159.462H419.835V157.89H349.963V159.462ZM419.177 159.106L512.22 301.345L513.536 300.484L420.493 158.246L419.177 159.106ZM513.664 300.915V158.676H512.092V300.915H513.664ZM615.421 410H614.635V410.786H615.421V410ZM615.421 158.676V157.89H614.635V158.676H615.421ZM685.293 348.328H684.507V349.114H685.293V348.328ZM685.293 219.279V218.493H684.507V219.279H685.293ZM714.881 159.462C754.815 159.462 787.404 172.326 810.006 194.309C832.607 216.291 845.283 247.449 845.283 284.16H846.855C846.855 247.077 834.042 215.494 811.102 193.182C788.162 170.871 755.158 157.89 714.881 157.89V159.462ZM845.283 284.16C845.283 320.333 832.608 351.584 810.003 373.79C787.398 395.997 754.809 409.214 714.881 409.214V410.786C755.164 410.786 788.168 397.445 811.105 374.912C834.041 352.379 846.855 320.71 846.855 284.16H845.283ZM714.881 409.214H615.421V410.786H714.881V409.214ZM616.207 410V158.676H614.635V410H616.207ZM615.421 159.462H714.881V157.89H615.421V159.462ZM685.293 349.114H709.534V347.542H685.293V349.114ZM709.534 349.114C729.821 349.114 746.434 343.367 757.981 332.319C769.532 321.266 775.914 304.999 775.914 284.16H774.342C774.342 304.673 768.068 320.49 756.894 331.183C745.714 341.881 729.531 347.542 709.534 347.542V349.114ZM775.914 284.16C775.914 263.144 769.533 246.701 757.984 235.514C746.439 224.331 729.824 218.493 709.534 218.493V220.065C729.528 220.065 745.71 225.813 756.89 236.643C768.067 247.469 774.342 263.466 774.342 284.16H775.914ZM709.534 218.493H685.293V220.065H709.534V218.493ZM684.507 219.279V348.328H686.079V219.279H684.507ZM869.366 158.676V157.89H868.58V158.676H869.366ZM938.881 158.676H939.667V157.89H938.881V158.676ZM1015.88 158.676V157.89H1015.1V158.676H1015.88ZM1085.75 158.676H1086.54V157.89H1085.75V158.676ZM870.152 304.48V158.676H868.58V304.48H870.152ZM869.366 159.462H938.881V157.89H869.366V159.462ZM938.095 158.676V304.48H939.667V158.676H938.095ZM938.095 304.48C938.095 317.595 941.058 328.411 947.461 335.958C953.884 343.528 963.665 347.688 977.025 347.688V346.116C964.006 346.116 954.714 342.076 948.66 334.941C942.587 327.783 939.667 317.388 939.667 304.48H938.095ZM977.025 347.688C990.385 347.688 1000.34 343.529 1006.94 335.966C1013.52 328.422 1016.67 317.605 1016.67 304.48H1015.1C1015.1 317.378 1012 327.772 1005.75 334.933C999.521 342.075 990.046 346.116 977.025 346.116V347.688ZM1016.67 304.48V158.676H1015.1V304.48H1016.67ZM1015.88 159.462H1085.75V157.89H1015.88V159.462ZM1084.97 158.676V304.48H1086.54V158.676H1084.97ZM1084.97 304.48C1084.97 340.112 1072.57 366.894 1052.74 384.774C1032.91 402.666 1005.57 411.709 975.599 411.709V413.281C1005.88 413.281 1033.62 404.144 1053.8 385.941C1073.99 367.728 1086.54 340.501 1086.54 304.48H1084.97ZM975.599 411.709C945.452 411.709 919.104 402.667 900.298 384.788C881.5 366.916 870.152 340.134 870.152 304.48H868.58C868.58 340.48 880.048 367.705 899.215 385.927C918.375 404.143 945.144 413.281 975.599 413.281V411.709ZM1186.97 217.14V216.354H1186.18V217.14H1186.97ZM1186.97 269.544H1186.18V270.33H1186.97V269.544ZM1117.09 158.676V157.89H1116.31V158.676H1117.09ZM1265.75 311.966L1265.52 311.214L1264.57 311.502L1265.07 312.359L1265.75 311.966ZM1322.43 410V410.786H1323.79L1323.11 409.607L1322.43 410ZM1244.36 410L1243.67 410.373L1243.89 410.786H1244.36V410ZM1194.45 317.313L1195.14 316.941L1194.92 316.527H1194.45V317.313ZM1186.97 317.313V316.527H1186.18V317.313H1186.97ZM1186.97 410V410.786H1187.75V410H1186.97ZM1117.09 410H1116.31V410.786H1117.09V410ZM1250.85 243.164C1250.85 235.159 1248.39 228.427 1243.43 223.701C1238.48 218.979 1231.13 216.354 1221.55 216.354V217.926C1230.85 217.926 1237.77 220.471 1242.35 224.839C1246.93 229.203 1249.28 235.483 1249.28 243.164H1250.85ZM1221.55 216.354H1186.97V217.926H1221.55V216.354ZM1186.18 217.14V269.544H1187.75V217.14H1186.18ZM1186.97 270.33H1221.55V268.758H1186.97V270.33ZM1221.55 270.33C1231.11 270.33 1238.46 267.984 1243.43 263.345C1248.4 258.697 1250.85 251.865 1250.85 243.164H1249.28C1249.28 251.574 1246.92 257.932 1242.35 262.196C1237.78 266.469 1230.87 268.758 1221.55 268.758V270.33ZM1117.09 159.462H1227.25V157.89H1117.09V159.462ZM1227.25 159.462C1258.29 159.462 1281.52 168.33 1296.99 182.691C1312.45 197.05 1320.22 216.972 1320.22 239.242H1321.79C1321.79 216.596 1313.88 196.234 1298.06 181.539C1282.24 166.847 1258.59 157.89 1227.25 157.89V159.462ZM1320.22 239.242C1320.22 271.709 1302.61 299.912 1265.52 311.214L1265.98 312.718C1303.76 301.205 1321.79 272.369 1321.79 239.242H1320.22ZM1265.07 312.359L1321.75 410.393L1323.11 409.607L1266.43 311.572L1265.07 312.359ZM1322.43 409.214H1244.36V410.786H1322.43V409.214ZM1245.05 409.627L1195.14 316.941L1193.76 317.686L1243.67 410.373L1245.05 409.627ZM1194.45 316.527H1186.97V318.099H1194.45V316.527ZM1186.18 317.313V410H1187.75V317.313H1186.18ZM1186.97 409.214H1117.09V410.786H1186.97V409.214ZM1117.88 410V158.676H1116.31V410H1117.88ZM1345.65 410H1344.86V410.786H1345.65V410ZM1345.65 158.676V157.89H1344.86V158.676H1345.65ZM1415.52 158.676H1416.31V157.89H1415.52V158.676ZM1415.52 410V410.786H1416.31V410H1415.52ZM1346.44 410V158.676H1344.86V410H1346.44ZM1345.65 159.462H1415.52V157.89H1345.65V159.462ZM1414.74 158.676V410H1416.31V158.676H1414.74ZM1415.52 409.214H1345.65V410.786H1415.52V409.214ZM1696.58 283.447C1696.58 358.574 1639.55 411.709 1568.68 411.709V413.281C1640.39 413.281 1698.15 359.471 1698.15 283.447H1696.58ZM1568.68 411.709C1497.79 411.709 1440.41 358.571 1440.41 283.447H1438.84C1438.84 359.473 1496.96 413.281 1568.68 413.281V411.709ZM1440.41 283.447C1440.41 208.325 1497.79 155.541 1568.68 155.541V153.969C1496.96 153.969 1438.84 207.417 1438.84 283.447H1440.41ZM1568.68 155.541C1639.91 155.541 1696.58 208.321 1696.58 283.447H1698.15C1698.15 207.422 1640.75 153.969 1568.68 153.969V155.541ZM1510.14 283.447C1510.14 303.014 1515.52 319.259 1525.58 330.623C1535.64 341.999 1550.3 348.401 1568.68 348.401V346.829C1550.69 346.829 1536.48 340.575 1526.75 329.581C1517.02 318.576 1511.71 302.737 1511.71 283.447H1510.14ZM1568.68 348.401C1586.87 348.401 1601.54 341.998 1611.64 330.624C1621.74 319.262 1627.21 303.017 1627.21 283.447H1625.64C1625.64 302.734 1620.24 318.573 1610.47 329.58C1600.7 340.576 1586.48 346.829 1568.68 346.829V348.401ZM1627.21 283.447C1627.21 263.523 1621.74 247.188 1611.64 235.824C1601.53 224.448 1586.87 218.137 1568.68 218.137V219.709C1586.49 219.709 1600.7 225.874 1610.47 236.868C1620.24 247.873 1625.64 263.8 1625.64 283.447H1627.21ZM1568.68 218.137C1550.3 218.137 1535.64 224.447 1525.58 235.825C1515.52 247.191 1510.14 263.526 1510.14 283.447H1511.71C1511.71 263.797 1517.02 247.871 1526.75 236.867C1536.47 225.875 1550.68 219.709 1568.68 219.709V218.137Z" fill="#2A2A2A" mask="url(#path-4-outside-2_166_7744)"/>
      <path d="M107 217C107 212.582 110.582 209 115 209H176.3C180.719 209 184.3 212.582 184.3 217V268.847L224.227 301.76H315.441C319.859 301.76 323.441 305.342 323.441 309.76V401.981C323.441 406.399 319.859 409.981 315.441 409.981H218.067C213.649 409.981 210.067 406.399 210.067 401.981V322.046L166.704 286.3H115C110.582 286.3 107 282.719 107 278.3V217Z" fill="#F2F2F2"/>
    </svg>
  )
};

const HomeContentHeader = () => {
  return (
    <svg width="785" height="90" viewBox="0 0 785 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M118.872 41.56V34.18H127.392C129.112 34.18 130.552 33.84 131.712 33.16C132.912 32.48 133.812 31.54 134.412 30.34C135.052 29.14 135.372 27.76 135.372 26.2C135.372 24.64 135.052 23.26 134.412 22.06C133.812 20.86 132.912 19.94 131.712 19.3C130.552 18.62 129.112 18.28 127.392 18.28H118.872V10.9H126.672C130.352 10.9 133.472 11.5 136.032 12.7C138.632 13.9 140.612 15.62 141.972 17.86C143.332 20.06 144.012 22.68 144.012 25.72V26.68C144.012 29.72 143.332 32.36 141.972 34.6C140.612 36.8 138.632 38.52 136.032 39.76C133.472 40.96 130.352 41.56 126.672 41.56H118.872ZM111.552 55V10.9H120.072V55H111.552ZM150.619 55V22.42H157.219V36.22H157.039C157.039 31.54 158.039 28 160.039 25.6C162.039 23.2 164.979 22 168.859 22H170.059V29.26H167.779C164.979 29.26 162.799 30.02 161.239 31.54C159.719 33.02 158.959 35.18 158.959 38.02V55H150.619ZM191.064 56.14C188.184 56.14 185.644 55.68 183.444 54.76C181.244 53.84 179.384 52.6 177.864 51.04C176.344 49.44 175.184 47.64 174.384 45.64C173.624 43.64 173.244 41.56 173.244 39.4V38.14C173.244 35.9 173.644 33.78 174.444 31.78C175.284 29.74 176.464 27.94 177.984 26.38C179.544 24.78 181.424 23.54 183.624 22.66C185.824 21.74 188.304 21.28 191.064 21.28C193.824 21.28 196.304 21.74 198.504 22.66C200.704 23.54 202.564 24.78 204.084 26.38C205.644 27.94 206.824 29.74 207.624 31.78C208.424 33.78 208.824 35.9 208.824 38.14V39.4C208.824 41.56 208.424 43.64 207.624 45.64C206.864 47.64 205.724 49.44 204.204 51.04C202.684 52.6 200.824 53.84 198.624 54.76C196.424 55.68 193.904 56.14 191.064 56.14ZM191.064 49C193.104 49 194.824 48.56 196.224 47.68C197.624 46.76 198.684 45.54 199.404 44.02C200.124 42.46 200.484 40.7 200.484 38.74C200.484 36.74 200.104 34.98 199.344 33.46C198.624 31.9 197.544 30.68 196.104 29.8C194.704 28.88 193.024 28.42 191.064 28.42C189.104 28.42 187.404 28.88 185.964 29.8C184.564 30.68 183.484 31.9 182.724 33.46C181.964 34.98 181.584 36.74 181.584 38.74C181.584 40.7 181.944 42.46 182.664 44.02C183.424 45.54 184.504 46.76 185.904 47.68C187.304 48.56 189.024 49 191.064 49ZM231.787 56.14C228.907 56.14 226.367 55.68 224.167 54.76C221.967 53.84 220.107 52.6 218.587 51.04C217.067 49.44 215.907 47.64 215.107 45.64C214.347 43.64 213.967 41.56 213.967 39.4V38.14C213.967 35.9 214.367 33.78 215.167 31.78C216.007 29.74 217.187 27.94 218.707 26.38C220.267 24.78 222.147 23.54 224.347 22.66C226.547 21.74 229.027 21.28 231.787 21.28C234.547 21.28 237.027 21.74 239.227 22.66C241.427 23.54 243.287 24.78 244.807 26.38C246.367 27.94 247.547 29.74 248.347 31.78C249.147 33.78 249.547 35.9 249.547 38.14V39.4C249.547 41.56 249.147 43.64 248.347 45.64C247.587 47.64 246.447 49.44 244.927 51.04C243.407 52.6 241.547 53.84 239.347 54.76C237.147 55.68 234.627 56.14 231.787 56.14ZM231.787 49C233.827 49 235.547 48.56 236.947 47.68C238.347 46.76 239.407 45.54 240.127 44.02C240.847 42.46 241.207 40.7 241.207 38.74C241.207 36.74 240.827 34.98 240.067 33.46C239.347 31.9 238.267 30.68 236.827 29.8C235.427 28.88 233.747 28.42 231.787 28.42C229.827 28.42 228.127 28.88 226.687 29.8C225.287 30.68 224.207 31.9 223.447 33.46C222.687 34.98 222.307 36.74 222.307 38.74C222.307 40.7 222.667 42.46 223.387 44.02C224.147 45.54 225.227 46.76 226.627 47.68C228.027 48.56 229.747 49 231.787 49ZM257.629 55V21.64C257.629 17.92 258.649 15.18 260.689 13.42C262.769 11.62 265.829 10.72 269.869 10.72H273.949V17.14H269.269C268.029 17.14 267.069 17.48 266.389 18.16C265.749 18.8 265.429 19.72 265.429 20.92V55H257.629ZM253.549 29.08V22.96H274.489V29.08H253.549ZM308.31 56.14C305.43 56.14 302.89 55.68 300.69 54.76C298.49 53.84 296.63 52.6 295.11 51.04C293.59 49.44 292.43 47.64 291.63 45.64C290.87 43.64 290.49 41.56 290.49 39.4V38.14C290.49 35.9 290.89 33.78 291.69 31.78C292.53 29.74 293.71 27.94 295.23 26.38C296.79 24.78 298.67 23.54 300.87 22.66C303.07 21.74 305.55 21.28 308.31 21.28C311.07 21.28 313.55 21.74 315.75 22.66C317.95 23.54 319.81 24.78 321.33 26.38C322.89 27.94 324.07 29.74 324.87 31.78C325.67 33.78 326.07 35.9 326.07 38.14V39.4C326.07 41.56 325.67 43.64 324.87 45.64C324.11 47.64 322.97 49.44 321.45 51.04C319.93 52.6 318.07 53.84 315.87 54.76C313.67 55.68 311.15 56.14 308.31 56.14ZM308.31 49C310.35 49 312.07 48.56 313.47 47.68C314.87 46.76 315.93 45.54 316.65 44.02C317.37 42.46 317.73 40.7 317.73 38.74C317.73 36.74 317.35 34.98 316.59 33.46C315.87 31.9 314.79 30.68 313.35 29.8C311.95 28.88 310.27 28.42 308.31 28.42C306.35 28.42 304.65 28.88 303.21 29.8C301.81 30.68 300.73 31.9 299.97 33.46C299.21 34.98 298.83 36.74 298.83 38.74C298.83 40.7 299.19 42.46 299.91 44.02C300.67 45.54 301.75 46.76 303.15 47.68C304.55 48.56 306.27 49 308.31 49ZM334.153 55V21.64C334.153 17.92 335.173 15.18 337.213 13.42C339.293 11.62 342.353 10.72 346.393 10.72H350.473V17.14H345.793C344.553 17.14 343.593 17.48 342.913 18.16C342.273 18.8 341.953 19.72 341.953 20.92V55H334.153ZM330.073 29.08V22.96H351.013V29.08H330.073ZM369.834 55V10.9H378.354V55H369.834ZM396.594 55L383.154 35.92H392.694L406.554 55H396.594ZM375.834 40.36V33.46H386.994C388.554 33.46 389.894 33.14 391.014 32.5C392.174 31.86 393.074 30.96 393.714 29.8C394.354 28.64 394.674 27.32 394.674 25.84C394.674 24.32 394.354 22.98 393.714 21.82C393.074 20.66 392.174 19.76 391.014 19.12C389.894 18.48 388.554 18.16 386.994 18.16H375.834V10.9H386.094C389.614 10.9 392.654 11.42 395.214 12.46C397.814 13.5 399.814 15.08 401.214 17.2C402.614 19.32 403.314 21.98 403.314 25.18V26.14C403.314 29.38 402.594 32.04 401.154 34.12C399.754 36.2 397.774 37.76 395.214 38.8C392.654 39.84 389.614 40.36 386.094 40.36H375.834ZM426.351 56.14C423.551 56.14 421.091 55.66 418.971 54.7C416.891 53.74 415.151 52.46 413.751 50.86C412.391 49.22 411.351 47.4 410.631 45.4C409.951 43.4 409.611 41.36 409.611 39.28V38.14C409.611 35.98 409.951 33.9 410.631 31.9C411.351 29.86 412.391 28.06 413.751 26.5C415.151 24.9 416.871 23.64 418.911 22.72C420.951 21.76 423.311 21.28 425.991 21.28C429.511 21.28 432.451 22.06 434.811 23.62C437.211 25.14 439.011 27.16 440.211 29.68C441.411 32.16 442.011 34.84 442.011 37.72V40.72H413.151V35.62H436.791L434.211 38.14C434.211 36.06 433.911 34.28 433.311 32.8C432.711 31.32 431.791 30.18 430.551 29.38C429.351 28.58 427.831 28.18 425.991 28.18C424.151 28.18 422.591 28.6 421.311 29.44C420.031 30.28 419.051 31.5 418.371 33.1C417.731 34.66 417.411 36.54 417.411 38.74C417.411 40.78 417.731 42.6 418.371 44.2C419.011 45.76 419.991 47 421.311 47.92C422.631 48.8 424.311 49.24 426.351 49.24C428.391 49.24 430.051 48.84 431.331 48.04C432.611 47.2 433.431 46.18 433.791 44.98H441.471C440.991 47.22 440.071 49.18 438.711 50.86C437.351 52.54 435.611 53.84 433.491 54.76C431.411 55.68 429.031 56.14 426.351 56.14ZM449.758 55V21.64C449.758 17.92 450.778 15.18 452.818 13.42C454.898 11.62 457.958 10.72 461.998 10.72H466.078V17.14H461.398C460.158 17.14 459.198 17.48 458.518 18.16C457.878 18.8 457.558 19.72 457.558 20.92V55H449.758ZM445.678 29.08V22.96H466.618V29.08H445.678ZM486.234 56.14C483.434 56.14 480.974 55.66 478.854 54.7C476.774 53.74 475.034 52.46 473.634 50.86C472.274 49.22 471.234 47.4 470.514 45.4C469.834 43.4 469.494 41.36 469.494 39.28V38.14C469.494 35.98 469.834 33.9 470.514 31.9C471.234 29.86 472.274 28.06 473.634 26.5C475.034 24.9 476.754 23.64 478.794 22.72C480.834 21.76 483.194 21.28 485.874 21.28C489.394 21.28 492.334 22.06 494.694 23.62C497.094 25.14 498.894 27.16 500.094 29.68C501.294 32.16 501.894 34.84 501.894 37.72V40.72H473.034V35.62H496.674L494.094 38.14C494.094 36.06 493.794 34.28 493.194 32.8C492.594 31.32 491.674 30.18 490.434 29.38C489.234 28.58 487.714 28.18 485.874 28.18C484.034 28.18 482.474 28.6 481.194 29.44C479.914 30.28 478.934 31.5 478.254 33.1C477.614 34.66 477.294 36.54 477.294 38.74C477.294 40.78 477.614 42.6 478.254 44.2C478.894 45.76 479.874 47 481.194 47.92C482.514 48.8 484.194 49.24 486.234 49.24C488.274 49.24 489.934 48.84 491.214 48.04C492.494 47.2 493.314 46.18 493.674 44.98H501.354C500.874 47.22 499.954 49.18 498.594 50.86C497.234 52.54 495.494 53.84 493.374 54.76C491.294 55.68 488.914 56.14 486.234 56.14ZM508.861 55V22.42H515.461V36.22H515.281C515.281 31.54 516.281 28 518.281 25.6C520.281 23.2 523.221 22 527.101 22H528.301V29.26H526.021C523.221 29.26 521.041 30.02 519.481 31.54C517.961 33.02 517.201 35.18 517.201 38.02V55H508.861ZM548.226 56.14C545.426 56.14 542.966 55.66 540.846 54.7C538.766 53.74 537.026 52.46 535.626 50.86C534.266 49.22 533.226 47.4 532.506 45.4C531.826 43.4 531.486 41.36 531.486 39.28V38.14C531.486 35.98 531.826 33.9 532.506 31.9C533.226 29.86 534.266 28.06 535.626 26.5C537.026 24.9 538.746 23.64 540.786 22.72C542.826 21.76 545.186 21.28 547.866 21.28C551.386 21.28 554.326 22.06 556.686 23.62C559.086 25.14 560.886 27.16 562.086 29.68C563.286 32.16 563.886 34.84 563.886 37.72V40.72H535.026V35.62H558.666L556.086 38.14C556.086 36.06 555.786 34.28 555.186 32.8C554.586 31.32 553.666 30.18 552.426 29.38C551.226 28.58 549.706 28.18 547.866 28.18C546.026 28.18 544.466 28.6 543.186 29.44C541.906 30.28 540.926 31.5 540.246 33.1C539.606 34.66 539.286 36.54 539.286 38.74C539.286 40.78 539.606 42.6 540.246 44.2C540.886 45.76 541.866 47 543.186 47.92C544.506 48.8 546.186 49.24 548.226 49.24C550.266 49.24 551.926 48.84 553.206 48.04C554.486 47.2 555.306 46.18 555.666 44.98H563.346C562.866 47.22 561.946 49.18 560.586 50.86C559.226 52.54 557.486 53.84 555.366 54.76C553.286 55.68 550.906 56.14 548.226 56.14ZM570.853 55V22.42H577.453V36.4H576.853C576.853 33.08 577.293 30.32 578.173 28.12C579.053 25.88 580.353 24.2 582.073 23.08C583.833 21.96 586.013 21.4 588.613 21.4H588.973C592.853 21.4 595.793 22.66 597.793 25.18C599.793 27.66 600.793 31.38 600.793 36.34V55H592.453V35.62C592.453 33.62 591.873 32 590.713 30.76C589.593 29.52 588.033 28.9 586.033 28.9C583.993 28.9 582.333 29.54 581.053 30.82C579.813 32.06 579.193 33.74 579.193 35.86V55H570.853ZM624.22 56.14C621.38 56.14 618.92 55.66 616.84 54.7C614.8 53.74 613.08 52.46 611.68 50.86C610.32 49.26 609.3 47.46 608.62 45.46C607.94 43.46 607.6 41.42 607.6 39.34V38.2C607.6 36 607.94 33.9 608.62 31.9C609.34 29.86 610.4 28.06 611.8 26.5C613.2 24.9 614.92 23.64 616.96 22.72C619.04 21.76 621.44 21.28 624.16 21.28C627 21.28 629.54 21.84 631.78 22.96C634.02 24.04 635.8 25.56 637.12 27.52C638.48 29.48 639.24 31.76 639.4 34.36H631.3C631.1 32.68 630.38 31.28 629.14 30.16C627.94 29.04 626.28 28.48 624.16 28.48C622.32 28.48 620.78 28.92 619.54 29.8C618.34 30.68 617.44 31.9 616.84 33.46C616.24 34.98 615.94 36.74 615.94 38.74C615.94 40.66 616.22 42.4 616.78 43.96C617.38 45.52 618.28 46.74 619.48 47.62C620.72 48.5 622.3 48.94 624.22 48.94C625.66 48.94 626.9 48.68 627.94 48.16C628.98 47.64 629.8 46.92 630.4 46C631.04 45.08 631.44 44.04 631.6 42.88H639.7C639.54 45.52 638.76 47.84 637.36 49.84C636 51.8 634.18 53.34 631.9 54.46C629.66 55.58 627.1 56.14 624.22 56.14ZM660.961 56.14C658.161 56.14 655.701 55.66 653.581 54.7C651.501 53.74 649.761 52.46 648.361 50.86C647.001 49.22 645.961 47.4 645.241 45.4C644.561 43.4 644.221 41.36 644.221 39.28V38.14C644.221 35.98 644.561 33.9 645.241 31.9C645.961 29.86 647.001 28.06 648.361 26.5C649.761 24.9 651.481 23.64 653.521 22.72C655.561 21.76 657.921 21.28 660.601 21.28C664.121 21.28 667.061 22.06 669.421 23.62C671.821 25.14 673.621 27.16 674.821 29.68C676.021 32.16 676.621 34.84 676.621 37.72V40.72H647.761V35.62H671.401L668.821 38.14C668.821 36.06 668.521 34.28 667.921 32.8C667.321 31.32 666.401 30.18 665.161 29.38C663.961 28.58 662.441 28.18 660.601 28.18C658.761 28.18 657.201 28.6 655.921 29.44C654.641 30.28 653.661 31.5 652.981 33.1C652.341 34.66 652.021 36.54 652.021 38.74C652.021 40.78 652.341 42.6 652.981 44.2C653.621 45.76 654.601 47 655.921 47.92C657.241 48.8 658.921 49.24 660.961 49.24C663.001 49.24 664.661 48.84 665.941 48.04C667.221 47.2 668.041 46.18 668.401 44.98H676.081C675.601 47.22 674.681 49.18 673.321 50.86C671.961 52.54 670.221 53.84 668.101 54.76C666.021 55.68 663.641 56.14 660.961 56.14Z" fill="white"/>
      <path d="M170 87C247.192 80.963 444.462 72.5112 616 87" stroke="url(#paint0_angular_131_44914)" stroke-width="6"/>
      <defs>
      <radialGradient id="paint0_angular_131_44914" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(393 83) rotate(90) scale(4 223)">
      <stop offset="0.0993526" stop-color="#FFC876"/>
      <stop offset="0.526122" stop-color="#ACFF8E"/>
      <stop offset="0.739587" stop-color="#9453FF"/>
      <stop offset="0.913343" stop-color="#FF89C2"/>
      </radialGradient>
      </defs>
    </svg>
  )
};

const HomeContentHeaderMobile = () => {
  return (
    <svg width="291" height="110" viewBox="0 0 291 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M75.0027 21.04V16.12H80.6827C81.8293 16.12 82.7893 15.8933 83.5627 15.44C84.3627 14.9867 84.9627 14.36 85.3627 13.56C85.7893 12.76 86.0027 11.84 86.0027 10.8C86.0027 9.76 85.7893 8.84 85.3627 8.04C84.9627 7.24 84.3627 6.62666 83.5627 6.2C82.7893 5.74667 81.8293 5.52 80.6827 5.52H75.0027V0.599999H80.2027C82.656 0.599999 84.736 0.999999 86.4427 1.8C88.176 2.6 89.496 3.74667 90.4027 5.24C91.3093 6.70667 91.7627 8.45333 91.7627 10.48V11.12C91.7627 13.1467 91.3093 14.9067 90.4027 16.4C89.496 17.8667 88.176 19.0133 86.4427 19.84C84.736 20.64 82.656 21.04 80.2027 21.04H75.0027ZM70.1227 30V0.599999H75.8027V30H70.1227ZM95.367 30V8.28H99.767V17.48H99.647C99.647 14.36 100.314 12 101.647 10.4C102.98 8.8 104.94 8 107.527 8H108.327V12.84H106.807C104.94 12.84 103.487 13.3467 102.447 14.36C101.434 15.3467 100.927 16.7867 100.927 18.68V30H95.367ZM121.53 30.76C119.61 30.76 117.917 30.4533 116.45 29.84C114.984 29.2267 113.744 28.4 112.73 27.36C111.717 26.2933 110.944 25.0933 110.41 23.76C109.904 22.4267 109.65 21.04 109.65 19.6V18.76C109.65 17.2667 109.917 15.8533 110.45 14.52C111.01 13.16 111.797 11.96 112.81 10.92C113.85 9.85333 115.104 9.02667 116.57 8.44C118.037 7.82667 119.69 7.52 121.53 7.52C123.37 7.52 125.024 7.82667 126.49 8.44C127.957 9.02667 129.197 9.85333 130.21 10.92C131.25 11.96 132.037 13.16 132.57 14.52C133.104 15.8533 133.37 17.2667 133.37 18.76V19.6C133.37 21.04 133.104 22.4267 132.57 23.76C132.064 25.0933 131.304 26.2933 130.29 27.36C129.277 28.4 128.037 29.2267 126.57 29.84C125.104 30.4533 123.424 30.76 121.53 30.76ZM121.53 26C122.89 26 124.037 25.7067 124.97 25.12C125.904 24.5067 126.61 23.6933 127.09 22.68C127.57 21.64 127.81 20.4667 127.81 19.16C127.81 17.8267 127.557 16.6533 127.05 15.64C126.57 14.6 125.85 13.7867 124.89 13.2C123.957 12.5867 122.837 12.28 121.53 12.28C120.224 12.28 119.09 12.5867 118.13 13.2C117.197 13.7867 116.477 14.6 115.97 15.64C115.464 16.6533 115.21 17.8267 115.21 19.16C115.21 20.4667 115.45 21.64 115.93 22.68C116.437 23.6933 117.157 24.5067 118.09 25.12C119.024 25.7067 120.17 26 121.53 26ZM147.879 30.76C145.959 30.76 144.266 30.4533 142.799 29.84C141.332 29.2267 140.092 28.4 139.079 27.36C138.066 26.2933 137.292 25.0933 136.759 23.76C136.252 22.4267 135.999 21.04 135.999 19.6V18.76C135.999 17.2667 136.266 15.8533 136.799 14.52C137.359 13.16 138.146 11.96 139.159 10.92C140.199 9.85333 141.452 9.02667 142.919 8.44C144.386 7.82667 146.039 7.52 147.879 7.52C149.719 7.52 151.372 7.82667 152.839 8.44C154.306 9.02667 155.546 9.85333 156.559 10.92C157.599 11.96 158.386 13.16 158.919 14.52C159.452 15.8533 159.719 17.2667 159.719 18.76V19.6C159.719 21.04 159.452 22.4267 158.919 23.76C158.412 25.0933 157.652 26.2933 156.639 27.36C155.626 28.4 154.386 29.2267 152.919 29.84C151.452 30.4533 149.772 30.76 147.879 30.76ZM147.879 26C149.239 26 150.386 25.7067 151.319 25.12C152.252 24.5067 152.959 23.6933 153.439 22.68C153.919 21.64 154.159 20.4667 154.159 19.16C154.159 17.8267 153.906 16.6533 153.399 15.64C152.919 14.6 152.199 13.7867 151.239 13.2C150.306 12.5867 149.186 12.28 147.879 12.28C146.572 12.28 145.439 12.5867 144.479 13.2C143.546 13.7867 142.826 14.6 142.319 15.64C141.812 16.6533 141.559 17.8267 141.559 19.16C141.559 20.4667 141.799 21.64 142.279 22.68C142.786 23.6933 143.506 24.5067 144.439 25.12C145.372 25.7067 146.519 26 147.879 26ZM164.307 30V7.76C164.307 5.28 164.987 3.45333 166.347 2.28C167.734 1.08 169.774 0.479999 172.467 0.479999H175.187V4.76H172.067C171.241 4.76 170.601 4.98667 170.147 5.44C169.721 5.86667 169.507 6.48 169.507 7.28V30H164.307ZM161.587 12.72V8.64H175.547V12.72H161.587ZM196.495 30.76C194.575 30.76 192.881 30.4533 191.415 29.84C189.948 29.2267 188.708 28.4 187.695 27.36C186.681 26.2933 185.908 25.0933 185.375 23.76C184.868 22.4267 184.615 21.04 184.615 19.6V18.76C184.615 17.2667 184.881 15.8533 185.415 14.52C185.975 13.16 186.761 11.96 187.775 10.92C188.815 9.85333 190.068 9.02667 191.535 8.44C193.001 7.82667 194.655 7.52 196.495 7.52C198.335 7.52 199.988 7.82667 201.455 8.44C202.921 9.02667 204.161 9.85333 205.175 10.92C206.215 11.96 207.001 13.16 207.535 14.52C208.068 15.8533 208.335 17.2667 208.335 18.76V19.6C208.335 21.04 208.068 22.4267 207.535 23.76C207.028 25.0933 206.268 26.2933 205.255 27.36C204.241 28.4 203.001 29.2267 201.535 29.84C200.068 30.4533 198.388 30.76 196.495 30.76ZM196.495 26C197.855 26 199.001 25.7067 199.935 25.12C200.868 24.5067 201.575 23.6933 202.055 22.68C202.535 21.64 202.775 20.4667 202.775 19.16C202.775 17.8267 202.521 16.6533 202.015 15.64C201.535 14.6 200.815 13.7867 199.855 13.2C198.921 12.5867 197.801 12.28 196.495 12.28C195.188 12.28 194.055 12.5867 193.095 13.2C192.161 13.7867 191.441 14.6 190.935 15.64C190.428 16.6533 190.175 17.8267 190.175 19.16C190.175 20.4667 190.415 21.64 190.895 22.68C191.401 23.6933 192.121 24.5067 193.055 25.12C193.988 25.7067 195.135 26 196.495 26ZM212.923 30V7.76C212.923 5.28 213.603 3.45333 214.963 2.28C216.35 1.08 218.39 0.479999 221.083 0.479999H223.803V4.76H220.683C219.856 4.76 219.216 4.98667 218.763 5.44C218.336 5.86667 218.123 6.48 218.123 7.28V30H212.923ZM210.203 12.72V8.64H224.163V12.72H210.203ZM47.4953 80V50.6H53.1753V80H47.4953ZM65.3353 80L56.3753 67.28H62.7353L71.9753 80H65.3353ZM51.4953 70.24V65.64H58.9353C59.9753 65.64 60.8686 65.4267 61.6153 65C62.3886 64.5733 62.9886 63.9733 63.4153 63.2C63.842 62.4267 64.0553 61.5467 64.0553 60.56C64.0553 59.5467 63.842 58.6533 63.4153 57.88C62.9886 57.1067 62.3886 56.5067 61.6153 56.08C60.8686 55.6533 59.9753 55.44 58.9353 55.44H51.4953V50.6H58.3353C60.682 50.6 62.7086 50.9467 64.4153 51.64C66.1486 52.3333 67.482 53.3867 68.4153 54.8C69.3486 56.2133 69.8153 57.9867 69.8153 60.12V60.76C69.8153 62.92 69.3353 64.6933 68.3753 66.08C67.442 67.4667 66.122 68.5067 64.4153 69.2C62.7086 69.8933 60.682 70.24 58.3353 70.24H51.4953ZM84.3737 80.76C82.5071 80.76 80.8671 80.44 79.4537 79.8C78.0671 79.16 76.9071 78.3067 75.9737 77.24C75.0671 76.1467 74.3737 74.9333 73.8937 73.6C73.4404 72.2667 73.2137 70.9067 73.2137 69.52V68.76C73.2137 67.32 73.4404 65.9333 73.8937 64.6C74.3737 63.24 75.0671 62.04 75.9737 61C76.9071 59.9333 78.0537 59.0933 79.4137 58.48C80.7737 57.84 82.3471 57.52 84.1337 57.52C86.4804 57.52 88.4404 58.04 90.0137 59.08C91.6137 60.0933 92.8137 61.44 93.6137 63.12C94.4137 64.7733 94.8137 66.56 94.8137 68.48V70.48H75.5737V67.08H91.3337L89.6137 68.76C89.6137 67.3733 89.4137 66.1867 89.0137 65.2C88.6137 64.2133 88.0004 63.4533 87.1737 62.92C86.3737 62.3867 85.3604 62.12 84.1337 62.12C82.9071 62.12 81.8671 62.4 81.0137 62.96C80.1604 63.52 79.5071 64.3333 79.0537 65.4C78.6271 66.44 78.4137 67.6933 78.4137 69.16C78.4137 70.52 78.6271 71.7333 79.0537 72.8C79.4804 73.84 80.1337 74.6667 81.0137 75.28C81.8937 75.8667 83.0137 76.16 84.3737 76.16C85.7337 76.16 86.8404 75.8933 87.6937 75.36C88.5471 74.8 89.0937 74.12 89.3337 73.32H94.4537C94.1337 74.8133 93.5204 76.12 92.6137 77.24C91.7071 78.36 90.5471 79.2267 89.1337 79.84C87.7471 80.4533 86.1604 80.76 84.3737 80.76ZM99.1784 80V57.76C99.1784 55.28 99.8584 53.4533 101.218 52.28C102.605 51.08 104.645 50.48 107.338 50.48H110.058V54.76H106.938C106.112 54.76 105.472 54.9867 105.018 55.44C104.592 55.8667 104.378 56.48 104.378 57.28V80H99.1784ZM96.4584 62.72V58.64H110.418V62.72H96.4584ZM122.696 80.76C120.829 80.76 119.189 80.44 117.776 79.8C116.389 79.16 115.229 78.3067 114.296 77.24C113.389 76.1467 112.696 74.9333 112.216 73.6C111.762 72.2667 111.536 70.9067 111.536 69.52V68.76C111.536 67.32 111.762 65.9333 112.216 64.6C112.696 63.24 113.389 62.04 114.296 61C115.229 59.9333 116.376 59.0933 117.736 58.48C119.096 57.84 120.669 57.52 122.456 57.52C124.802 57.52 126.762 58.04 128.336 59.08C129.936 60.0933 131.136 61.44 131.936 63.12C132.736 64.7733 133.136 66.56 133.136 68.48V70.48H113.896V67.08H129.656L127.936 68.76C127.936 67.3733 127.736 66.1867 127.336 65.2C126.936 64.2133 126.322 63.4533 125.496 62.92C124.696 62.3867 123.682 62.12 122.456 62.12C121.229 62.12 120.189 62.4 119.336 62.96C118.482 63.52 117.829 64.3333 117.376 65.4C116.949 66.44 116.736 67.6933 116.736 69.16C116.736 70.52 116.949 71.7333 117.376 72.8C117.802 73.84 118.456 74.6667 119.336 75.28C120.216 75.8667 121.336 76.16 122.696 76.16C124.056 76.16 125.162 75.8933 126.016 75.36C126.869 74.8 127.416 74.12 127.656 73.32H132.776C132.456 74.8133 131.842 76.12 130.936 77.24C130.029 78.36 128.869 79.2267 127.456 79.84C126.069 80.4533 124.482 80.76 122.696 80.76ZM136.98 80V58.28H141.38V67.48H141.26C141.26 64.36 141.927 62 143.26 60.4C144.594 58.8 146.554 58 149.14 58H149.94V62.84H148.42C146.554 62.84 145.1 63.3467 144.06 64.36C143.047 65.3467 142.54 66.7867 142.54 68.68V80H136.98ZM162.424 80.76C160.557 80.76 158.917 80.44 157.504 79.8C156.117 79.16 154.957 78.3067 154.024 77.24C153.117 76.1467 152.424 74.9333 151.944 73.6C151.49 72.2667 151.264 70.9067 151.264 69.52V68.76C151.264 67.32 151.49 65.9333 151.944 64.6C152.424 63.24 153.117 62.04 154.024 61C154.957 59.9333 156.104 59.0933 157.464 58.48C158.824 57.84 160.397 57.52 162.184 57.52C164.53 57.52 166.49 58.04 168.064 59.08C169.664 60.0933 170.864 61.44 171.664 63.12C172.464 64.7733 172.864 66.56 172.864 68.48V70.48H153.624V67.08H169.384L167.664 68.76C167.664 67.3733 167.464 66.1867 167.064 65.2C166.664 64.2133 166.05 63.4533 165.224 62.92C164.424 62.3867 163.41 62.12 162.184 62.12C160.957 62.12 159.917 62.4 159.064 62.96C158.21 63.52 157.557 64.3333 157.104 65.4C156.677 66.44 156.464 67.6933 156.464 69.16C156.464 70.52 156.677 71.7333 157.104 72.8C157.53 73.84 158.184 74.6667 159.064 75.28C159.944 75.8667 161.064 76.16 162.424 76.16C163.784 76.16 164.89 75.8933 165.744 75.36C166.597 74.8 167.144 74.12 167.384 73.32H172.504C172.184 74.8133 171.57 76.12 170.664 77.24C169.757 78.36 168.597 79.2267 167.184 79.84C165.797 80.4533 164.21 80.76 162.424 80.76ZM176.708 80V58.28H181.108V67.6H180.708C180.708 65.3867 181.002 63.5467 181.588 62.08C182.175 60.5867 183.042 59.4667 184.188 58.72C185.362 57.9733 186.815 57.6 188.548 57.6H188.788C191.375 57.6 193.335 58.44 194.668 60.12C196.002 61.7733 196.668 64.2533 196.668 67.56V80H191.108V67.08C191.108 65.7467 190.722 64.6667 189.948 63.84C189.202 63.0133 188.162 62.6 186.828 62.6C185.468 62.6 184.362 63.0267 183.508 63.88C182.682 64.7067 182.268 65.8267 182.268 67.24V80H176.708ZM211.486 80.76C209.593 80.76 207.953 80.44 206.566 79.8C205.206 79.16 204.059 78.3067 203.126 77.24C202.219 76.1733 201.539 74.9733 201.086 73.64C200.633 72.3067 200.406 70.9467 200.406 69.56V68.8C200.406 67.3333 200.633 65.9333 201.086 64.6C201.566 63.24 202.273 62.04 203.206 61C204.139 59.9333 205.286 59.0933 206.646 58.48C208.033 57.84 209.633 57.52 211.446 57.52C213.339 57.52 215.033 57.8933 216.526 58.64C218.019 59.36 219.206 60.3733 220.086 61.68C220.993 62.9867 221.499 64.5067 221.606 66.24H216.206C216.073 65.12 215.593 64.1867 214.766 63.44C213.966 62.6933 212.859 62.32 211.446 62.32C210.219 62.32 209.193 62.6133 208.366 63.2C207.566 63.7867 206.966 64.6 206.566 65.64C206.166 66.6533 205.966 67.8267 205.966 69.16C205.966 70.44 206.153 71.6 206.526 72.64C206.926 73.68 207.526 74.4933 208.326 75.08C209.153 75.6667 210.206 75.96 211.486 75.96C212.446 75.96 213.273 75.7867 213.966 75.44C214.659 75.0933 215.206 74.6133 215.606 74C216.033 73.3867 216.299 72.6933 216.406 71.92H221.806C221.699 73.68 221.179 75.2267 220.246 76.56C219.339 77.8667 218.126 78.8933 216.606 79.64C215.113 80.3867 213.406 80.76 211.486 80.76ZM235.18 80.76C233.313 80.76 231.673 80.44 230.26 79.8C228.873 79.16 227.713 78.3067 226.78 77.24C225.873 76.1467 225.18 74.9333 224.7 73.6C224.247 72.2667 224.02 70.9067 224.02 69.52V68.76C224.02 67.32 224.247 65.9333 224.7 64.6C225.18 63.24 225.873 62.04 226.78 61C227.713 59.9333 228.86 59.0933 230.22 58.48C231.58 57.84 233.153 57.52 234.94 57.52C237.287 57.52 239.247 58.04 240.82 59.08C242.42 60.0933 243.62 61.44 244.42 63.12C245.22 64.7733 245.62 66.56 245.62 68.48V70.48H226.38V67.08H242.14L240.42 68.76C240.42 67.3733 240.22 66.1867 239.82 65.2C239.42 64.2133 238.807 63.4533 237.98 62.92C237.18 62.3867 236.167 62.12 234.94 62.12C233.713 62.12 232.673 62.4 231.82 62.96C230.967 63.52 230.313 64.3333 229.86 65.4C229.433 66.44 229.22 67.6933 229.22 69.16C229.22 70.52 229.433 71.7333 229.86 72.8C230.287 73.84 230.94 74.6667 231.82 75.28C232.7 75.8667 233.82 76.16 235.18 76.16C236.54 76.16 237.647 75.8933 238.5 75.36C239.353 74.8 239.9 74.12 240.14 73.32H245.26C244.94 74.8133 244.327 76.12 243.42 77.24C242.513 78.36 241.353 79.2267 239.94 79.84C238.553 80.4533 236.967 80.76 235.18 80.76Z" fill="white"/>
      <path d="M0.5 107C50.6923 100.963 178.962 92.5112 290.5 107" stroke="url(#paint0_angular_131_44914)" stroke-width="6"/>
      <defs>
      <radialGradient id="paint0_angular_131_44914" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(145.5 103) rotate(90) scale(4 145)">
      <stop offset="0.0993526" stop-color="#FFC876"/>
      <stop offset="0.526122" stop-color="#ACFF8E"/>
      <stop offset="0.739587" stop-color="#9453FF"/>
      <stop offset="0.913343" stop-color="#FF89C2"/>
      </radialGradient>
      </defs>
    </svg>
  )
};

const ScrollSVG = () => {
  return (
    <svg
      width="46"
      height="98"
      viewBox="0 0 46 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="23.5"
        y1="2.18557e-08"
        x2="23.5"
        y2="64"
        stroke="url(#paint0_linear_461_8283)"
      />
      <path
        d="M3.88574 93.209C3.17441 93.209 2.57307 93.0953 2.08174 92.868C1.59774 92.6407 1.2274 92.329 0.970738 91.933C0.714072 91.5297 0.585738 91.075 0.585738 90.569H2.11474C2.11474 90.7817 2.1734 90.9907 2.29074 91.196C2.40807 91.394 2.59507 91.5553 2.85174 91.68C3.11574 91.8047 3.46041 91.867 3.88574 91.867C4.26707 91.867 4.58607 91.812 4.84274 91.702C5.09941 91.592 5.29007 91.449 5.41474 91.273C5.53941 91.0897 5.60174 90.8843 5.60174 90.657C5.60174 90.371 5.48074 90.1437 5.23874 89.975C4.99674 89.799 4.62274 89.689 4.11674 89.645L3.41274 89.59C2.64274 89.524 2.02674 89.2857 1.56474 88.875C1.11007 88.457 0.882738 87.907 0.882738 87.225C0.882738 86.7117 1.00374 86.2717 1.24574 85.905C1.48774 85.531 1.82507 85.245 2.25774 85.047C2.69774 84.8417 3.21107 84.739 3.79774 84.739C4.40641 84.739 4.93074 84.8453 5.37074 85.058C5.81074 85.2707 6.15174 85.5713 6.39374 85.96C6.63574 86.3413 6.75674 86.7923 6.75674 87.313H5.22774C5.22774 87.093 5.17274 86.8913 5.06274 86.708C4.96007 86.5173 4.80241 86.367 4.58974 86.257C4.38441 86.1397 4.12041 86.081 3.79774 86.081C3.48974 86.081 3.23307 86.1323 3.02774 86.235C2.82241 86.3377 2.66841 86.477 2.56574 86.653C2.46307 86.829 2.41174 87.0197 2.41174 87.225C2.41174 87.4743 2.50341 87.6943 2.68674 87.885C2.87007 88.0683 3.15974 88.1747 3.55574 88.204L4.25974 88.27C4.83174 88.314 5.33407 88.435 5.76674 88.633C6.19941 88.831 6.53307 89.0987 6.76774 89.436C7.00974 89.7733 7.13074 90.1803 7.13074 90.657C7.13074 91.163 6.99874 91.6103 6.73474 91.999C6.47074 92.3803 6.09307 92.6773 5.60174 92.89C5.11774 93.1027 4.54574 93.209 3.88574 93.209ZM12.1778 93.209C11.4518 93.209 10.8285 93.0807 10.3078 92.824C9.78718 92.5673 9.36185 92.2337 9.03185 91.823C8.70918 91.4123 8.47085 90.965 8.31685 90.481C8.16285 89.997 8.08585 89.5313 8.08585 89.084V88.842C8.08585 88.3433 8.16285 87.852 8.31685 87.368C8.47818 86.884 8.72385 86.444 9.05385 86.048C9.38385 85.652 9.80185 85.3367 10.3078 85.102C10.8212 84.86 11.4262 84.739 12.1228 84.739C12.8488 84.739 13.4795 84.871 14.0148 85.135C14.5575 85.3917 14.9902 85.7583 15.3128 86.235C15.6355 86.7043 15.8298 87.2543 15.8958 87.885H14.3228C14.2642 87.5183 14.1322 87.2103 13.9268 86.961C13.7288 86.7043 13.4758 86.5137 13.1678 86.389C12.8598 86.257 12.5115 86.191 12.1228 86.191C11.7268 86.191 11.3748 86.2607 11.0668 86.4C10.7588 86.532 10.5022 86.7227 10.2968 86.972C10.0915 87.2213 9.93385 87.5147 9.82385 87.852C9.72118 88.1893 9.66985 88.5633 9.66985 88.974C9.66985 89.37 9.72118 89.7367 9.82385 90.074C9.93385 90.4113 10.0952 90.7083 10.3078 90.965C10.5205 91.2143 10.7808 91.4087 11.0888 91.548C11.4042 91.6873 11.7672 91.757 12.1778 91.757C12.7792 91.757 13.2852 91.6103 13.6958 91.317C14.1138 91.0163 14.3668 90.5983 14.4548 90.063H16.0278C15.9545 90.635 15.7602 91.1593 15.4448 91.636C15.1295 92.1127 14.6968 92.494 14.1468 92.78C13.5968 93.066 12.9405 93.209 12.1778 93.209ZM17.346 93V84.915H18.908V93H17.346ZM22.252 93L19.788 89.502H21.537L24.078 93H22.252ZM18.446 90.316V89.051H20.492C20.778 89.051 21.0236 88.9923 21.229 88.875C21.4416 88.7577 21.6066 88.5927 21.724 88.38C21.8413 88.1673 21.9 87.9253 21.9 87.654C21.9 87.3753 21.8413 87.1297 21.724 86.917C21.6066 86.7043 21.4416 86.5393 21.229 86.422C21.0236 86.3047 20.778 86.246 20.492 86.246H18.446V84.915H20.327C20.9723 84.915 21.5296 85.0103 21.999 85.201C22.4756 85.3917 22.8423 85.6813 23.099 86.07C23.3556 86.4587 23.484 86.9463 23.484 87.533V87.709C23.484 88.303 23.352 88.7907 23.088 89.172C22.8313 89.5533 22.4683 89.8393 21.999 90.03C21.5296 90.2207 20.9723 90.316 20.327 90.316H18.446ZM28.9285 93.209C28.2025 93.209 27.5719 93.0807 27.0365 92.824C26.5085 92.5673 26.0685 92.2337 25.7165 91.823C25.3719 91.405 25.1115 90.9577 24.9355 90.481C24.7669 89.997 24.6825 89.5313 24.6825 89.084V88.842C24.6825 88.3507 24.7705 87.863 24.9465 87.379C25.1225 86.8877 25.3865 86.444 25.7385 86.048C26.0979 85.652 26.5415 85.3367 27.0695 85.102C27.5975 84.86 28.2172 84.739 28.9285 84.739C29.6325 84.739 30.2485 84.86 30.7765 85.102C31.3045 85.3367 31.7445 85.652 32.0965 86.048C32.4559 86.444 32.7235 86.8877 32.8995 87.379C33.0755 87.863 33.1635 88.3507 33.1635 88.842V89.084C33.1635 89.5313 33.0755 89.997 32.8995 90.481C32.7309 90.9577 32.4705 91.405 32.1185 91.823C31.7739 92.2337 31.3339 92.5673 30.7985 92.824C30.2705 93.0807 29.6472 93.209 28.9285 93.209ZM28.9285 91.757C29.3392 91.757 29.7059 91.6837 30.0285 91.537C30.3585 91.3903 30.6372 91.1887 30.8645 90.932C31.0992 90.668 31.2752 90.371 31.3925 90.041C31.5172 89.7037 31.5795 89.348 31.5795 88.974C31.5795 88.5707 31.5172 88.2003 31.3925 87.863C31.2752 87.5257 31.0992 87.2323 30.8645 86.983C30.6372 86.7337 30.3585 86.5393 30.0285 86.4C29.6985 86.2607 29.3319 86.191 28.9285 86.191C28.5179 86.191 28.1475 86.2607 27.8175 86.4C27.4875 86.5393 27.2052 86.7337 26.9705 86.983C26.7432 87.2323 26.5672 87.5257 26.4425 87.863C26.3252 88.2003 26.2665 88.5707 26.2665 88.974C26.2665 89.348 26.3252 89.7037 26.4425 90.041C26.5672 90.371 26.7432 90.668 26.9705 90.932C27.2052 91.1887 27.4875 91.3903 27.8175 91.537C28.1475 91.6837 28.5179 91.757 28.9285 91.757ZM34.6731 93V84.97H36.2351V93H34.6731ZM36.0151 93V91.625H39.4801V93H36.0151ZM40.7532 93V84.97H42.3152V93H40.7532ZM42.0952 93V91.625H45.5602V93H42.0952Z"
        fill="#CAC6DD"
      />
      <defs>
        <linearGradient
          id="paint0_linear_461_8283"
          x1="23"
          y1="67"
          x2="23"
          y2="1.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CAC6DD" />
          <stop offset="1" stopColor="#CAC6DD" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const CardBorder = () => {
  return (
    <svg
      width="276"
      height="336"
      viewBox="0 0 276 336"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_530_1406)">
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H186.584C192.979 0 199.11 2.55241 203.615 7.09081L236.288 40L269.032 72.9812C273.495 77.477 276 83.5552 276 89.8904V312C276 325.255 265.255 336 252 336H24C10.7452 336 0 325.255 0 312V24Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          d="M0.5 24C0.5 11.0213 11.0213 0.5 24 0.5H186.584C192.846 0.5 198.849 2.99923 203.261 7.44309L235.933 40.3523L268.677 73.3335C273.047 77.7356 275.5 83.6872 275.5 89.8904V312C275.5 324.979 264.979 335.5 252 335.5H24C11.0213 335.5 0.5 324.979 0.5 312V24Z"
          stroke="white"
          strokeOpacity="0.15"
        />
        <path
          d="M0.5 24C0.5 11.0213 11.0213 0.5 24 0.5H186.584C192.846 0.5 198.849 2.99923 203.261 7.44309L235.933 40.3523L268.677 73.3335C273.047 77.7356 275.5 83.6872 275.5 89.8904V312C275.5 324.979 264.979 335.5 252 335.5H24C11.0213 335.5 0.5 324.979 0.5 312V24Z"
          stroke="url(#paint0_linear_530_1406)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_530_1406"
          x="-64"
          y="-64"
          width="404"
          height="464"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_530_1406"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_530_1406"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_530_1406"
          x1="138"
          y1="0"
          x2="138"
          y2="336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const CardBorderHover = () => {
  return (
    <svg
      width="276"
      height="336"
      viewBox="0 0 276 336"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2746_17081)">
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H186.584C192.979 0 199.11 2.55241 203.615 7.09081L236.288 40L269.032 72.9812C273.495 77.477 276 83.5552 276 89.8904V312C276 325.255 265.255 336 252 336H24C10.7452 336 0 325.255 0 312V24Z"
          fill="#0E0C15"
        />
        <path
          d="M0.5 24C0.5 11.0213 11.0213 0.5 24 0.5H186.584C192.846 0.5 198.849 2.99923 203.261 7.44309L235.933 40.3523L268.677 73.3335C273.047 77.7356 275.5 83.6872 275.5 89.8904V312C275.5 324.979 264.979 335.5 252 335.5H24C11.0213 335.5 0.5 324.979 0.5 312V24Z"
          stroke="white"
          strokeOpacity="0.15"
        />
        <path
          d="M0.5 24C0.5 11.0213 11.0213 0.5 24 0.5H186.584C192.846 0.5 198.849 2.99923 203.261 7.44309L235.933 40.3523L268.677 73.3335C273.047 77.7356 275.5 83.6872 275.5 89.8904V312C275.5 324.979 264.979 335.5 252 335.5H24C11.0213 335.5 0.5 324.979 0.5 312V24Z"
          stroke="url(#paint0_linear_2746_17081)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2746_17081"
          x="-64"
          y="-64"
          width="404"
          height="464"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2746_17081"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2746_17081"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2746_17081"
          x1="138"
          y1="0"
          x2="138"
          y2="336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#33CEFF" />
          <stop offset="0.562842" stop-color="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const InfiniteLiquidity = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5553 5.86502C13.3509 3.99703 16.6377 3 20 3C24.5087 3 28.8327 4.79107 32.0208 7.97918C35.2089 11.1673 37 15.4913 37 20C37 23.3623 36.003 26.6491 34.135 29.4447C32.267 32.2403 29.612 34.4193 26.5056 35.7059C23.3993 36.9926 19.9811 37.3293 16.6835 36.6733C13.3858 36.0174 10.3567 34.3983 7.97919 32.0208C5.6017 29.6433 3.98261 26.6142 3.32666 23.3165C2.67071 20.0189 3.00737 16.6007 4.29406 13.4944C5.58074 10.388 7.75968 7.733 10.5553 5.86502ZM20.3246 21.7618C22.0864 23.2455 25.44 25.7955 27.7273 25.7955C29.2643 25.7955 30.7384 25.1849 31.8253 24.098C32.9121 23.0111 33.5227 21.537 33.5227 20C33.5227 18.4629 32.9121 16.9889 31.8253 15.902C30.7384 14.8151 29.2643 14.2045 27.7273 14.2045C25.44 14.2045 22.0864 16.6927 20.3246 18.2382C20.2565 18.299 20.1685 18.3326 20.0773 18.3326C19.986 18.3326 19.898 18.299 19.83 18.2382C18.0682 16.7545 14.7146 14.2045 12.4273 14.2045C10.8902 14.2045 9.41613 14.8151 8.32927 15.902C7.24242 16.9889 6.63183 18.4629 6.63183 20C6.63183 21.537 7.24242 23.0111 8.32927 24.098C9.41613 25.1849 10.8902 25.7955 12.4273 25.7955C14.7146 25.7955 18.0682 23.3073 19.83 21.7618C19.898 21.701 19.986 21.6674 20.0773 21.6674C20.1685 21.6674 20.2565 21.701 20.3246 21.7618ZM8.79533 19.9994C8.80756 20.9312 9.18843 21.8203 9.8546 22.472C10.5208 23.1237 11.418 23.4849 12.3499 23.4767C13.5244 23.4767 15.9508 21.9312 17.8826 20.293C17.9257 20.2571 17.9605 20.2122 17.9845 20.1615C18.0085 20.1108 18.0212 20.0555 18.0217 19.9994C18.0218 19.9416 18.0077 19.8846 17.9808 19.8334C17.9539 19.7823 17.9148 19.7384 17.8671 19.7057C15.9508 18.1603 13.5244 16.5221 12.3499 16.5221C11.418 16.5139 10.5208 16.8751 9.8546 17.5268C9.18843 18.1785 8.80756 19.0675 8.79533 19.9994ZM27.7276 16.522C26.5531 16.522 24.1267 18.0674 22.1949 19.7056C22.1518 19.7415 22.117 19.7864 22.093 19.8371C22.069 19.8878 22.0563 19.9431 22.0558 19.9992C22.0558 20.0571 22.0698 20.114 22.0967 20.1652C22.1237 20.2164 22.1627 20.2602 22.2104 20.2929C24.1267 21.8383 26.5531 23.4765 27.7276 23.4765C28.6499 23.4765 29.5343 23.1102 30.1864 22.458C30.8386 21.8059 31.2049 20.9215 31.2049 19.9992C31.2049 19.077 30.8386 18.1926 30.1864 17.5404C29.5343 16.8883 28.6499 16.522 27.7276 16.522Z"
        fill="url(#paint0_angular_530_1525)"
      />
      <defs>
        <radialGradient
          id="paint0_angular_530_1525"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 20) rotate(90) scale(17)"
        >
          <stop offset="0.046875" stopColor="#FFC876" />
          <stop offset="0.395833" stopColor="#79FFF7" />
          <stop offset="0.718753" stopColor="#0182FA" />
          <stop offset="1" stopColor="#FF98E2" />
        </radialGradient>
      </defs>
    </svg>
  );
};

const ArrowIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_530_1427)">
        <path
          d="M11.3797 7.94502C11.3832 8.11185 11.3527 8.27765 11.2903 8.4324C11.2279 8.58715 11.1348 8.72764 11.0165 8.8454C10.8983 8.96316 10.7575 9.05573 10.6025 9.11754C10.4475 9.17935 10.2816 9.20911 10.1147 9.20502C9.94987 9.20789 9.78615 9.17703 9.63364 9.11433C9.48112 9.05164 9.34304 8.95843 9.22785 8.84044C9.11267 8.72244 9.02281 8.58215 8.96381 8.42817C8.90481 8.27419 8.8779 8.10978 8.88474 7.94502L8.88474 5.27002C8.88482 5.24563 8.87777 5.22174 8.86444 5.20131C8.85111 5.18087 8.8321 5.16478 8.80974 5.15502C8.78703 5.14471 8.76157 5.14205 8.73722 5.14746C8.71287 5.15288 8.69094 5.16606 8.67474 5.18502L2.63974 11.115C2.35974 11.395 1.69974 11.59 1.04474 10.935C0.812423 10.7436 0.664854 10.4683 0.633973 10.1689C0.603093 9.86943 0.691384 9.56986 0.879736 9.33502L6.81974 3.33502C6.83564 3.31672 6.8461 3.29434 6.84995 3.2704C6.8538 3.24647 6.85087 3.22193 6.84151 3.19957C6.83215 3.17721 6.81672 3.15791 6.79697 3.14385C6.77722 3.1298 6.75393 3.12154 6.72974 3.12002L3.95974 3.12002C3.62822 3.12002 3.31027 2.98833 3.07585 2.75391C2.84143 2.51949 2.70974 2.20154 2.70974 1.87002C2.70974 1.5385 2.84143 1.22056 3.07585 0.986141C3.31027 0.75172 3.62822 0.620025 3.95974 0.620025L10.8797 0.620025C11.0123 0.620025 11.1395 0.672704 11.2333 0.766472C11.3271 0.86024 11.3797 0.987416 11.3797 1.12002L11.3797 7.94502Z"
          fill="#CAC6DD"
        />
      </g>
      <defs>
        <clipPath id="clip0_530_1427">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="matrix(1 0 0 -1 0 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const ArrowRightIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9725 5L15.8337 10M15.8337 10L10.9725 15M15.8337 10L4.16699 10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const RectangleGradient = () => {
  return (
    <svg
      width="996"
      height="328"
      viewBox="0 0 996 328"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_461_8312)">
        <rect width="996" height="328" rx="24" fill="black" fillOpacity="0.1" />
        <rect
          x="0.5"
          y="0.5"
          width="995"
          height="327"
          rx="23.5"
          stroke="white"
          strokeOpacity="0.15"
        />
        <rect
          x="0.5"
          y="0.5"
          width="995"
          height="327"
          rx="23.5"
          stroke="url(#paint0_linear_461_8312)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_461_8312"
          x="-64"
          y="-64"
          width="1124"
          height="456"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_461_8312"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_461_8312"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_461_8312"
          x1="498"
          y1="0"
          x2="498"
          y2="328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const RectangleGradientMobile = () => {
  return (
    <svg
      width="343"
      height="596"
      viewBox="0 0 343 596"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2760_17062)">
        <rect
          width="343"
          height="596"
          rx="24"
          fill="black"
          fillOpacity="0.1"
        />
        <rect
          x="0.5"
          y="0.5"
          width="342"
          height="595"
          rx="23.5"
          stroke="white"
          strokeOpacity="0.15"
        />
        <rect
          x="0.5"
          y="0.5"
          width="342"
          height="595"
          rx="23.5"
          stroke="url(#paint0_linear_2760_17062)"
          strokeOpacity="0.85"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2760_17062"
          x="-64"
          y="-64"
          width="471"
          height="724"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="32" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2760_17062"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2760_17062"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2760_17062"
          x1="171.5"
          y1="0"
          x2="171.5"
          y2="596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#33CEFF" />
          <stop offset="0.562842" stopColor="#D633FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const DiscoverBanner = () => {
  return (
    <svg
      width="362"
      height="280"
      viewBox="0 0 362 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.6"
          d="M157.786 268.605L31.557 195.917C25.88 192.689 26.6592 186.901 33.1154 183.116L146.432 117.664C152.999 113.88 162.906 113.546 168.583 116.774L294.812 189.461C300.489 192.689 299.71 198.478 293.253 202.262L179.826 267.714C173.37 271.387 163.351 271.833 157.786 268.605Z"
          fill="url(#paint0_radial_461_8313)"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M63.7266 254.582L93.6697 237.329L124.281 234.1L148.658 248.126L170.142 247.347L188.842 236.549"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M123.39 240.446L146.988 254.137L172.256 253.135L204.648 234.435"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M190.177 237.108C189.509 237.553 188.396 237.553 187.728 237.108C187.061 236.663 187.061 236.106 187.728 235.661C188.396 235.215 189.509 235.215 190.177 235.661C190.845 236.106 190.845 236.774 190.177 237.108Z"
          fill="#2A49F9"
        />
        <path
          d="M205.984 234.992C205.316 235.437 204.203 235.437 203.535 234.992C202.867 234.547 202.867 233.99 203.535 233.545C204.203 233.1 205.316 233.1 205.984 233.545C206.652 233.99 206.652 234.658 205.984 234.992Z"
          fill="#2A49F9"
        />
        <path
          d="M173.592 253.693C172.924 254.138 171.811 254.138 171.143 253.693C170.476 253.248 170.476 252.691 171.143 252.246C171.811 251.801 172.924 251.801 173.592 252.246C174.26 252.691 174.26 253.359 173.592 253.693Z"
          fill="#2A49F9"
        />
        <path
          d="M170.141 248.35C171.125 248.35 171.922 247.901 171.922 247.348C171.922 246.795 171.125 246.346 170.141 246.346C169.158 246.346 168.36 246.795 168.36 247.348C168.36 247.901 169.158 248.35 170.141 248.35Z"
          fill="#2A49F9"
        />
        <path
          d="M125.504 234.992C124.837 235.437 123.723 235.437 123.056 234.992C122.388 234.547 122.388 233.99 123.056 233.545C123.723 233.1 124.837 233.1 125.504 233.545C126.172 233.879 126.172 234.547 125.504 234.992Z"
          fill="#2A49F9"
        />
        <path
          d="M124.615 241.225C123.947 241.671 122.834 241.671 122.166 241.225C121.498 240.78 121.498 240.224 122.166 239.778C122.834 239.333 123.947 239.333 124.615 239.778C125.283 240.224 125.283 240.78 124.615 241.225Z"
          fill="#2A49F9"
        />
        <path
          d="M64.9507 255.251C64.2829 255.696 63.1698 255.696 62.5019 255.251C61.834 254.806 61.834 254.249 62.5019 253.804C63.1698 253.359 64.2829 253.359 64.9507 253.804C65.6186 254.249 65.6186 254.917 64.9507 255.251Z"
          fill="#2A49F9"
        />
        <path
          d="M254.628 278.851L224.685 261.597L193.963 258.48L169.697 272.506L148.102 271.615L129.513 260.818"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M194.853 264.824L171.255 278.404L145.987 277.402L113.706 258.702"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M128.065 261.375C128.733 261.82 129.846 261.82 130.514 261.375C131.182 260.929 131.182 260.373 130.514 259.928C129.846 259.482 128.733 259.482 128.065 259.928C127.397 260.373 127.397 261.041 128.065 261.375Z"
          fill="#2A49F9"
        />
        <path
          d="M112.259 259.37C112.927 259.815 114.04 259.815 114.708 259.37C115.375 258.924 115.375 258.368 114.708 257.923C114.04 257.477 112.927 257.477 112.259 257.923C111.591 258.257 111.591 258.924 112.259 259.37Z"
          fill="#2A49F9"
        />
        <path
          d="M144.651 278.072C145.319 278.517 146.432 278.517 147.1 278.072C147.768 277.626 147.768 277.07 147.1 276.624C146.432 276.179 145.319 276.179 144.651 276.624C143.983 277.07 143.983 277.626 144.651 278.072Z"
          fill="#2A49F9"
        />
        <path
          d="M146.877 272.283C147.545 272.728 148.658 272.728 149.326 272.283C149.994 271.838 149.994 271.281 149.326 270.836C148.658 270.391 147.545 270.391 146.877 270.836C146.209 271.281 146.209 271.949 146.877 272.283Z"
          fill="#2A49F9"
        />
        <path
          d="M192.849 259.259C193.517 259.704 194.63 259.704 195.298 259.259C195.966 258.814 195.966 258.257 195.298 257.812C194.63 257.367 193.517 257.367 192.849 257.812C192.07 258.257 192.07 258.814 192.849 259.259Z"
          fill="#2A49F9"
        />
        <path
          d="M193.628 265.491C194.296 265.937 195.409 265.937 196.077 265.491C196.745 265.046 196.745 264.49 196.077 264.044C195.409 263.599 194.296 263.599 193.628 264.044C192.96 264.49 192.96 265.046 193.628 265.491Z"
          fill="#2A49F9"
        />
        <path
          d="M253.403 279.629C254.071 280.074 255.184 280.074 255.852 279.629C256.52 279.183 256.52 278.627 255.852 278.182C255.184 277.736 254.071 277.736 253.403 278.182C252.735 278.627 252.735 279.183 253.403 279.629Z"
          fill="#2A49F9"
        />
        <path
          d="M146.989 236.775L117.046 219.522L86.3232 216.294L62.057 230.319L40.5736 229.429L21.873 218.743"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M87.3248 222.638L63.7265 236.329L38.4584 235.328L6.06641 216.627"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M20.5375 219.298C21.2054 219.743 22.3185 219.743 22.9864 219.298C23.6543 218.853 23.6543 218.296 22.9864 217.851C22.3185 217.406 21.2054 217.406 20.5375 217.851C19.7583 218.296 19.7583 218.964 20.5375 219.298Z"
          fill="#2A49F9"
        />
        <path
          d="M4.61907 217.183C5.28695 217.628 6.40007 217.628 7.06795 217.183C7.73583 216.738 7.73583 216.181 7.06795 215.736C6.40007 215.291 5.28695 215.291 4.61907 215.736C3.95119 216.181 3.95119 216.849 4.61907 217.183Z"
          fill="#2A49F9"
        />
        <path
          d="M37.123 235.884C37.7909 236.329 38.904 236.329 39.5719 235.884C40.2398 235.439 40.2398 234.882 39.5719 234.437C38.904 233.992 37.7909 233.992 37.123 234.437C36.4551 234.882 36.4551 235.55 37.123 235.884Z"
          fill="#2A49F9"
        />
        <path
          d="M39.3495 230.207C40.0174 230.653 41.1306 230.653 41.7984 230.207C42.4663 229.762 42.4663 229.205 41.7984 228.76C41.1306 228.315 40.0174 228.315 39.3495 228.76C38.6817 229.205 38.6817 229.762 39.3495 230.207Z"
          fill="#2A49F9"
        />
        <path
          d="M85.2099 217.072C85.8778 217.518 86.9909 217.518 87.6588 217.072C88.3267 216.627 88.3267 216.071 87.6588 215.625C86.9909 215.18 85.8778 215.18 85.2099 215.625C84.542 216.071 84.542 216.738 85.2099 217.072Z"
          fill="#2A49F9"
        />
        <path
          d="M86.1005 223.417C86.7684 223.863 87.8815 223.863 88.5494 223.417C89.2173 222.972 89.2173 222.416 88.5494 221.97C87.8815 221.525 86.7684 221.525 86.1005 221.97C85.4326 222.304 85.4326 222.972 86.1005 223.417Z"
          fill="#2A49F9"
        />
        <path
          d="M145.764 237.442C146.431 237.887 147.545 237.887 148.212 237.442C148.88 236.997 148.88 236.44 148.212 235.995C147.545 235.55 146.431 235.55 145.764 235.995C145.096 236.44 145.096 237.108 145.764 237.442Z"
          fill="#2A49F9"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M359.374 178.89L329.431 161.637L298.709 158.52L274.443 172.545L252.959 171.655L234.259 160.857"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M299.711 164.865L276.112 178.445L250.844 177.443L218.452 158.742"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M234.147 161.746C235.131 161.746 235.928 161.298 235.928 160.745C235.928 160.191 235.131 159.743 234.147 159.743C233.164 159.743 232.366 160.191 232.366 160.745C232.366 161.298 233.164 161.746 234.147 161.746Z"
          fill="#2A49F9"
        />
        <path
          d="M217.005 159.409C217.673 159.854 218.786 159.854 219.454 159.409C220.122 158.964 220.122 158.407 219.454 157.962C218.786 157.517 217.673 157.517 217.005 157.962C216.337 158.296 216.337 158.964 217.005 159.409Z"
          fill="#2A49F9"
        />
        <path
          d="M249.509 178.111C250.177 178.556 251.29 178.556 251.958 178.111C252.625 177.666 252.625 177.109 251.958 176.664C251.29 176.219 250.177 176.219 249.509 176.664C248.841 177.109 248.841 177.666 249.509 178.111Z"
          fill="#2A49F9"
        />
        <path
          d="M251.734 172.322C252.402 172.767 253.515 172.767 254.183 172.322C254.851 171.876 254.851 171.32 254.183 170.874C253.515 170.429 252.402 170.429 251.734 170.874C251.066 171.32 251.066 171.988 251.734 172.322Z"
          fill="#2A49F9"
        />
        <path
          d="M297.596 159.298C298.264 159.744 299.377 159.744 300.045 159.298C300.712 158.853 300.712 158.297 300.045 157.851C299.377 157.406 298.264 157.406 297.596 157.851C296.928 158.297 296.928 158.853 297.596 159.298Z"
          fill="#2A49F9"
        />
        <path
          d="M298.486 165.531C299.154 165.976 300.267 165.976 300.935 165.531C301.603 165.085 301.603 164.529 300.935 164.084C300.267 163.638 299.154 163.638 298.486 164.084C297.818 164.529 297.818 165.197 298.486 165.531Z"
          fill="#2A49F9"
        />
        <path
          d="M358.149 179.668C358.817 180.113 359.93 180.113 360.598 179.668C361.266 179.223 361.266 178.666 360.598 178.221C359.93 177.776 358.817 177.776 358.149 178.221C357.481 178.666 357.481 179.223 358.149 179.668Z"
          fill="#2A49F9"
        />
        <path
          d="M212.997 205.16L242.94 187.795L273.663 184.679L297.929 198.704"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M272.66 191.023L296.258 204.603"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M274.775 185.457C274.107 185.902 272.994 185.902 272.326 185.457C271.658 185.012 271.658 184.455 272.326 184.01C272.994 183.565 274.107 183.565 274.775 184.01C275.443 184.455 275.443 185.123 274.775 185.457Z"
          fill="#2A49F9"
        />
        <path
          d="M272.66 192.025C273.644 192.025 274.441 191.576 274.441 191.023C274.441 190.47 273.644 190.021 272.66 190.021C271.676 190.021 270.879 190.47 270.879 191.023C270.879 191.576 271.676 192.025 272.66 192.025Z"
          fill="#2A49F9"
        />
        <path
          d="M214.221 205.828C213.553 206.273 212.44 206.273 211.772 205.828C211.105 205.382 211.105 204.826 211.772 204.381C212.44 203.935 213.553 203.935 214.221 204.381C214.889 204.826 214.889 205.382 214.221 205.828Z"
          fill="#2A49F9"
        />
        <path
          d="M216.447 222.3L246.39 205.047L277.113 201.93L301.379 215.956"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M276.224 208.275L299.822 221.855"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M278.226 202.709C277.558 203.154 276.445 203.154 275.777 202.709C275.109 202.264 275.109 201.707 275.777 201.262C276.445 200.817 277.558 200.817 278.226 201.262C278.894 201.707 278.894 202.264 278.226 202.709Z"
          fill="#2A49F9"
        />
        <path
          d="M277.448 208.941C276.78 209.387 275.667 209.387 274.999 208.941C274.331 208.496 274.331 207.94 274.999 207.494C275.667 207.049 276.78 207.049 277.448 207.494C278.116 207.94 278.116 208.496 277.448 208.941Z"
          fill="#2A49F9"
        />
        <path
          d="M217.672 223.079C217.005 223.524 215.891 223.524 215.224 223.079C214.556 222.634 214.556 222.077 215.224 221.632C215.891 221.186 217.005 221.186 217.672 221.632C218.34 221.966 218.34 222.634 217.672 223.079Z"
          fill="#2A49F9"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M59.4961 123.236L89.4392 140.49L120.162 143.606L144.428 129.581L165.911 130.471L184.612 141.269"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M119.16 137.262L142.758 123.682L168.026 124.683L200.419 143.384"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M185.948 140.711C185.28 140.266 184.167 140.266 183.499 140.711C182.831 141.157 182.831 141.713 183.499 142.159C184.167 142.604 185.28 142.604 185.948 142.159C186.727 141.713 186.727 141.045 185.948 140.711Z"
          fill="#2A49F9"
        />
        <path
          d="M201.866 142.827C201.198 142.382 200.085 142.382 199.417 142.827C198.749 143.272 198.749 143.829 199.417 144.274C200.085 144.719 201.198 144.719 201.866 144.274C202.534 143.829 202.534 143.161 201.866 142.827Z"
          fill="#2A49F9"
        />
        <path
          d="M169.363 124.016C168.695 123.57 167.582 123.57 166.914 124.016C166.246 124.461 166.246 125.017 166.914 125.463C167.582 125.908 168.695 125.908 169.363 125.463C170.031 125.129 170.031 124.461 169.363 124.016Z"
          fill="#2A49F9"
        />
        <path
          d="M167.136 129.803C166.468 129.358 165.355 129.358 164.687 129.803C164.02 130.248 164.02 130.805 164.687 131.25C165.355 131.695 166.468 131.695 167.136 131.25C167.804 130.805 167.804 130.137 167.136 129.803Z"
          fill="#2A49F9"
        />
        <path
          d="M121.275 142.827C120.607 142.382 119.494 142.382 118.826 142.827C118.158 143.272 118.158 143.829 118.826 144.274C119.494 144.719 120.607 144.719 121.275 144.274C121.943 143.829 121.943 143.272 121.275 142.827Z"
          fill="#2A49F9"
        />
        <path
          d="M120.384 136.594C119.716 136.149 118.603 136.149 117.935 136.594C117.268 137.039 117.268 137.596 117.935 138.041C118.603 138.486 119.716 138.486 120.384 138.041C121.052 137.596 121.052 137.039 120.384 136.594Z"
          fill="#2A49F9"
        />
        <path
          d="M60.7213 122.456C60.0534 122.011 58.9403 122.011 58.2724 122.456C57.6045 122.902 57.6045 123.458 58.2724 123.904C58.9403 124.349 60.0534 124.349 60.7213 123.904C61.3892 123.57 61.3892 122.902 60.7213 122.456Z"
          fill="#2A49F9"
        />
        <path
          d="M250.398 98.8593L220.455 116.224L189.732 119.341L165.466 105.315L143.871 106.206L125.282 117.003"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M190.622 112.995L167.023 99.4149L141.755 100.417L109.475 119.117"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M123.835 116.335C124.503 115.89 125.616 115.89 126.284 116.335C126.952 116.78 126.952 117.337 126.284 117.782C125.616 118.227 124.503 118.227 123.835 117.782C123.167 117.448 123.167 116.78 123.835 116.335Z"
          fill="#2A49F9"
        />
        <path
          d="M108.028 118.45C108.696 118.004 109.809 118.004 110.477 118.45C111.145 118.895 111.145 119.452 110.477 119.897C109.809 120.342 108.696 120.342 108.028 119.897C107.36 119.452 107.36 118.895 108.028 118.45Z"
          fill="#2A49F9"
        />
        <path
          d="M140.532 99.7499C141.2 99.3046 142.313 99.3046 142.981 99.7499C143.648 100.195 143.648 100.752 142.981 101.197C142.313 101.642 141.2 101.642 140.532 101.197C139.864 100.752 139.753 100.195 140.532 99.7499Z"
          fill="#2A49F9"
        />
        <path
          d="M142.646 105.537C143.314 105.092 144.427 105.092 145.095 105.537C145.763 105.983 145.763 106.539 145.095 106.984C144.427 107.43 143.314 107.43 142.646 106.984C141.979 106.539 141.979 105.871 142.646 105.537Z"
          fill="#2A49F9"
        />
        <path
          d="M188.619 118.56C189.287 118.115 190.4 118.115 191.068 118.56C191.736 119.006 191.736 119.562 191.068 120.007C190.4 120.453 189.287 120.453 188.619 120.007C187.951 119.562 187.951 118.894 188.619 118.56Z"
          fill="#2A49F9"
        />
        <path
          d="M190.622 113.997C191.605 113.997 192.403 113.548 192.403 112.995C192.403 112.442 191.605 111.993 190.622 111.993C189.638 111.993 188.841 112.442 188.841 112.995C188.841 113.548 189.638 113.997 190.622 113.997Z"
          fill="#2A49F9"
        />
        <path
          d="M249.173 98.1908C249.841 97.7456 250.954 97.7456 251.622 98.1908C252.29 98.6361 252.29 99.1926 251.622 99.6379C250.954 100.083 249.841 100.083 249.173 99.6379C248.505 99.1926 248.505 98.6361 249.173 98.1908Z"
          fill="#2A49F9"
        />
        <path
          d="M142.758 141.046L112.815 158.299L82.204 161.527L57.8265 147.502L36.3431 148.281L17.6426 159.079"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M83.0943 155.182L59.496 141.49L34.228 142.492L1.83594 161.193"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M16.3075 158.521C16.9754 158.075 18.0886 158.075 18.7564 158.521C19.4243 158.966 19.4243 159.522 18.7564 159.968C18.0886 160.413 16.9754 160.413 16.3075 159.968C15.6397 159.522 15.6397 158.855 16.3075 158.521Z"
          fill="#2A49F9"
        />
        <path
          d="M0.500908 160.636C1.16878 160.191 2.28193 160.191 2.9498 160.636C3.61768 161.081 3.61768 161.638 2.9498 162.083C2.28193 162.529 1.16878 162.529 0.500908 162.083C-0.166969 161.638 -0.166969 160.97 0.500908 160.636Z"
          fill="#2A49F9"
        />
        <path
          d="M32.8935 141.824C33.5614 141.378 34.6745 141.378 35.3424 141.824C36.0103 142.269 36.0103 142.826 35.3424 143.271C34.6745 143.716 33.5614 143.716 32.8935 143.271C32.2256 142.937 32.2256 142.269 32.8935 141.824Z"
          fill="#2A49F9"
        />
        <path
          d="M35.1191 147.613C35.7869 147.168 36.9001 147.168 37.568 147.613C38.2358 148.058 38.2358 148.615 37.568 149.06C36.9001 149.505 35.7869 149.505 35.1191 149.06C34.4512 148.615 34.4512 147.947 35.1191 147.613Z"
          fill="#2A49F9"
        />
        <path
          d="M80.9794 160.636C81.6473 160.191 82.7604 160.191 83.4283 160.636C84.0962 161.081 84.0962 161.638 83.4283 162.083C82.7604 162.529 81.6473 162.529 80.9794 162.083C80.3115 161.749 80.3115 161.081 80.9794 160.636Z"
          fill="#2A49F9"
        />
        <path
          d="M81.871 154.403C82.5389 153.958 83.652 153.958 84.3199 154.403C84.9878 154.848 84.9878 155.405 84.3199 155.85C83.652 156.295 82.5389 156.295 81.871 155.85C81.2031 155.405 81.2031 154.848 81.871 154.403Z"
          fill="#2A49F9"
        />
        <path
          d="M142.759 142.047C143.742 142.047 144.54 141.599 144.54 141.045C144.54 140.492 143.742 140.043 142.759 140.043C141.775 140.043 140.978 140.492 140.978 141.045C140.978 141.599 141.775 142.047 142.759 142.047Z"
          fill="#2A49F9"
        />
      </g>
      <path
        d="M166.358 95.7357C152.666 95.7357 141.535 83.046 141.535 67.3509C141.535 51.6558 152.666 38.9661 166.358 38.9661C180.049 38.9661 191.181 51.6558 191.181 67.3509C191.181 83.046 180.049 95.7357 166.358 95.7357Z"
        fill="url(#paint1_linear_461_8313)"
      />
      <path
        d="M141.535 67.3509C141.535 52.8802 150.997 40.9698 163.353 39.1887C162.351 39.0774 161.349 38.9661 160.347 38.9661C146.656 38.9661 135.524 51.6558 135.524 67.3509C135.524 83.046 146.656 95.7357 160.347 95.7357C161.349 95.7357 162.351 95.6244 163.353 95.513C151.108 93.732 141.535 81.8216 141.535 67.3509Z"
        fill="url(#paint2_linear_461_8313)"
      />
      <g opacity="0.5">
        <path
          d="M141.535 68.3526H135.413C135.413 69.0204 135.524 69.6883 135.524 70.3562H141.647C141.647 69.6883 141.535 69.0204 141.535 68.3526Z"
          fill="url(#paint3_linear_461_8313)"
        />
        <path
          d="M141.758 63.3422H135.636C135.524 64.0101 135.524 64.678 135.413 65.3459H141.535C141.647 64.678 141.758 64.0101 141.758 63.3422Z"
          fill="url(#paint4_linear_461_8313)"
        />
        <path
          d="M142.092 73.3609H135.97C136.081 74.0288 136.304 74.6967 136.415 75.3646H142.537C142.426 74.808 142.203 74.1401 142.092 73.3609Z"
          fill="url(#paint5_linear_461_8313)"
        />
        <path
          d="M143.539 78.483H137.417C137.64 79.1508 137.974 79.8187 138.308 80.4866H144.43C144.096 79.8187 143.762 79.1508 143.539 78.483Z"
          fill="url(#paint6_linear_461_8313)"
        />
        <path
          d="M142.871 58.2221H136.749C136.526 58.89 136.415 59.5579 136.192 60.2258H142.315C142.426 59.5579 142.649 58.89 142.871 58.2221Z"
          fill="url(#paint7_linear_461_8313)"
        />
        <path
          d="M144.875 53.2138H138.753C138.419 53.8817 138.085 54.5495 137.862 55.2174H143.985C144.207 54.5495 144.541 53.7703 144.875 53.2138Z"
          fill="url(#paint8_linear_461_8313)"
        />
        <path
          d="M148.994 47.0922H142.872C142.315 47.7601 141.759 48.428 141.202 49.0958H147.324C147.881 48.428 148.437 47.7601 148.994 47.0922Z"
          fill="url(#paint9_linear_461_8313)"
        />
        <path
          d="M155.226 42.0829H149.104C148.102 42.6394 147.1 43.3073 146.099 44.0865H152.221C153.111 43.3073 154.113 42.6394 155.226 42.0829Z"
          fill="url(#paint10_linear_461_8313)"
        />
        <path
          d="M146.655 84.4919H140.533C140.978 85.1597 141.535 85.8276 141.98 86.4955H148.102C147.657 85.9389 147.101 85.271 146.655 84.4919Z"
          fill="url(#paint11_linear_461_8313)"
        />
        <path
          d="M144.986 89.6129C145.766 90.3921 146.656 91.06 147.547 91.6165H153.669C152.778 90.9487 151.888 90.2808 151.109 89.6129H144.986Z"
          fill="url(#paint12_linear_461_8313)"
        />
      </g>
      <path
        opacity="0.6"
        d="M167.36 89.9475C178.425 89.9475 187.396 79.8307 187.396 67.351C187.396 54.8713 178.425 44.7545 167.36 44.7545C156.294 44.7545 147.323 54.8713 147.323 67.351C147.323 79.8307 156.294 89.9475 167.36 89.9475Z"
        stroke="url(#paint13_linear_461_8313)"
        strokeWidth="1.0818"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.6"
        d="M167.471 87.944C177.492 87.944 185.615 78.7741 185.615 67.4625C185.615 56.1508 177.492 46.9809 167.471 46.9809C157.45 46.9809 149.327 56.1508 149.327 67.4625C149.327 78.7741 157.45 87.944 167.471 87.944Z"
        stroke="url(#paint14_linear_461_8313)"
        strokeWidth="0.3152"
        strokeMiterlimit="10"
      />
      <path
        d="M117.157 42.4161C113.484 45.5328 107.695 44.7536 104.133 40.635C100.571 36.5165 100.571 30.6169 104.245 27.5001C107.918 24.3834 113.706 25.1626 117.268 29.2811C120.719 33.3997 120.719 39.2993 117.157 42.4161Z"
        fill="url(#paint15_linear_461_8313)"
      />
      <path
        d="M117.157 29.1701C120.496 32.9548 120.719 38.2978 117.824 41.6371C118.158 41.4145 118.381 41.1919 118.715 40.9693C122.388 37.8525 122.388 31.9529 118.826 27.8344C115.264 23.7158 109.365 22.8253 105.803 26.0534C105.58 26.276 105.246 26.4986 105.023 26.8326C108.585 24.3837 113.928 25.3855 117.157 29.1701Z"
        fill="url(#paint16_linear_461_8313)"
      />
      <g opacity="0.5">
        <path
          d="M117.379 29.5036C117.49 29.7262 117.713 29.8375 117.824 30.0602L119.383 28.7244C119.271 28.5018 119.049 28.3905 118.937 28.1678L117.379 29.5036Z"
          fill="url(#paint17_linear_461_8313)"
        />
        <path
          d="M116.154 28.1689C116.377 28.2803 116.488 28.5029 116.711 28.6142L118.269 27.2784C118.047 27.0558 117.935 26.9445 117.713 26.8332L116.154 28.1689Z"
          fill="url(#paint18_linear_461_8313)"
        />
        <path
          d="M118.381 30.9519C118.492 31.1745 118.604 31.3971 118.715 31.6198L120.273 30.284C120.162 30.0614 120.051 29.8388 119.939 29.6161L118.381 30.9519Z"
          fill="url(#paint19_linear_461_8313)"
        />
        <path
          d="M119.16 32.6217C119.271 32.8443 119.383 33.0669 119.383 33.4009L120.941 32.0651C120.83 31.8425 120.83 31.6199 120.719 31.2859L119.16 32.6217Z"
          fill="url(#paint20_linear_461_8313)"
        />
        <path
          d="M114.818 27.0558C115.041 27.1671 115.264 27.2784 115.375 27.501L116.933 26.1652C116.711 26.0539 116.488 25.8313 116.377 25.72L114.818 27.0558Z"
          fill="url(#paint21_linear_461_8313)"
        />
        <path
          d="M113.038 26.2757C113.261 26.3871 113.483 26.4984 113.706 26.6097L115.264 25.2739C115.042 25.1626 114.819 25.0513 114.596 24.94L113.038 26.2757Z"
          fill="url(#paint22_linear_461_8313)"
        />
        <path
          d="M110.589 25.6084C110.923 25.6084 111.145 25.7197 111.479 25.7197L113.038 24.3839C112.704 24.2726 112.481 24.2726 112.147 24.2726L110.589 25.6084Z"
          fill="url(#paint23_linear_461_8313)"
        />
        <path
          d="M107.807 25.6082C108.252 25.4969 108.586 25.4969 109.031 25.4969L110.589 24.1612C110.144 24.1612 109.699 24.2725 109.365 24.2725L107.807 25.6082Z"
          fill="url(#paint24_linear_461_8313)"
        />
        <path
          d="M119.828 34.9588C119.828 35.2927 119.939 35.5154 119.939 35.8493L121.498 34.5136C121.498 34.1796 121.498 33.957 121.386 33.623L119.828 34.9588Z"
          fill="url(#paint25_linear_461_8313)"
        />
        <path
          d="M119.828 37.2965C119.828 37.6304 119.717 38.0757 119.605 38.4096L121.164 36.9626C121.275 36.6286 121.275 36.1834 121.386 35.8494L119.828 37.2965Z"
          fill="url(#paint26_linear_461_8313)"
        />
      </g>
      <path
        d="M115.821 40.9692C115.71 41.0805 115.488 41.0805 115.376 40.9692C115.265 40.8579 115.265 40.6352 115.376 40.4126C115.488 40.3013 115.71 40.0787 115.821 39.9673C115.933 39.856 116.155 39.856 116.267 39.9673C116.378 40.0787 116.378 40.3013 116.267 40.4126C116.155 40.6352 116.044 40.7465 115.821 40.9692ZM114.04 41.971C113.929 42.0823 113.929 42.0823 114.04 41.971C113.707 42.0823 113.484 42.1936 113.261 42.3049C113.039 42.3049 112.927 42.1936 112.816 42.0823C112.816 41.8597 112.927 41.7483 113.039 41.637C113.261 41.637 113.484 41.5257 113.707 41.4144C113.929 41.3031 114.04 41.4144 114.152 41.637C114.152 41.7483 114.152 41.8597 114.04 41.971ZM117.491 38.6316C117.38 38.7429 117.269 38.7429 117.157 38.7429C116.935 38.6316 116.935 38.409 116.935 38.2977C117.046 38.075 117.046 37.8524 117.157 37.6298C117.157 37.4072 117.38 37.2958 117.603 37.4072C117.825 37.4072 117.936 37.6298 117.825 37.8524C117.714 38.075 117.714 38.2977 117.603 38.5203C117.491 38.6316 117.491 38.6316 117.491 38.6316ZM111.258 42.4162C111.146 42.5276 111.146 42.5275 111.035 42.5275C110.812 42.5275 110.59 42.5276 110.256 42.4162C110.033 42.4162 109.922 42.1936 109.922 41.971C109.922 41.7484 110.145 41.637 110.367 41.637C110.59 41.637 110.812 41.7484 111.035 41.7484C111.258 41.7484 111.369 41.971 111.369 42.0823C111.369 42.1936 111.369 42.3049 111.258 42.4162ZM117.936 35.9601C117.825 35.9601 117.825 36.0714 117.714 36.0714C117.491 36.0714 117.38 35.9601 117.38 35.7375C117.38 35.5148 117.38 35.2922 117.38 35.0696C117.38 34.847 117.491 34.7357 117.714 34.6243C117.936 34.6243 118.048 34.7356 118.159 34.9583C118.159 35.1809 118.159 35.4035 118.159 35.7375C118.048 35.7375 118.048 35.8488 117.936 35.9601ZM108.586 41.637C108.475 41.7483 108.364 41.7483 108.252 41.637C108.03 41.5257 107.807 41.4144 107.584 41.3031C107.362 41.1918 107.362 40.9692 107.473 40.8579C107.584 40.6352 107.807 40.6352 107.918 40.7465C108.141 40.8579 108.364 40.9692 108.475 41.0805C108.697 41.1918 108.697 41.4144 108.586 41.5257V41.637ZM117.38 33.1773C117.046 33.2886 116.935 33.1773 116.823 33.066C116.712 32.8433 116.601 32.6207 116.601 32.5094C116.489 32.2868 116.601 32.1755 116.712 32.0641C116.935 31.9528 117.046 32.0641 117.157 32.1754C117.269 32.3981 117.38 32.6207 117.491 32.8433C117.491 32.9546 117.491 33.066 117.38 33.1773ZM106.249 39.9673C106.137 40.0787 105.915 40.0787 105.803 39.9673C105.692 39.856 105.469 39.6334 105.358 39.4108C105.247 39.2995 105.247 39.0768 105.358 38.9655C105.469 38.8542 105.692 38.8542 105.915 38.9655C106.026 39.0768 106.249 39.2995 106.36 39.4108C106.471 39.6334 106.471 39.856 106.249 39.9673ZM115.933 30.8397C115.821 30.951 115.599 30.951 115.376 30.8397C115.265 30.7284 115.042 30.5058 114.931 30.3945C114.82 30.2831 114.82 30.0605 114.931 29.9492C115.042 29.8379 115.265 29.8379 115.376 29.9492C115.599 30.1718 115.71 30.2831 115.821 30.5058C116.044 30.5058 116.044 30.7284 115.933 30.8397ZM104.579 37.7411C104.356 37.8524 104.134 37.8524 104.022 37.6298C103.911 37.4072 103.8 37.1845 103.688 36.9619C103.577 36.7393 103.688 36.628 103.911 36.5167C104.134 36.4053 104.245 36.5167 104.356 36.7393C104.468 36.9619 104.579 37.1845 104.579 37.4072C104.802 37.5185 104.802 37.6298 104.579 37.7411ZM113.818 29.0587C113.707 29.17 113.595 29.17 113.373 29.0587C113.15 28.9474 112.927 28.8361 112.816 28.7248C112.593 28.6134 112.593 28.3908 112.705 28.2795C112.816 28.0569 113.039 28.0569 113.15 28.1682C113.373 28.2795 113.595 28.3908 113.818 28.5021C113.929 28.5021 113.929 28.7248 113.818 29.0587C113.818 28.9474 113.818 28.9474 113.818 29.0587ZM103.8 35.0696C103.8 35.0696 103.688 35.1809 103.577 35.1809C103.354 35.1809 103.243 35.0696 103.132 34.847C103.132 34.6243 103.132 34.4017 103.132 34.0678C103.132 33.8452 103.243 33.7338 103.466 33.7338C103.688 33.7338 103.8 33.8452 103.8 34.0678C103.8 34.2904 103.8 34.513 103.8 34.7356C103.911 34.847 103.911 34.9583 103.8 35.0696ZM111.146 28.0569C111.035 28.1682 110.924 28.1682 110.812 28.1682C110.59 28.1682 110.367 28.0569 110.145 28.0569C109.922 28.0569 109.811 27.8342 109.811 27.7229C109.811 27.5003 110.033 27.389 110.145 27.389C110.367 27.389 110.59 27.389 110.924 27.5003C111.146 27.5003 111.258 27.7229 111.258 27.9456C111.258 27.9456 111.258 27.9456 111.146 28.0569ZM104.022 32.2868C103.911 32.3981 103.8 32.3981 103.688 32.3981C103.466 32.3981 103.354 32.1754 103.466 31.9528C103.577 31.7302 103.577 31.5076 103.688 31.285C103.8 31.0623 104.022 31.0623 104.134 31.0623C104.356 31.1736 104.356 31.3963 104.356 31.5076C104.245 31.7302 104.245 31.9528 104.134 32.1754C104.134 32.1754 104.134 32.2868 104.022 32.2868ZM108.364 28.1682L108.252 28.2795C108.03 28.2795 107.807 28.3908 107.584 28.5021C107.362 28.6134 107.25 28.5021 107.139 28.2795C107.028 28.0569 107.139 27.9456 107.362 27.8343C107.584 27.7229 107.807 27.7229 108.03 27.6116C108.252 27.6116 108.364 27.7229 108.475 27.8343C108.475 27.9456 108.475 28.0569 108.364 28.1682ZM105.358 29.8379C105.247 29.9492 105.024 29.9492 104.913 29.8379C104.802 29.7266 104.802 29.5039 104.913 29.3926C105.024 29.17 105.247 29.0587 105.469 28.8361C105.581 28.7247 105.803 28.7247 105.915 28.8361C106.026 28.9474 106.026 29.17 105.915 29.3926C105.692 29.5039 105.581 29.7266 105.358 29.8379Z"
        fill="url(#paint27_linear_461_8313)"
      />
      <path
        d="M197.079 29.17C191.625 24.6061 191.403 15.7011 196.634 9.46759C201.866 3.23407 210.66 1.89832 216.114 6.46215C221.568 11.026 221.791 19.931 216.559 26.1645C211.216 32.5093 202.534 33.8451 197.079 29.17Z"
        fill="url(#paint28_linear_461_8313)"
      />
      <path
        d="M216.56 26.1643C211.662 31.9526 203.87 33.511 198.416 30.0603C198.75 30.5055 199.195 30.8395 199.529 31.1734C204.983 35.7372 213.777 34.4015 219.009 28.1679C224.241 21.9344 224.129 13.0294 218.564 8.46558C218.118 8.13164 217.673 7.7977 217.228 7.57507C221.569 12.4728 221.346 20.376 216.56 26.1643Z"
        fill="url(#paint29_linear_461_8313)"
      />
      <g opacity="0.5">
        <path
          d="M216.225 26.6103C216.003 26.8329 215.78 27.1669 215.446 27.3895L217.895 29.3931C218.118 29.1705 218.34 28.8366 218.674 28.6139L216.225 26.6103Z"
          fill="url(#paint30_linear_461_8313)"
        />
        <path
          d="M217.784 24.4946C217.561 24.8286 217.339 25.0512 217.228 25.3851L219.676 27.3888C219.899 27.0548 220.122 26.8322 220.233 26.4983L217.784 24.4946Z"
          fill="url(#paint31_linear_461_8313)"
        />
        <path
          d="M214.223 28.5015C213.889 28.7242 213.666 28.9468 213.332 29.1694L215.781 31.173C216.115 30.9504 216.337 30.7278 216.671 30.5051L214.223 28.5015Z"
          fill="url(#paint32_linear_461_8313)"
        />
        <path
          d="M211.996 29.9499C211.662 30.1725 211.328 30.2838 210.994 30.5064L213.443 32.5101C213.777 32.3987 214.111 32.1761 214.445 31.9535L211.996 29.9499Z"
          fill="url(#paint33_linear_461_8313)"
        />
        <path
          d="M219.12 22.1566C219.009 22.4905 218.786 22.8244 218.675 23.1584L221.124 25.162C221.346 24.8281 221.458 24.4941 221.569 24.1602L219.12 22.1566Z"
          fill="url(#paint34_linear_461_8313)"
        />
        <path
          d="M220.011 19.3745C219.899 19.7085 219.788 20.1537 219.677 20.4877L222.126 22.4913C222.237 22.1574 222.348 21.7121 222.46 21.3782L220.011 19.3745Z"
          fill="url(#paint35_linear_461_8313)"
        />
        <path
          d="M220.345 15.5911C220.345 16.0363 220.345 16.4816 220.345 16.9268L222.794 18.9304C222.794 18.4852 222.794 18.0399 222.794 17.5947L220.345 15.5911Z"
          fill="url(#paint36_linear_461_8313)"
        />
        <path
          d="M219.564 11.4715C219.787 12.0281 219.898 12.6959 220.121 13.2525L222.57 15.2561C222.459 14.5882 222.236 14.0317 222.013 13.4751L219.564 11.4715Z"
          fill="url(#paint37_linear_461_8313)"
        />
        <path
          d="M208.656 31.3972C208.211 31.5085 207.766 31.6198 207.32 31.7311L209.769 33.7348C210.214 33.6234 210.66 33.5121 210.994 33.4008L208.656 31.3972Z"
          fill="url(#paint38_linear_461_8313)"
        />
        <path
          d="M205.206 31.9538C204.649 31.9538 204.093 31.9538 203.536 31.9538L205.985 33.9574C206.542 33.9574 207.098 34.0687 207.655 33.9574L205.206 31.9538Z"
          fill="url(#paint39_linear_461_8313)"
        />
      </g>
      <path
        d="M198.861 26.9439C198.638 26.7212 198.638 26.3873 198.861 26.1647C199.083 25.942 199.417 25.942 199.64 26.1647C199.863 26.3873 200.197 26.6099 200.419 26.7212C200.642 26.9439 200.753 27.1665 200.531 27.5004C200.419 27.723 200.085 27.8344 199.751 27.6117C199.529 27.5004 199.195 27.2778 198.861 26.9439ZM196.857 24.495L196.746 24.3837C196.523 24.0497 196.412 23.7158 196.301 23.3819C196.189 23.1592 196.301 22.8253 196.635 22.714C196.857 22.6027 197.191 22.714 197.302 23.0479C197.414 23.3818 197.525 23.6045 197.748 23.9384C197.859 24.161 197.748 24.495 197.525 24.6063C197.302 24.7176 197.08 24.7176 196.857 24.495ZM202.645 28.8362C202.534 28.7249 202.423 28.5022 202.423 28.2796C202.534 27.9457 202.757 27.8344 203.091 27.8344C203.425 27.9457 203.759 27.9457 204.093 28.057C204.426 28.057 204.538 28.3909 204.538 28.6136C204.538 28.9475 204.204 29.0588 203.981 29.0588C203.647 29.0588 203.202 28.9475 202.868 28.8362C202.757 28.9475 202.645 28.9475 202.645 28.8362ZM195.744 20.599C195.633 20.4877 195.521 20.3764 195.521 20.2651C195.521 19.9312 195.521 19.4859 195.521 19.152C195.521 18.818 195.744 18.5954 196.078 18.5954C196.412 18.5954 196.635 18.818 196.635 19.152C196.635 19.4859 196.635 19.8198 196.635 20.1538C196.635 20.4877 196.412 20.7104 196.189 20.7104C195.967 20.7104 195.744 20.599 195.744 20.599ZM206.764 28.9475C206.653 28.8362 206.653 28.7249 206.541 28.6136C206.541 28.2796 206.653 28.057 206.987 27.9457C207.321 27.8344 207.655 27.8344 207.989 27.723C208.322 27.6117 208.545 27.8344 208.656 28.057C208.768 28.3909 208.545 28.6136 208.322 28.7249C207.989 28.8362 207.655 28.9475 207.209 28.9475C207.098 29.0588 206.875 29.0588 206.764 28.9475ZM196.189 16.3691C196.078 16.2578 195.967 16.0352 195.967 15.8126C196.078 15.4786 196.189 15.1447 196.301 14.8108C196.412 14.5881 196.746 14.3655 196.969 14.4768C197.191 14.5881 197.414 14.9221 197.302 15.1447C197.191 15.4786 197.08 15.8126 196.969 16.1465C196.857 16.4805 196.635 16.5918 196.301 16.4805C196.301 16.4805 196.189 16.4805 196.189 16.3691ZM210.66 27.3891L210.549 27.2778C210.437 27.0552 210.437 26.7212 210.771 26.4986C211.105 26.276 211.328 26.1647 211.662 25.9421C211.884 25.7194 212.218 25.8307 212.441 26.0534C212.664 26.276 212.552 26.6099 212.33 26.8326C211.996 27.0552 211.773 27.2778 211.439 27.3891C211.105 27.6117 210.883 27.5004 210.66 27.3891ZM197.97 12.6958C197.748 12.4732 197.748 12.2506 197.859 12.0279C198.082 11.694 198.304 11.4714 198.527 11.2488C198.75 11.0261 199.083 11.0261 199.306 11.2488C199.529 11.4714 199.529 11.8053 199.306 12.0279C199.083 12.2506 198.861 12.5845 198.75 12.8071C198.638 12.8071 198.304 12.8071 197.97 12.6958ZM213.888 24.7176C213.665 24.495 213.665 24.161 213.777 23.9384C213.999 23.7158 214.222 23.3819 214.333 23.1592C214.556 22.9366 214.89 22.8253 215.113 23.0479C215.335 23.2705 215.446 23.4932 215.224 23.8271C215.001 24.161 214.779 24.3837 214.556 24.7176C214.445 24.8289 214.111 24.8289 213.888 24.7176ZM200.976 9.69037C200.864 9.57906 200.864 9.69037 200.976 9.69037C200.753 9.35643 200.753 9.0225 200.976 8.91118C201.31 8.68856 201.532 8.46593 201.866 8.35462C202.089 8.24331 202.423 8.2433 202.645 8.57724C202.757 8.79987 202.757 9.1338 202.423 9.35643C202.089 9.57905 201.866 9.69037 201.532 9.91299C201.421 9.91299 201.087 9.80168 200.976 9.69037ZM216.003 21.1556C215.78 21.0443 215.78 20.8217 215.892 20.599C216.003 20.2651 216.114 19.9312 216.226 19.5972C216.337 19.2633 216.56 19.152 216.894 19.2633C217.227 19.3746 217.339 19.5972 217.227 19.9311C217.116 20.2651 217.005 20.599 216.894 20.933C216.782 21.1556 216.448 21.3782 216.226 21.2669C216.114 21.1556 216.003 21.1556 216.003 21.1556ZM204.649 7.90938C204.538 7.79806 204.538 7.79805 204.427 7.68674C204.315 7.3528 204.538 7.13018 204.76 7.01887C205.094 6.90756 205.428 6.79625 205.874 6.79625C206.208 6.79625 206.43 6.90755 206.541 7.24149C206.541 7.57543 206.43 7.79806 206.096 7.90938C205.762 8.02069 205.428 8.02069 205.094 8.132C204.983 8.02069 204.76 8.02069 204.649 7.90938ZM216.782 17.037C216.671 16.9257 216.56 16.8144 216.56 16.5918C216.56 16.2578 216.56 15.9239 216.56 15.59C216.56 15.256 216.782 15.0334 217.005 15.0334C217.339 15.0334 217.561 15.256 217.561 15.4786C217.561 15.8126 217.561 16.2578 217.561 16.5918C217.561 16.9257 217.339 17.1483 217.005 17.1483C217.005 17.1483 216.894 17.037 216.782 17.037ZM208.879 7.46411C208.768 7.3528 208.656 7.13018 208.656 7.01887C208.656 6.68493 208.99 6.57361 209.213 6.57361C209.547 6.57361 209.992 6.68493 210.326 6.79625C210.66 6.90756 210.771 7.13018 210.771 7.46411C210.66 7.79805 210.437 7.90938 210.103 7.90938C209.77 7.79806 209.436 7.79805 209.102 7.68674C208.99 7.57542 208.879 7.57543 208.879 7.46411ZM216.003 12.9185C215.892 12.9185 215.892 12.8071 215.892 12.6958C215.78 12.3619 215.669 12.1393 215.446 11.8053C215.335 11.5827 215.446 11.2488 215.669 11.1374C215.892 11.0261 216.226 11.0261 216.337 11.3601C216.56 11.694 216.671 12.028 216.782 12.3619C216.894 12.5845 216.782 12.9184 216.448 13.0298C216.448 13.0298 216.226 13.0298 216.003 12.9185ZM212.775 8.91118C212.552 8.68856 212.552 8.46593 212.664 8.2433C212.775 8.02068 213.109 7.90937 213.443 8.132C213.777 8.35462 213.999 8.57724 214.333 8.79987C214.556 9.02249 214.556 9.35644 214.445 9.57907C214.222 9.80169 213.888 9.80168 213.665 9.69037C213.332 9.35643 213.109 9.13381 212.775 8.91118Z"
        fill="url(#paint40_linear_461_8313)"
      />
      <path
        d="M158.453 235.321L75.9707 187.79C72.2973 185.675 72.186 174.544 73.7444 170.759L151.107 130.687C155.337 128.238 161.904 127.904 165.577 130.13L249.953 173.097C253.069 177.995 251.288 189.571 247.058 192.02L173.035 234.764C168.694 237.213 162.127 237.436 158.453 235.321Z"
        fill="url(#paint41_linear_461_8313)"
      />
      <path
        d="M158.453 223.078L75.97 175.547C72.2967 173.432 72.742 169.648 76.9718 167.199L150.995 124.455C155.225 122.006 161.792 121.672 165.466 123.898L247.948 171.429C251.622 173.543 251.176 177.328 246.947 179.777L172.923 222.521C168.694 224.859 162.126 225.193 158.453 223.078Z"
        fill="url(#paint42_linear_461_8313)"
      />
      <path
        d="M158.342 217.512L85.4319 175.547C81.7586 173.432 82.2039 169.647 86.4338 167.199L151.107 129.909C155.336 127.46 161.904 127.126 165.577 129.352L238.487 171.317C242.16 173.432 241.715 177.217 237.485 179.666L172.812 216.955C168.583 219.404 162.015 219.627 158.342 217.512Z"
        fill="url(#paint43_linear_461_8313)"
      />
      <path
        d="M159.011 201.818L97.121 166.198C94.3382 164.64 94.3382 160.744 95.4513 157.961L153.445 127.906C156.673 126.014 161.46 125.903 164.243 127.461L227.468 159.631C229.806 163.304 228.47 167.422 225.242 169.315L169.697 201.373C166.691 203.154 161.794 203.376 159.011 201.818Z"
        fill="url(#paint44_linear_461_8313)"
      />
      <path
        d="M159.011 197.142L97.1211 161.522C94.3383 159.963 94.6722 157.069 97.9003 155.288L153.445 123.23C156.673 121.338 161.46 121.227 164.243 122.785L226.133 158.405C228.915 159.963 228.582 162.858 225.353 164.639L169.808 196.697C166.692 198.589 161.794 198.812 159.011 197.142Z"
        fill="url(#paint45_linear_461_8313)"
      />
      <path
        d="M158.9 193.023L104.245 161.633C101.462 160.074 101.796 157.18 105.024 155.399L153.445 127.46C156.673 125.567 161.46 125.456 164.243 127.014L218.897 158.404C221.68 159.963 221.346 162.857 218.118 164.638L169.697 192.578C166.58 194.47 161.683 194.581 158.9 193.023Z"
        fill="url(#paint46_linear_461_8313)"
      />
      <path
        d="M158.9 183.226L100.906 149.832C98.3453 148.385 98.234 144.823 99.3471 142.151L153.668 113.989C156.673 112.208 161.237 112.097 163.797 113.544L223.016 143.71C225.242 147.16 224.018 151.056 221.012 152.726L169.029 182.781C166.024 184.562 161.46 184.784 158.9 183.226Z"
        fill="url(#paint47_linear_461_8313)"
      />
      <path
        d="M158.9 178.885L100.906 145.491C98.3457 144.044 98.6796 141.373 101.685 139.592L153.668 109.537C156.674 107.756 161.237 107.645 163.798 109.092L221.792 142.486C224.352 143.933 224.018 146.605 221.012 148.386L169.029 178.44C166.024 180.221 161.46 180.444 158.9 178.885Z"
        fill="url(#paint48_linear_461_8313)"
      />
      <path
        d="M158.788 175.102L107.585 145.715C105.024 144.268 105.358 141.597 108.364 139.816L153.779 113.657C156.785 111.876 161.349 111.765 163.909 113.212L215.113 142.598C217.673 144.045 217.339 146.717 214.334 148.498L168.918 174.656C166.024 176.326 161.46 176.549 158.788 175.102Z"
        fill="url(#paint49_linear_461_8313)"
      />
      <path
        d="M159.01 166.419L104.578 135.14C102.129 133.693 102.129 130.354 103.02 127.905L154.112 101.413C156.895 99.7428 161.236 99.6315 163.685 100.967L219.341 129.352C221.345 132.58 220.232 136.253 217.449 137.812L168.583 165.974C165.8 167.644 161.459 167.866 159.01 166.419Z"
        fill="url(#paint50_linear_461_8313)"
      />
      <path
        d="M159.01 162.412L104.579 131.133C102.13 129.686 102.464 127.237 105.246 125.678L154.113 97.5164C156.896 95.8467 161.237 95.7353 163.686 97.0711L218.118 128.35C220.566 129.797 220.233 132.246 217.45 133.804L168.583 161.966C165.801 163.636 161.459 163.747 159.01 162.412Z"
        fill="url(#paint51_linear_461_8313)"
      />
      <path
        d="M159.009 158.739L110.922 131.134C108.473 129.687 108.807 127.238 111.59 125.679L154.223 101.079C157.006 99.4097 161.347 99.2983 163.796 100.634L211.883 128.24C214.332 129.687 213.998 132.136 211.215 133.694L168.582 158.294C165.688 159.964 161.458 160.186 159.009 158.739Z"
        fill="url(#paint52_linear_461_8313)"
      />
      <path
        d="M160.791 147.609L128.956 129.354C127.509 128.574 127.509 121.673 128.065 120.226L157.897 104.754C159.567 103.752 162.016 103.752 163.463 104.531L195.966 121.117C197.191 123.009 196.523 130.022 194.853 131.023L166.357 147.498C164.687 148.277 162.127 148.388 160.791 147.609Z"
        fill="url(#paint53_linear_461_8313)"
      />
      <path
        d="M160.792 140.262L128.957 122.007C127.51 121.228 127.732 119.781 129.402 118.779L157.898 102.305C159.568 101.303 162.017 101.303 163.464 102.082L195.299 120.337C196.746 121.117 196.523 122.564 194.854 123.565L166.358 140.04C164.688 141.042 162.128 141.153 160.792 140.262Z"
        fill="url(#paint54_linear_461_8313)"
      />
      <path
        d="M160.679 138.148L132.628 122.008C131.181 121.229 131.404 119.781 133.074 118.78L158.008 104.42C159.677 103.419 162.126 103.419 163.573 104.198L191.624 120.338C193.071 121.117 192.849 122.564 191.179 123.566L166.245 137.925C164.687 138.927 162.126 139.039 160.679 138.148Z"
        fill="#C6F8FF"
      />
      <path
        opacity="0.8"
        d="M65.7305 31.9537L128.288 119.891L159.901 138.146C162.127 139.482 164.91 139.482 167.136 138.146L198.749 119.891L257.745 34.0687C257.745 34.0687 203.87 -2.33063 162.573 0.118249C119.272 2.90107 65.7305 31.9537 65.7305 31.9537Z"
        fill="url(#paint55_linear_461_8313)"
      />
      <g opacity="0.5">
        <path
          d="M205.874 69.3549H205.651C205.54 69.3549 205.54 69.2435 205.54 69.2435V69.0209C205.54 68.9096 205.651 68.9096 205.651 68.9096H205.874C205.985 68.9096 205.985 69.0209 205.985 69.0209V69.2435C205.985 69.3549 205.874 69.3549 205.874 69.3549Z"
          fill="white"
        />
        <path
          d="M203.313 103.972H203.091C202.979 103.972 202.979 103.861 202.979 103.861V103.639C202.979 103.527 203.091 103.527 203.091 103.527H203.313C203.425 103.527 203.425 103.639 203.425 103.639V103.861C203.425 103.973 203.425 103.972 203.313 103.972Z"
          fill="white"
        />
        <path
          d="M187.507 96.5153H187.284C187.173 96.5153 187.173 96.404 187.173 96.404V96.1814C187.173 96.0701 187.284 96.0701 187.284 96.0701H187.507C187.618 96.0701 187.618 96.1814 187.618 96.1814V96.404L187.507 96.5153Z"
          fill="white"
        />
        <path
          d="M176.821 98.9637H176.599C176.487 98.9637 176.487 98.8524 176.487 98.8524V98.5185C176.487 98.4072 176.599 98.4072 176.599 98.4072H176.821C176.933 98.4072 176.933 98.5185 176.933 98.5185V98.7411C176.933 98.8524 176.933 98.9637 176.821 98.9637Z"
          fill="white"
        />
        <path
          d="M171.367 87.9441L171.145 87.8328C171.033 87.8328 171.033 87.7215 171.033 87.6102L171.145 87.3876C171.145 87.2763 171.256 87.2762 171.367 87.2762L171.59 87.3876C171.701 87.3876 171.701 87.4989 171.701 87.6102L171.59 87.8328C171.478 87.9441 171.367 87.9441 171.367 87.9441Z"
          fill="white"
        />
        <path
          d="M162.907 108.871L162.685 108.76C162.573 108.76 162.573 108.649 162.573 108.537L162.685 108.315C162.685 108.203 162.796 108.203 162.907 108.203L163.13 108.315C163.241 108.315 163.241 108.426 163.241 108.537L163.13 108.76C163.13 108.871 163.018 108.983 162.907 108.871Z"
          fill="white"
        />
        <path
          d="M150.106 78.7054L149.884 78.5941C149.772 78.5941 149.772 78.4828 149.772 78.3715L149.884 78.1489C149.884 78.0376 149.995 78.0376 150.106 78.0376L150.329 78.1489C150.44 78.1489 150.44 78.2602 150.44 78.3715L150.329 78.5941C150.218 78.7054 150.218 78.8167 150.106 78.7054Z"
          fill="white"
        />
        <path
          d="M128.623 88.2783L128.4 88.167C128.289 88.167 128.289 88.0557 128.289 87.9444L128.4 87.7217C128.4 87.6104 128.512 87.6104 128.623 87.6104L128.846 87.7217C128.957 87.7217 128.957 87.833 128.957 87.9444L128.846 88.167C128.734 88.2783 128.734 88.2783 128.623 88.2783Z"
          fill="white"
        />
        <path
          d="M139.197 119.668L138.975 119.557C138.863 119.557 138.863 119.445 138.863 119.334L138.975 119.112C138.975 119 139.086 119 139.197 119L139.42 119.112C139.531 119.112 139.531 119.223 139.531 119.334L139.42 119.557C139.309 119.668 139.197 119.779 139.197 119.668Z"
          fill="white"
        />
        <path
          d="M143.204 98.296L142.981 98.1847C142.87 98.1847 142.87 98.0734 142.87 97.9621L142.981 97.7395C142.981 97.6282 143.093 97.6281 143.204 97.6281L143.427 97.7395C143.538 97.7395 143.538 97.8508 143.538 97.9621L143.427 98.1847C143.315 98.296 143.204 98.296 143.204 98.296Z"
          fill="white"
        />
        <path
          d="M128.623 72.3605L128.4 72.2492C128.289 72.2492 128.289 72.1379 128.289 72.0265L128.4 71.8039C128.4 71.6926 128.512 71.6926 128.623 71.6926L128.846 71.8039C128.957 71.8039 128.957 71.9152 128.957 72.0265L128.846 72.2492C128.734 72.3605 128.734 72.3605 128.623 72.3605Z"
          fill="white"
        />
        <path
          d="M111.592 93.2876L111.369 93.1763C111.258 93.1763 111.258 93.065 111.258 92.9537L111.369 92.7311C111.369 92.6198 111.48 92.6198 111.592 92.6198L111.814 92.7311C111.926 92.7311 111.926 92.8424 111.926 92.9537L111.814 93.1763C111.703 93.2876 111.703 93.2876 111.592 93.2876Z"
          fill="white"
        />
        <path
          d="M111.592 77.3698L111.369 77.2585C111.258 77.2585 111.258 77.1472 111.258 77.0359L111.369 76.8133C111.369 76.7019 111.48 76.7019 111.592 76.7019L111.814 76.8133C111.926 76.8133 111.926 76.9246 111.926 77.0359L111.814 77.2585C111.703 77.3698 111.703 77.3698 111.592 77.3698Z"
          fill="white"
        />
        <path
          d="M216.448 87.9441L216.226 87.8328C216.114 87.8328 216.114 87.7215 216.114 87.6102L216.226 87.3876C216.226 87.2763 216.337 87.2762 216.448 87.2762L216.671 87.3876C216.782 87.3876 216.782 87.4989 216.782 87.6102L216.671 87.8328C216.56 87.9441 216.448 87.9441 216.448 87.9441Z"
          fill="white"
        />
        <path
          d="M217.784 77.3698L217.562 77.2585C217.45 77.2585 217.45 77.1472 217.45 77.0359L217.562 76.8133C217.562 76.7019 217.673 76.7019 217.784 76.7019L218.007 76.8133C218.118 76.8133 218.118 76.9246 218.118 77.0359L218.007 77.2585C218.007 77.3698 217.895 77.3698 217.784 77.3698Z"
          fill="white"
        />
        <path
          d="M196.857 92.3959L196.635 92.2846C196.523 92.2846 196.523 92.1733 196.523 92.062L196.635 91.8393C196.635 91.728 196.746 91.728 196.857 91.728L197.08 91.8393C197.191 91.8393 197.191 91.9507 197.191 92.062L197.08 92.2846C197.08 92.3959 196.969 92.3959 196.857 92.3959Z"
          fill="white"
        />
        <path
          d="M188.063 73.8068L187.841 73.6955C187.729 73.6955 187.729 73.5842 187.729 73.4729L187.841 73.2503C187.841 73.139 187.952 73.1389 188.063 73.1389L188.286 73.2503C188.397 73.2503 188.397 73.3616 188.397 73.4729L188.286 73.6955C188.286 73.8068 188.175 73.9181 188.063 73.8068Z"
          fill="white"
        />
        <path
          d="M164.91 127.905H164.687C164.576 127.905 164.576 127.794 164.576 127.794V127.571C164.576 127.46 164.687 127.46 164.687 127.46H164.91C165.021 127.46 165.021 127.571 165.021 127.571V127.794C165.021 127.794 165.021 127.905 164.91 127.905Z"
          fill="white"
        />
        <path
          d="M191.514 110.653L191.291 110.541C191.18 110.541 191.18 110.43 191.18 110.319L191.291 110.096C191.291 109.985 191.402 109.985 191.514 109.985L191.736 110.096C191.848 110.096 191.848 110.208 191.848 110.319L191.736 110.541C191.625 110.653 191.514 110.653 191.514 110.653Z"
          fill="white"
        />
        <path
          d="M129.18 102.08L128.957 101.969C128.846 101.969 128.846 101.858 128.846 101.747L128.957 101.524C128.957 101.413 129.068 101.413 129.18 101.413L129.402 101.524C129.514 101.524 129.514 101.635 129.514 101.747L129.402 101.969C129.291 102.08 129.18 102.08 129.18 102.08Z"
          fill="white"
        />
        <path
          d="M175.151 121.338L174.929 121.227C174.817 121.227 174.817 121.115 174.817 121.004L174.929 120.781C174.929 120.67 175.04 120.67 175.151 120.67L175.374 120.781C175.485 120.781 175.485 120.893 175.485 121.004L175.374 121.227C175.263 121.338 175.151 121.338 175.151 121.338Z"
          fill="white"
        />
        <path
          d="M180.606 81.1543L180.384 81.043C180.272 81.043 180.272 80.9316 180.272 80.8203L180.384 80.5977C180.384 80.4864 180.495 80.4864 180.606 80.4864L180.829 80.5977C180.94 80.5977 180.94 80.709 180.94 80.8203L180.829 81.043C180.718 81.1543 180.606 81.1543 180.606 81.1543Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M175.374 11.8054H175.151C175.04 11.8054 175.04 11.694 175.04 11.694V11.4714C175.04 11.3601 175.151 11.3601 175.151 11.3601H175.374C175.485 11.3601 175.485 11.4714 175.485 11.4714V11.694C175.485 11.694 175.485 11.8054 175.374 11.8054Z"
          fill="white"
        />
        <path
          d="M172.926 46.423H172.592C172.48 46.423 172.48 46.3117 172.48 46.3117V46.089C172.48 45.9777 172.592 45.9777 172.592 45.9777H172.814C172.926 45.9777 172.926 46.089 172.926 46.089V46.3117C173.037 46.3117 172.926 46.423 172.926 46.423Z"
          fill="white"
        />
        <path
          d="M158.01 29.0578H157.787C157.676 29.0578 157.676 28.9465 157.676 28.9465V28.7239C157.676 28.6126 157.787 28.6126 157.787 28.6126H158.01C158.121 28.6126 158.121 28.7239 158.121 28.7239V28.9465C158.232 28.9465 158.121 29.0578 158.01 29.0578Z"
          fill="white"
        />
        <path
          d="M146.433 41.4146H146.21C146.099 41.4146 146.099 41.3033 146.099 41.3033V41.0807C146.099 40.9694 146.21 40.9694 146.21 40.9694H146.433C146.544 40.9694 146.544 41.0807 146.544 41.0807V41.3033L146.433 41.4146Z"
          fill="white"
        />
        <path
          d="M136.638 19.7086L136.415 19.5973C136.304 19.5973 136.304 19.4859 136.304 19.3746L136.415 19.152C136.415 19.0407 136.526 19.0407 136.638 19.0407L136.86 19.152C136.972 19.152 136.972 19.2633 136.972 19.3746L136.86 19.5973C136.749 19.7086 136.638 19.8199 136.638 19.7086Z"
          fill="white"
        />
        <path
          d="M132.518 51.3218L132.296 51.2105C132.185 51.2105 132.185 51.0992 132.185 50.9878L132.296 50.7652C132.296 50.6539 132.407 50.6539 132.518 50.6539L132.741 50.7652C132.852 50.7652 132.852 50.8765 132.852 50.9878L132.741 51.2105C132.63 51.3218 132.518 51.4331 132.518 51.3218Z"
          fill="white"
        />
        <path
          d="M119.606 21.1559L119.384 21.0446C119.272 21.0446 119.272 20.9333 119.272 20.822L119.384 20.5994C119.384 20.488 119.495 20.488 119.606 20.488L119.829 20.5994C119.94 20.5994 119.94 20.7107 119.94 20.822L119.829 21.0446C119.829 21.1559 119.718 21.1559 119.606 21.1559Z"
          fill="white"
        />
        <path
          d="M108.698 62.1186L108.476 62.0072C108.364 62.0072 108.364 61.8959 108.364 61.7846L108.476 61.562C108.476 61.4507 108.587 61.4507 108.698 61.4507L108.921 61.562C109.032 61.562 109.032 61.6733 109.032 61.7846L108.921 62.0072C108.81 62.1186 108.81 62.1186 108.698 62.1186Z"
          fill="white"
        />
        <path
          d="M112.705 40.6352H112.482C112.371 40.6352 112.371 40.5239 112.371 40.4126L112.482 40.1899C112.482 40.0786 112.594 40.0786 112.705 40.0786L112.928 40.1899C113.039 40.1899 113.039 40.3012 113.039 40.4126L112.928 40.6352C112.928 40.6352 112.816 40.7465 112.705 40.6352Z"
          fill="white"
        />
        <path
          d="M185.949 30.3946L185.727 30.2833C185.615 30.2833 185.615 30.172 185.615 30.0607L185.727 29.8381C185.727 29.7268 185.838 29.7267 185.949 29.7267L186.172 29.8381C186.283 29.8381 186.283 29.9494 186.283 30.0607L186.172 30.2833C186.06 30.3946 186.06 30.3946 185.949 30.3946Z"
          fill="white"
        />
        <path
          d="M195.521 51.7677L195.299 51.6564C195.188 51.6564 195.188 51.545 195.188 51.4337L195.299 51.2111C195.299 51.0998 195.41 51.0998 195.521 51.0998L195.744 51.2111C195.855 51.2111 195.855 51.3224 195.855 51.4337L195.744 51.6564C195.633 51.7677 195.521 51.879 195.521 51.7677Z"
          fill="white"
        />
        <path
          d="M217.895 49.7637L217.673 49.6524C217.562 49.6524 217.562 49.5411 217.562 49.4298L217.673 49.2071C217.673 49.0958 217.784 49.0958 217.895 49.0958L218.118 49.2071C218.229 49.2071 218.229 49.3184 218.229 49.4298L218.118 49.6524C218.007 49.7637 217.895 49.875 217.895 49.7637Z"
          fill="white"
        />
        <path
          d="M232.7 43.1963L232.477 43.085C232.366 43.085 232.366 42.9737 232.366 42.8624L232.477 42.6397C232.477 42.5284 232.589 42.5284 232.7 42.5284L232.923 42.6397C233.034 42.6397 233.034 42.751 233.034 42.8624L232.923 43.085C232.811 43.1963 232.7 43.1963 232.7 43.1963Z"
          fill="white"
        />
        <path
          d="M134.411 70.3556H134.188C134.077 70.3556 134.077 70.2443 134.077 70.2443V70.0216C134.077 69.9103 134.188 69.9103 134.188 69.9103H134.411C134.522 69.9103 134.522 70.0216 134.522 70.0216V70.2443C134.522 70.2443 134.522 70.3556 134.411 70.3556Z"
          fill="white"
        />
        <path
          d="M161.015 53.1033L160.792 52.992C160.681 52.992 160.681 52.8806 160.681 52.7693L160.792 52.5467C160.792 52.4354 160.903 52.4354 161.015 52.4354L161.237 52.5467C161.349 52.5467 161.349 52.658 161.349 52.7693L161.237 52.992C161.126 53.1033 161.126 53.1033 161.015 53.1033Z"
          fill="white"
        />
        <path
          d="M98.6797 44.531L98.457 44.4196C98.3457 44.4196 98.3457 44.3083 98.3457 44.197L98.457 43.9744C98.457 43.8631 98.5683 43.8631 98.6797 43.8631L98.9023 43.9744C99.0136 43.9744 99.0136 44.0857 99.0136 44.197L98.9023 44.4196C98.791 44.5309 98.791 44.531 98.6797 44.531Z"
          fill="white"
        />
        <path
          d="M144.651 63.7883L144.429 63.677C144.317 63.677 144.317 63.5657 144.317 63.4544L144.429 63.2318C144.429 63.1205 144.54 63.1205 144.651 63.1205L144.874 63.2318C144.985 63.2318 144.985 63.3431 144.985 63.4544L144.874 63.677C144.763 63.7883 144.763 63.7883 144.651 63.7883Z"
          fill="white"
        />
        <path
          d="M170.922 25.1628L170.699 25.0515C170.588 25.0515 170.588 24.9402 170.588 24.8289L170.699 24.6063C170.699 24.4949 170.811 24.4949 170.922 24.4949L171.144 24.6063C171.256 24.6063 171.256 24.7176 171.256 24.8289L171.144 25.0515C171.144 25.1628 171.033 25.1628 170.922 25.1628Z"
          fill="white"
        />
      </g>
      <path
        opacity="0.15"
        d="M63.3927 95.5124L7.73633 127.682V77.1458L63.3927 44.9764V95.5124Z"
        fill="url(#paint56_linear_461_8313)"
      />
      <g opacity="0.2">
        <path
          d="M10.2969 97.2943L60.0537 68.5756"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M10.2969 86.2732L60.0537 57.5544"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M10.2969 108.202L60.0537 79.5948"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M10.2969 119.221L60.0537 90.614"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M54.8223 93.6202L56.492 92.6184V61.1168L54.8223 62.1186V93.6202Z"
        fill="url(#paint57_linear_461_8313)"
      />
      <path
        d="M49.5908 96.6261L51.2605 95.6243V73.5844L49.5908 74.5862V96.6261Z"
        fill="url(#paint58_linear_461_8313)"
      />
      <path
        d="M44.3584 99.6317L46.1394 98.6299V62.6759L44.3584 63.6777V99.6317Z"
        fill="url(#paint59_linear_461_8313)"
      />
      <path
        d="M39.2393 102.637L40.9089 101.635V89.168L39.2393 90.0585V102.637Z"
        fill="url(#paint60_linear_461_8313)"
      />
      <path
        d="M34.0078 105.531L35.6775 104.64V85.8285L34.0078 86.8303V105.531Z"
        fill="url(#paint61_linear_461_8313)"
      />
      <path
        d="M28.7754 108.537L30.5564 107.535V77.7029L28.7754 78.7048V108.537Z"
        fill="url(#paint62_linear_461_8313)"
      />
      <path
        d="M23.6543 111.541L25.324 110.539V96.4028L23.6543 97.2933V111.541Z"
        fill="url(#paint63_linear_461_8313)"
      />
      <path
        d="M18.4229 114.546L20.2039 113.544V98.1833L18.4229 99.1851V114.546Z"
        fill="url(#paint64_linear_461_8313)"
      />
      <path
        d="M13.3027 117.553L14.9724 116.551V95.7354L13.3027 96.7373V117.553Z"
        fill="url(#paint65_linear_461_8313)"
      />
      <path
        opacity="0.15"
        d="M260.417 97.0715L316.073 129.241V78.8162L260.417 46.6468V97.0715Z"
        fill="url(#paint66_linear_461_8313)"
      />
      <g opacity="0.2">
        <path
          d="M313.514 98.8509L263.757 70.1322"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M313.514 87.8313L263.757 59.2239"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M313.514 109.871L263.757 81.1524"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M313.514 120.89L263.757 92.1716"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
      </g>
      <path
        opacity="0.6"
        d="M269.434 68.5738C271.883 70.0209 272.662 83.3784 275.778 85.1594C278.895 86.9404 277.559 74.0281 280.008 75.5865C283.014 77.4788 281.455 94.1758 285.574 96.6246C289.693 99.0735 291.028 76.477 295.37 78.8146C299.822 81.1522 298.598 96.9586 301.714 98.7396C304.942 100.521 304.72 95.6228 306.946 96.8473C308.95 97.9604 310.953 106.198 311.621 110.093L311.287 120.223L262.755 92.1721L263.979 83.1558C265.76 75.03 267.541 67.572 269.434 68.5738Z"
        fill="url(#paint67_linear_461_8313)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_461_8313"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(163.14 192.69) rotate(30.0007) scale(97.1912 97.1969)"
        >
          <stop stopColor="#000020" />
          <stop offset="0.2222" stopColor="#0A113B" />
          <stop offset="0.365" stopColor="#0C1340" />
          <stop offset="0.5278" stopColor="#11194D" />
          <stop offset="0.7005" stopColor="#192364" />
          <stop offset="0.8789" stopColor="#253184" />
          <stop offset="1" stopColor="#2F3C9E" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_461_8313"
          x1="159.289"
          y1="46.4232"
          x2="174.811"
          y2="92.3148"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84E4A4" />
          <stop offset="1" stopColor="#68B69D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_461_8313"
          x1="162.207"
          y1="65.6508"
          x2="132.343"
          y2="81.0042"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_461_8313"
          x1="135.489"
          y1="69.3626"
          x2="141.686"
          y2="69.3626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_461_8313"
          x1="135.534"
          y1="64.2999"
          x2="141.791"
          y2="64.2999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_461_8313"
          x1="136.042"
          y1="74.4235"
          x2="142.572"
          y2="74.4235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_461_8313"
          x1="137.456"
          y1="79.4867"
          x2="144.379"
          y2="79.4867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_461_8313"
          x1="136.247"
          y1="59.2385"
          x2="142.85"
          y2="59.2385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_461_8313"
          x1="137.856"
          y1="54.1787"
          x2="144.866"
          y2="54.1787"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_461_8313"
          x1="141.275"
          y1="48.1055"
          x2="148.998"
          y2="48.1055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_461_8313"
          x1="146.125"
          y1="43.0426"
          x2="155.186"
          y2="43.0426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_461_8313"
          x1="140.566"
          y1="85.5586"
          x2="148.138"
          y2="85.5586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_461_8313"
          x1="144.937"
          y1="90.6209"
          x2="153.581"
          y2="90.6209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_461_8313"
          x1="179.007"
          y1="48.0798"
          x2="155.634"
          y2="86.6137"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" stopColor="#000067" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_461_8313"
          x1="177.901"
          y1="50.2362"
          x2="157.054"
          y2="84.6062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" stopColor="#000067" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_461_8313"
          x1="107.72"
          y1="27.7353"
          x2="114.099"
          y2="43.4299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84E4A4" />
          <stop offset="1" stopColor="#68B69D" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_461_8313"
          x1="111.341"
          y1="33.4917"
          x2="122.755"
          y2="30.7309"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_461_8313"
          x1="119.262"
          y1="28.3677"
          x2="117.621"
          y2="29.784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_461_8313"
          x1="118.093"
          y1="27.0395"
          x2="116.437"
          y2="28.4695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_461_8313"
          x1="120.272"
          y1="29.8354"
          x2="118.544"
          y2="31.3275"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_461_8313"
          x1="121.055"
          y1="31.4982"
          x2="119.222"
          y2="33.0804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_461_8313"
          x1="116.747"
          y1="25.8625"
          x2="114.999"
          y2="27.3717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_461_8313"
          x1="115.166"
          y1="24.8898"
          x2="113.31"
          y2="26.4918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_461_8313"
          x1="112.872"
          y1="24.064"
          x2="110.828"
          y2="25.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_461_8313"
          x1="110.432"
          y1="23.8325"
          x2="108.033"
          y2="25.9032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_461_8313"
          x1="121.62"
          y1="33.8164"
          x2="119.615"
          y2="35.5468"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_461_8313"
          x1="121.62"
          y1="36.155"
          x2="119.332"
          y2="38.1305"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_461_8313"
          x1="95.9677"
          y1="30.1378"
          x2="128.003"
          y2="40.518"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_461_8313"
          x1="216.451"
          y1="11.8662"
          x2="194.799"
          y2="25.0257"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84E4A4" />
          <stop offset="1" stopColor="#68B69D" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_461_8313"
          x1="208.816"
          y1="18.5853"
          x2="215.613"
          y2="34.7791"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_461_8313"
          x1="218.268"
          y1="29.0591"
          x2="215.786"
          y2="26.9748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_461_8313"
          x1="219.953"
          y1="27.0158"
          x2="217.447"
          y2="24.9114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_461_8313"
          x1="216.345"
          y1="30.8991"
          x2="213.73"
          y2="28.703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_461_8313"
          x1="214.076"
          y1="32.4524"
          x2="211.303"
          y2="30.1239"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_461_8313"
          x1="221.37"
          y1="24.7485"
          x2="218.725"
          y2="22.5275"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_461_8313"
          x1="222.428"
          y1="22.1813"
          x2="219.62"
          y2="19.8234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_461_8313"
          x1="223.101"
          y1="18.5999"
          x2="220.008"
          y2="16.0023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_461_8313"
          x1="222.86"
          y1="14.9395"
          x2="219.231"
          y2="11.8921"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_461_8313"
          x1="210.787"
          y1="33.8392"
          x2="207.754"
          y2="31.2924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_461_8313"
          x1="207.335"
          y1="34.3967"
          x2="203.873"
          y2="31.4893"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_461_8313"
          x1="210.103"
          y1="-4.91349"
          x2="202.413"
          y2="44.8599"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_461_8313"
          x1="260.781"
          y1="213.679"
          x2="87.2729"
          y2="159.195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_461_8313"
          x1="158.001"
          y1="132.826"
          x2="159.144"
          y2="237.434"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_461_8313"
          x1="89.2859"
          y1="133.777"
          x2="195.319"
          y2="191.613"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.8175" stopColor="#3C53D7" />
          <stop offset="1" stopColor="#2B29C6" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_461_8313"
          x1="180.415"
          y1="202.594"
          x2="156.099"
          y2="150.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_461_8313"
          x1="158.676"
          y1="129.541"
          x2="159.533"
          y2="207.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_461_8313"
          x1="158.999"
          y1="132.825"
          x2="159.763"
          y2="202.782"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_461_8313"
          x1="178.937"
          y1="184.026"
          x2="156.155"
          y2="135.067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_461_8313"
          x1="158.57"
          y1="115.585"
          x2="159.373"
          y2="189.055"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_461_8313"
          x1="158.872"
          y1="118.663"
          x2="159.588"
          y2="184.206"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_461_8313"
          x1="174.835"
          y1="160.65"
          x2="153.441"
          y2="114.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_461_8313"
          x1="157.9"
          y1="94.2799"
          x2="158.653"
          y2="163.278"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_461_8313"
          x1="150.207"
          y1="109.719"
          x2="174.538"
          y2="153.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_461_8313"
          x1="164.321"
          y1="129.349"
          x2="150.354"
          y2="99.3321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#35498E" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_461_8313"
          x1="160.58"
          y1="105.567"
          x2="161.02"
          y2="145.858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#62A4A1" />
          <stop offset="1" stopColor="#2F3C9E" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_461_8313"
          x1="160.758"
          y1="8.37833"
          x2="165.418"
          y2="123.136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1EBF9" stopOpacity="0" />
          <stop offset="0.252" stopColor="#F2EEFA" stopOpacity="0" />
          <stop offset="0.2989" stopColor="#F3F0FA" stopOpacity="0" />
          <stop offset="0.4873" stopColor="#EDF9FD" stopOpacity="0.137" />
          <stop offset="0.5741" stopColor="#E9FFFF" stopOpacity="0.2" />
          <stop offset="1" stopColor="#E6FFFF" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_461_8313"
          x1="17.8148"
          y1="69.3652"
          x2="60.4891"
          y2="93.9178"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_461_8313"
          x1="55.6231"
          y1="93.8684"
          x2="42.6356"
          y2="71.3742"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_461_8313"
          x1="50.4352"
          y1="96.8644"
          x2="37.4477"
          y2="74.3701"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_461_8313"
          x1="45.2463"
          y1="99.7201"
          x2="34.6317"
          y2="81.3356"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_461_8313"
          x1="40.0593"
          y1="102.855"
          x2="27.0718"
          y2="80.3606"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_461_8313"
          x1="34.8714"
          y1="105.85"
          x2="21.8839"
          y2="83.3558"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_461_8313"
          x1="29.6825"
          y1="108.846"
          x2="16.6951"
          y2="86.3515"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_461_8313"
          x1="24.4935"
          y1="111.841"
          x2="11.5061"
          y2="89.3463"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_461_8313"
          x1="19.3057"
          y1="114.836"
          x2="6.31826"
          y2="92.3412"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_461_8313"
          x1="14.1178"
          y1="117.832"
          x2="1.13026"
          y2="95.3375"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_461_8313"
          x1="305.978"
          y1="70.9748"
          x2="263.304"
          y2="95.5274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_461_8313"
          x1="293.228"
          y1="89.0942"
          x2="284.735"
          y2="102.584"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const DerivableLogoMini = () => {
  return (
    <svg width="107" height="26" viewBox="0 0 1698 413" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_166_7744" fill="white">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M107 217C107 212.582 110.582 209 115 209H176.3C180.719 209 184.3 212.582 184.3 217V268.847L224.227 301.76H315.441C319.859 301.76 323.441 305.342 323.441 309.76V401.981C323.441 406.399 319.859 409.981 315.441 409.981H218.067C213.649 409.981 210.067 406.399 210.067 401.981V322.046L166.704 286.3H115C110.582 286.3 107 282.719 107 278.3V217Z"/>
      </mask>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M107 217C107 212.582 110.582 209 115 209H176.3C180.719 209 184.3 212.582 184.3 217V268.847L224.227 301.76H315.441C319.859 301.76 323.441 305.342 323.441 309.76V401.981C323.441 406.399 319.859 409.981 315.441 409.981H218.067C213.649 409.981 210.067 406.399 210.067 401.981V322.046L166.704 286.3H115C110.582 286.3 107 282.719 107 278.3V217Z" fill="#87DEB5"/>
      <path d="M184.3 268.847H183.109V269.409L183.543 269.766L184.3 268.847ZM224.227 301.76L223.47 302.679L223.799 302.951H224.227V301.76ZM210.067 322.046H211.258V321.484L210.825 321.127L210.067 322.046ZM166.704 286.3L167.462 285.381L167.132 285.109H166.704V286.3ZM115 207.809C109.924 207.809 105.809 211.924 105.809 217H108.191C108.191 213.239 111.239 210.191 115 210.191V207.809ZM176.3 207.809H115V210.191H176.3V207.809ZM185.491 217C185.491 211.924 181.376 207.809 176.3 207.809V210.191C180.061 210.191 183.109 213.239 183.109 217H185.491ZM185.491 268.847V217H183.109V268.847H185.491ZM183.543 269.766L223.47 302.679L224.985 300.841L185.058 267.928L183.543 269.766ZM315.441 300.569H224.227V302.951H315.441V300.569ZM324.632 309.76C324.632 304.684 320.517 300.569 315.441 300.569V302.951C319.201 302.951 322.25 306 322.25 309.76H324.632ZM324.632 401.981V309.76H322.25V401.981H324.632ZM315.441 411.172C320.517 411.172 324.632 407.057 324.632 401.981H322.25C322.25 405.741 319.201 408.79 315.441 408.79V411.172ZM218.067 411.172H315.441V408.79H218.067V411.172ZM208.876 401.981C208.876 407.057 212.991 411.172 218.067 411.172V408.79C214.306 408.79 211.258 405.741 211.258 401.981H208.876ZM208.876 322.046V401.981H211.258V322.046H208.876ZM210.825 321.127L167.462 285.381L165.947 287.219L209.31 322.965L210.825 321.127ZM115 287.491H166.704V285.109H115V287.491ZM105.809 278.3C105.809 283.376 109.924 287.491 115 287.491V285.109C111.239 285.109 108.191 282.061 108.191 278.3H105.809ZM105.809 217V278.3H108.191V217H105.809Z" fill="#2A2A2A" mask="url(#path-1-inside-1_166_7744)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M191.232 410H8C3.58173 410 0 406.418 0 402V7.99999C0 3.58171 3.58172 0 8 0H315C319.418 0 323 3.58172 323 8V100.017C323 104.435 319.418 108.017 315 108.017H160.582C156.164 108.017 152.582 111.599 152.582 116.017V147C152.582 151.418 156.164 155 160.582 155H233C237.418 155 241 158.582 241 163V245.725C241 250.143 237.418 253.725 233 253.725H204.3V217C204.3 201.536 191.764 189 176.3 189H115C99.536 189 87 201.536 87 217V278.3C87 293.764 99.536 306.3 115 306.3H159.523L190.067 331.479V401.981C190.067 404.768 190.474 407.46 191.232 410Z" fill="#87DEB5"/>
      <mask id="path-4-outside-2_166_7744" maskUnits="userSpaceOnUse" x="349" y="153" width="1350" height="261" fill="black">
      <rect fill="white" x="349" y="153" width="1350" height="261"/>
      <path d="M512.878 158.676H582.75V410H512.878L419.835 269.544V410H349.963V158.676H419.835L512.878 300.915V158.676ZM714.881 158.676C795.091 158.676 846.069 210.367 846.069 284.16C846.069 356.883 795.091 410 714.881 410H615.421V158.676H714.881ZM685.293 348.328H709.534C749.817 348.328 775.128 325.512 775.128 284.16C775.128 242.451 749.817 219.279 709.534 219.279H685.293V348.328ZM869.366 304.48V158.676H938.881V304.48C938.881 330.503 950.645 346.902 977.025 346.902C1003.41 346.902 1015.88 330.503 1015.88 304.48V158.676H1085.75V304.48C1085.75 376.134 1035.85 412.495 975.599 412.495C914.996 412.495 869.366 376.134 869.366 304.48ZM1250.06 243.164C1250.06 227.478 1240.44 217.14 1221.55 217.14H1186.97V269.544H1221.55C1240.44 269.544 1250.06 260.275 1250.06 243.164ZM1117.09 158.676H1227.25C1289.63 158.676 1321.01 194.325 1321.01 239.242C1321.01 272.039 1303.18 300.558 1265.75 311.966L1322.43 410H1244.36L1194.45 317.313H1186.97V410H1117.09V158.676ZM1345.65 410V158.676H1415.52V410H1345.65ZM1697.37 283.447C1697.37 359.022 1639.97 412.495 1568.68 412.495C1497.38 412.495 1439.63 359.022 1439.63 283.447C1439.63 207.871 1497.38 154.755 1568.68 154.755C1640.33 154.755 1697.37 207.871 1697.37 283.447ZM1510.92 283.447C1510.92 322.304 1532.31 347.615 1568.68 347.615C1604.68 347.615 1626.43 322.304 1626.43 283.447C1626.43 243.877 1604.68 218.923 1568.68 218.923C1532.31 218.923 1510.92 243.877 1510.92 283.447Z"/>
      </mask>
      <path d="M512.878 158.676H582.75V410H512.878L419.835 269.544V410H349.963V158.676H419.835L512.878 300.915V158.676ZM714.881 158.676C795.091 158.676 846.069 210.367 846.069 284.16C846.069 356.883 795.091 410 714.881 410H615.421V158.676H714.881ZM685.293 348.328H709.534C749.817 348.328 775.128 325.512 775.128 284.16C775.128 242.451 749.817 219.279 709.534 219.279H685.293V348.328ZM869.366 304.48V158.676H938.881V304.48C938.881 330.503 950.645 346.902 977.025 346.902C1003.41 346.902 1015.88 330.503 1015.88 304.48V158.676H1085.75V304.48C1085.75 376.134 1035.85 412.495 975.599 412.495C914.996 412.495 869.366 376.134 869.366 304.48ZM1250.06 243.164C1250.06 227.478 1240.44 217.14 1221.55 217.14H1186.97V269.544H1221.55C1240.44 269.544 1250.06 260.275 1250.06 243.164ZM1117.09 158.676H1227.25C1289.63 158.676 1321.01 194.325 1321.01 239.242C1321.01 272.039 1303.18 300.558 1265.75 311.966L1322.43 410H1244.36L1194.45 317.313H1186.97V410H1117.09V158.676ZM1345.65 410V158.676H1415.52V410H1345.65ZM1697.37 283.447C1697.37 359.022 1639.97 412.495 1568.68 412.495C1497.38 412.495 1439.63 359.022 1439.63 283.447C1439.63 207.871 1497.38 154.755 1568.68 154.755C1640.33 154.755 1697.37 207.871 1697.37 283.447ZM1510.92 283.447C1510.92 322.304 1532.31 347.615 1568.68 347.615C1604.68 347.615 1626.43 322.304 1626.43 283.447C1626.43 243.877 1604.68 218.923 1568.68 218.923C1532.31 218.923 1510.92 243.877 1510.92 283.447Z" fill="#F2F2F2"/>
      <path d="M512.878 158.676V157.89H512.092V158.676H512.878ZM582.75 158.676H583.536V157.89H582.75V158.676ZM582.75 410V410.786H583.536V410H582.75ZM512.878 410L512.223 410.434L512.456 410.786H512.878V410ZM419.835 269.544L420.49 269.11L419.049 266.934V269.544H419.835ZM419.835 410V410.786H420.621V410H419.835ZM349.963 410H349.177V410.786H349.963V410ZM349.963 158.676V157.89H349.177V158.676H349.963ZM419.835 158.676L420.493 158.246L420.26 157.89H419.835V158.676ZM512.878 300.915L512.22 301.345L513.664 303.552V300.915H512.878ZM512.878 159.462H582.75V157.89H512.878V159.462ZM581.964 158.676V410H583.536V158.676H581.964ZM582.75 409.214H512.878V410.786H582.75V409.214ZM513.534 409.566L420.49 269.11L419.18 269.978L512.223 410.434L513.534 409.566ZM419.049 269.544V410H420.621V269.544H419.049ZM419.835 409.214H349.963V410.786H419.835V409.214ZM350.749 410V158.676H349.177V410H350.749ZM349.963 159.462H419.835V157.89H349.963V159.462ZM419.177 159.106L512.22 301.345L513.536 300.484L420.493 158.246L419.177 159.106ZM513.664 300.915V158.676H512.092V300.915H513.664ZM615.421 410H614.635V410.786H615.421V410ZM615.421 158.676V157.89H614.635V158.676H615.421ZM685.293 348.328H684.507V349.114H685.293V348.328ZM685.293 219.279V218.493H684.507V219.279H685.293ZM714.881 159.462C754.815 159.462 787.404 172.326 810.006 194.309C832.607 216.291 845.283 247.449 845.283 284.16H846.855C846.855 247.077 834.042 215.494 811.102 193.182C788.162 170.871 755.158 157.89 714.881 157.89V159.462ZM845.283 284.16C845.283 320.333 832.608 351.584 810.003 373.79C787.398 395.997 754.809 409.214 714.881 409.214V410.786C755.164 410.786 788.168 397.445 811.105 374.912C834.041 352.379 846.855 320.71 846.855 284.16H845.283ZM714.881 409.214H615.421V410.786H714.881V409.214ZM616.207 410V158.676H614.635V410H616.207ZM615.421 159.462H714.881V157.89H615.421V159.462ZM685.293 349.114H709.534V347.542H685.293V349.114ZM709.534 349.114C729.821 349.114 746.434 343.367 757.981 332.319C769.532 321.266 775.914 304.999 775.914 284.16H774.342C774.342 304.673 768.068 320.49 756.894 331.183C745.714 341.881 729.531 347.542 709.534 347.542V349.114ZM775.914 284.16C775.914 263.144 769.533 246.701 757.984 235.514C746.439 224.331 729.824 218.493 709.534 218.493V220.065C729.528 220.065 745.71 225.813 756.89 236.643C768.067 247.469 774.342 263.466 774.342 284.16H775.914ZM709.534 218.493H685.293V220.065H709.534V218.493ZM684.507 219.279V348.328H686.079V219.279H684.507ZM869.366 158.676V157.89H868.58V158.676H869.366ZM938.881 158.676H939.667V157.89H938.881V158.676ZM1015.88 158.676V157.89H1015.1V158.676H1015.88ZM1085.75 158.676H1086.54V157.89H1085.75V158.676ZM870.152 304.48V158.676H868.58V304.48H870.152ZM869.366 159.462H938.881V157.89H869.366V159.462ZM938.095 158.676V304.48H939.667V158.676H938.095ZM938.095 304.48C938.095 317.595 941.058 328.411 947.461 335.958C953.884 343.528 963.665 347.688 977.025 347.688V346.116C964.006 346.116 954.714 342.076 948.66 334.941C942.587 327.783 939.667 317.388 939.667 304.48H938.095ZM977.025 347.688C990.385 347.688 1000.34 343.529 1006.94 335.966C1013.52 328.422 1016.67 317.605 1016.67 304.48H1015.1C1015.1 317.378 1012 327.772 1005.75 334.933C999.521 342.075 990.046 346.116 977.025 346.116V347.688ZM1016.67 304.48V158.676H1015.1V304.48H1016.67ZM1015.88 159.462H1085.75V157.89H1015.88V159.462ZM1084.97 158.676V304.48H1086.54V158.676H1084.97ZM1084.97 304.48C1084.97 340.112 1072.57 366.894 1052.74 384.774C1032.91 402.666 1005.57 411.709 975.599 411.709V413.281C1005.88 413.281 1033.62 404.144 1053.8 385.941C1073.99 367.728 1086.54 340.501 1086.54 304.48H1084.97ZM975.599 411.709C945.452 411.709 919.104 402.667 900.298 384.788C881.5 366.916 870.152 340.134 870.152 304.48H868.58C868.58 340.48 880.048 367.705 899.215 385.927C918.375 404.143 945.144 413.281 975.599 413.281V411.709ZM1186.97 217.14V216.354H1186.18V217.14H1186.97ZM1186.97 269.544H1186.18V270.33H1186.97V269.544ZM1117.09 158.676V157.89H1116.31V158.676H1117.09ZM1265.75 311.966L1265.52 311.214L1264.57 311.502L1265.07 312.359L1265.75 311.966ZM1322.43 410V410.786H1323.79L1323.11 409.607L1322.43 410ZM1244.36 410L1243.67 410.373L1243.89 410.786H1244.36V410ZM1194.45 317.313L1195.14 316.941L1194.92 316.527H1194.45V317.313ZM1186.97 317.313V316.527H1186.18V317.313H1186.97ZM1186.97 410V410.786H1187.75V410H1186.97ZM1117.09 410H1116.31V410.786H1117.09V410ZM1250.85 243.164C1250.85 235.159 1248.39 228.427 1243.43 223.701C1238.48 218.979 1231.13 216.354 1221.55 216.354V217.926C1230.85 217.926 1237.77 220.471 1242.35 224.839C1246.93 229.203 1249.28 235.483 1249.28 243.164H1250.85ZM1221.55 216.354H1186.97V217.926H1221.55V216.354ZM1186.18 217.14V269.544H1187.75V217.14H1186.18ZM1186.97 270.33H1221.55V268.758H1186.97V270.33ZM1221.55 270.33C1231.11 270.33 1238.46 267.984 1243.43 263.345C1248.4 258.697 1250.85 251.865 1250.85 243.164H1249.28C1249.28 251.574 1246.92 257.932 1242.35 262.196C1237.78 266.469 1230.87 268.758 1221.55 268.758V270.33ZM1117.09 159.462H1227.25V157.89H1117.09V159.462ZM1227.25 159.462C1258.29 159.462 1281.52 168.33 1296.99 182.691C1312.45 197.05 1320.22 216.972 1320.22 239.242H1321.79C1321.79 216.596 1313.88 196.234 1298.06 181.539C1282.24 166.847 1258.59 157.89 1227.25 157.89V159.462ZM1320.22 239.242C1320.22 271.709 1302.61 299.912 1265.52 311.214L1265.98 312.718C1303.76 301.205 1321.79 272.369 1321.79 239.242H1320.22ZM1265.07 312.359L1321.75 410.393L1323.11 409.607L1266.43 311.572L1265.07 312.359ZM1322.43 409.214H1244.36V410.786H1322.43V409.214ZM1245.05 409.627L1195.14 316.941L1193.76 317.686L1243.67 410.373L1245.05 409.627ZM1194.45 316.527H1186.97V318.099H1194.45V316.527ZM1186.18 317.313V410H1187.75V317.313H1186.18ZM1186.97 409.214H1117.09V410.786H1186.97V409.214ZM1117.88 410V158.676H1116.31V410H1117.88ZM1345.65 410H1344.86V410.786H1345.65V410ZM1345.65 158.676V157.89H1344.86V158.676H1345.65ZM1415.52 158.676H1416.31V157.89H1415.52V158.676ZM1415.52 410V410.786H1416.31V410H1415.52ZM1346.44 410V158.676H1344.86V410H1346.44ZM1345.65 159.462H1415.52V157.89H1345.65V159.462ZM1414.74 158.676V410H1416.31V158.676H1414.74ZM1415.52 409.214H1345.65V410.786H1415.52V409.214ZM1696.58 283.447C1696.58 358.574 1639.55 411.709 1568.68 411.709V413.281C1640.39 413.281 1698.15 359.471 1698.15 283.447H1696.58ZM1568.68 411.709C1497.79 411.709 1440.41 358.571 1440.41 283.447H1438.84C1438.84 359.473 1496.96 413.281 1568.68 413.281V411.709ZM1440.41 283.447C1440.41 208.325 1497.79 155.541 1568.68 155.541V153.969C1496.96 153.969 1438.84 207.417 1438.84 283.447H1440.41ZM1568.68 155.541C1639.91 155.541 1696.58 208.321 1696.58 283.447H1698.15C1698.15 207.422 1640.75 153.969 1568.68 153.969V155.541ZM1510.14 283.447C1510.14 303.014 1515.52 319.259 1525.58 330.623C1535.64 341.999 1550.3 348.401 1568.68 348.401V346.829C1550.69 346.829 1536.48 340.575 1526.75 329.581C1517.02 318.576 1511.71 302.737 1511.71 283.447H1510.14ZM1568.68 348.401C1586.87 348.401 1601.54 341.998 1611.64 330.624C1621.74 319.262 1627.21 303.017 1627.21 283.447H1625.64C1625.64 302.734 1620.24 318.573 1610.47 329.58C1600.7 340.576 1586.48 346.829 1568.68 346.829V348.401ZM1627.21 283.447C1627.21 263.523 1621.74 247.188 1611.64 235.824C1601.53 224.448 1586.87 218.137 1568.68 218.137V219.709C1586.49 219.709 1600.7 225.874 1610.47 236.868C1620.24 247.873 1625.64 263.8 1625.64 283.447H1627.21ZM1568.68 218.137C1550.3 218.137 1535.64 224.447 1525.58 235.825C1515.52 247.191 1510.14 263.526 1510.14 283.447H1511.71C1511.71 263.797 1517.02 247.871 1526.75 236.867C1536.47 225.875 1550.68 219.709 1568.68 219.709V218.137Z" fill="#2A2A2A" mask="url(#path-4-outside-2_166_7744)"/>
      <path d="M107 217C107 212.582 110.582 209 115 209H176.3C180.719 209 184.3 212.582 184.3 217V268.847L224.227 301.76H315.441C319.859 301.76 323.441 305.342 323.441 309.76V401.981C323.441 406.399 319.859 409.981 315.441 409.981H218.067C213.649 409.981 210.067 406.399 210.067 401.981V322.046L166.704 286.3H115C110.582 286.3 107 282.719 107 278.3V217Z" fill="#F2F2F2"/>
    </svg>
  )
};

const DiscoverBannerMobile = () => {
  return (
    <svg
      width="295"
      height="229"
      viewBox="0 0 295 229"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          opacity="0.6"
          d="M128.904 219.437L25.7809 160.055C21.1431 157.418 21.7797 152.689 27.0541 149.597L119.628 96.1263C124.993 93.0344 133.087 92.7616 137.725 95.3987L240.848 154.781C245.485 157.418 244.849 162.147 239.574 165.239L146.909 218.71C141.635 221.711 133.451 222.074 128.904 219.437Z"
          fill="url(#paint0_radial_455_18271)"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M52.0615 207.983L76.5236 193.888L101.531 191.251L121.447 202.709L138.998 202.072L154.275 193.251"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M100.803 196.433L120.082 207.618L140.725 206.8L167.187 191.522"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M155.366 193.706C154.821 194.07 153.911 194.07 153.366 193.706C152.82 193.343 152.82 192.888 153.366 192.524C153.911 192.16 154.821 192.16 155.366 192.524C155.912 192.888 155.912 193.434 155.366 193.706Z"
          fill="#2A49F9"
        />
        <path
          d="M168.279 191.978C167.734 192.342 166.824 192.342 166.279 191.978C165.733 191.614 165.733 191.159 166.279 190.796C166.824 190.432 167.734 190.432 168.279 190.796C168.825 191.159 168.825 191.705 168.279 191.978Z"
          fill="#2A49F9"
        />
        <path
          d="M141.817 207.256C141.271 207.619 140.362 207.619 139.816 207.256C139.27 206.892 139.27 206.437 139.816 206.073C140.362 205.71 141.271 205.71 141.817 206.073C142.362 206.437 142.362 206.983 141.817 207.256Z"
          fill="#2A49F9"
        />
        <path
          d="M138.996 202.89C139.8 202.89 140.451 202.523 140.451 202.071C140.451 201.619 139.8 201.253 138.996 201.253C138.193 201.253 137.542 201.619 137.542 202.071C137.542 202.523 138.193 202.89 138.996 202.89Z"
          fill="#2A49F9"
        />
        <path
          d="M102.531 191.978C101.986 192.342 101.076 192.342 100.531 191.978C99.9852 191.614 99.9852 191.159 100.531 190.796C101.076 190.432 101.986 190.432 102.531 190.796C103.077 191.069 103.077 191.614 102.531 191.978Z"
          fill="#2A49F9"
        />
        <path
          d="M101.804 197.07C101.259 197.434 100.349 197.434 99.8037 197.07C99.2581 196.706 99.2581 196.252 99.8037 195.888C100.349 195.524 101.259 195.524 101.804 195.888C102.35 196.252 102.35 196.706 101.804 197.07Z"
          fill="#2A49F9"
        />
        <path
          d="M53.0617 208.528C52.5161 208.892 51.6067 208.892 51.0611 208.528C50.5154 208.164 50.5154 207.71 51.0611 207.346C51.6067 206.982 52.5161 206.982 53.0617 207.346C53.6073 207.71 53.6073 208.255 53.0617 208.528Z"
          fill="#2A49F9"
        />
        <path
          d="M208.02 227.809L183.558 213.714L158.459 211.168L138.635 222.626L120.993 221.898L105.807 213.077"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M159.186 216.35L139.908 227.444L119.265 226.626L92.8931 211.348"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M104.624 213.532C105.17 213.896 106.079 213.896 106.625 213.532C107.17 213.168 107.17 212.714 106.625 212.35C106.079 211.986 105.17 211.986 104.624 212.35C104.078 212.714 104.078 213.259 104.624 213.532Z"
          fill="#2A49F9"
        />
        <path
          d="M91.711 211.894C92.2566 212.258 93.166 212.258 93.7116 211.894C94.2572 211.531 94.2572 211.076 93.7116 210.712C93.166 210.348 92.2566 210.348 91.711 210.712C91.1654 210.985 91.1654 211.531 91.711 211.894Z"
          fill="#2A49F9"
        />
        <path
          d="M118.173 227.172C118.719 227.536 119.628 227.536 120.174 227.172C120.72 226.808 120.72 226.354 120.174 225.99C119.628 225.626 118.719 225.626 118.173 225.99C117.628 226.354 117.628 226.808 118.173 227.172Z"
          fill="#2A49F9"
        />
        <path
          d="M119.992 222.444C120.538 222.808 121.447 222.808 121.993 222.444C122.538 222.081 122.538 221.626 121.993 221.262C121.447 220.898 120.538 220.898 119.992 221.262C119.447 221.626 119.447 222.172 119.992 222.444Z"
          fill="#2A49F9"
        />
        <path
          d="M157.55 211.804C158.095 212.167 159.005 212.167 159.55 211.804C160.096 211.44 160.096 210.985 159.55 210.622C159.005 210.258 158.095 210.258 157.55 210.622C156.913 210.985 156.913 211.44 157.55 211.804Z"
          fill="#2A49F9"
        />
        <path
          d="M158.186 216.895C158.731 217.259 159.641 217.259 160.186 216.895C160.732 216.531 160.732 216.077 160.186 215.713C159.641 215.349 158.731 215.349 158.186 215.713C157.64 216.077 157.64 216.531 158.186 216.895Z"
          fill="#2A49F9"
        />
        <path
          d="M207.02 228.444C207.565 228.808 208.475 228.808 209.02 228.444C209.566 228.08 209.566 227.625 209.02 227.262C208.475 226.898 207.565 226.898 207.02 227.262C206.474 227.625 206.474 228.08 207.02 228.444Z"
          fill="#2A49F9"
        />
        <path
          d="M120.083 193.436L95.6205 179.34L70.5218 176.703L50.6975 188.161L33.1466 187.434L17.8691 178.704"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M71.3403 181.885L52.0616 193.07L31.4188 192.252L4.95605 176.974"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M16.7772 179.157C17.3228 179.521 18.2322 179.521 18.7779 179.157C19.3235 178.793 19.3235 178.338 18.7779 177.975C18.2322 177.611 17.3228 177.611 16.7772 177.975C16.1407 178.338 16.1407 178.884 16.7772 179.157Z"
          fill="#2A49F9"
        />
        <path
          d="M3.77348 177.429C4.3191 177.793 5.22847 177.793 5.77409 177.429C6.31972 177.065 6.31972 176.611 5.77409 176.247C5.22847 175.883 4.3191 175.883 3.77348 176.247C3.22785 176.611 3.22785 177.156 3.77348 177.429Z"
          fill="#2A49F9"
        />
        <path
          d="M30.3277 192.706C30.8733 193.07 31.7827 193.07 32.3283 192.706C32.8739 192.342 32.8739 191.888 32.3283 191.524C31.7827 191.16 30.8733 191.16 30.3277 191.524C29.7821 191.888 29.7821 192.433 30.3277 192.706Z"
          fill="#2A49F9"
        />
        <path
          d="M32.1465 188.069C32.6921 188.433 33.6015 188.433 34.1472 188.069C34.6928 187.705 34.6928 187.251 34.1472 186.887C33.6015 186.523 32.6921 186.523 32.1465 186.887C31.6009 187.251 31.6009 187.705 32.1465 188.069Z"
          fill="#2A49F9"
        />
        <path
          d="M69.6128 177.339C70.1585 177.703 71.0678 177.703 71.6135 177.339C72.1591 176.976 72.1591 176.521 71.6135 176.157C71.0678 175.793 70.1585 175.793 69.6128 176.157C69.0672 176.521 69.0672 177.066 69.6128 177.339Z"
          fill="#2A49F9"
        />
        <path
          d="M70.3409 182.523C70.8865 182.887 71.7959 182.887 72.3415 182.523C72.8871 182.159 72.8871 181.705 72.3415 181.341C71.7959 180.977 70.8865 180.977 70.3409 181.341C69.7952 181.614 69.7952 182.159 70.3409 182.523Z"
          fill="#2A49F9"
        />
        <path
          d="M119.082 193.98C119.627 194.344 120.537 194.344 121.082 193.98C121.628 193.616 121.628 193.162 121.082 192.798C120.537 192.434 119.627 192.434 119.082 192.798C118.536 193.162 118.536 193.707 119.082 193.98Z"
          fill="#2A49F9"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M293.591 146.146L269.129 132.051L244.03 129.505L224.206 140.963L206.655 140.235L191.377 131.415"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M244.849 134.687L225.57 145.782L204.927 144.963L178.464 129.686"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M191.286 132.141C192.09 132.141 192.741 131.774 192.741 131.322C192.741 130.87 192.09 130.504 191.286 130.504C190.482 130.504 189.831 130.87 189.831 131.322C189.831 131.774 190.482 132.141 191.286 132.141Z"
          fill="#2A49F9"
        />
        <path
          d="M177.282 130.23C177.827 130.594 178.737 130.594 179.282 130.23C179.828 129.867 179.828 129.412 179.282 129.048C178.737 128.684 177.827 128.684 177.282 129.048C176.736 129.321 176.736 129.867 177.282 130.23Z"
          fill="#2A49F9"
        />
        <path
          d="M203.836 145.508C204.382 145.872 205.291 145.872 205.837 145.508C206.382 145.144 206.382 144.69 205.837 144.326C205.291 143.962 204.382 143.962 203.836 144.326C203.29 144.69 203.29 145.144 203.836 145.508Z"
          fill="#2A49F9"
        />
        <path
          d="M205.655 140.78C206.2 141.143 207.11 141.143 207.655 140.78C208.201 140.416 208.201 139.961 207.655 139.597C207.11 139.234 206.2 139.234 205.655 139.597C205.109 139.961 205.109 140.507 205.655 140.78Z"
          fill="#2A49F9"
        />
        <path
          d="M243.121 130.14C243.666 130.503 244.576 130.503 245.121 130.14C245.667 129.776 245.667 129.321 245.121 128.958C244.576 128.594 243.666 128.594 243.121 128.958C242.575 129.321 242.575 129.776 243.121 130.14Z"
          fill="#2A49F9"
        />
        <path
          d="M243.848 135.231C244.394 135.595 245.303 135.595 245.849 135.231C246.394 134.867 246.394 134.413 245.849 134.049C245.303 133.685 244.394 133.685 243.848 134.049C243.303 134.413 243.303 134.958 243.848 135.231Z"
          fill="#2A49F9"
        />
        <path
          d="M292.59 146.781C293.136 147.144 294.045 147.144 294.591 146.781C295.137 146.417 295.137 145.962 294.591 145.598C294.045 145.235 293.136 145.235 292.59 145.598C292.045 145.962 292.045 146.417 292.59 146.781Z"
          fill="#2A49F9"
        />
        <path
          d="M174.008 167.608L198.47 153.422L223.569 150.875L243.393 162.334"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M222.75 156.059L242.029 167.153"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M224.478 151.512C223.933 151.876 223.023 151.876 222.478 151.512C221.932 151.148 221.932 150.693 222.478 150.33C223.023 149.966 223.933 149.966 224.478 150.33C225.024 150.693 225.024 151.239 224.478 151.512Z"
          fill="#2A49F9"
        />
        <path
          d="M222.749 156.878C223.553 156.878 224.204 156.511 224.204 156.059C224.204 155.607 223.553 155.241 222.749 155.241C221.946 155.241 221.294 155.607 221.294 156.059C221.294 156.511 221.946 156.878 222.749 156.878Z"
          fill="#2A49F9"
        />
        <path
          d="M175.008 168.154C174.463 168.517 173.553 168.517 173.008 168.154C172.462 167.79 172.462 167.335 173.008 166.971C173.553 166.608 174.463 166.608 175.008 166.971C175.554 167.335 175.554 167.79 175.008 168.154Z"
          fill="#2A49F9"
        />
        <path
          d="M176.827 181.611L201.289 167.516L226.387 164.97L246.212 176.428"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M225.661 170.151L244.939 181.246"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M227.298 165.605C226.752 165.969 225.843 165.969 225.297 165.605C224.751 165.241 224.751 164.787 225.297 164.423C225.843 164.059 226.752 164.059 227.298 164.423C227.843 164.787 227.843 165.241 227.298 165.605Z"
          fill="#2A49F9"
        />
        <path
          d="M226.661 170.697C226.115 171.06 225.206 171.06 224.66 170.697C224.115 170.333 224.115 169.878 224.66 169.514C225.206 169.151 226.115 169.151 226.661 169.514C227.206 169.878 227.206 170.333 226.661 170.697Z"
          fill="#2A49F9"
        />
        <path
          d="M177.827 182.246C177.282 182.61 176.372 182.61 175.827 182.246C175.281 181.882 175.281 181.428 175.827 181.064C176.372 180.7 177.282 180.7 177.827 181.064C178.373 181.337 178.373 181.882 177.827 182.246Z"
          fill="#2A49F9"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M48.606 100.683L73.0681 114.778L98.1668 117.324L117.991 105.866L135.542 106.594L150.819 115.415"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M97.3481 112.14L116.627 101.046L137.27 101.864L163.732 117.141"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M151.91 114.96C151.365 114.596 150.455 114.596 149.91 114.96C149.364 115.324 149.364 115.778 149.91 116.142C150.455 116.506 151.365 116.506 151.91 116.142C152.547 115.778 152.547 115.233 151.91 114.96Z"
          fill="#2A49F9"
        />
        <path
          d="M164.914 116.688C164.368 116.324 163.459 116.324 162.913 116.688C162.368 117.051 162.368 117.506 162.913 117.87C163.459 118.233 164.368 118.233 164.914 117.87C165.459 117.506 165.459 116.96 164.914 116.688Z"
          fill="#2A49F9"
        />
        <path
          d="M138.361 101.319C137.815 100.955 136.906 100.955 136.36 101.319C135.815 101.683 135.815 102.137 136.36 102.501C136.906 102.865 137.815 102.865 138.361 102.501C138.907 102.228 138.907 101.683 138.361 101.319Z"
          fill="#2A49F9"
        />
        <path
          d="M136.543 106.048C135.997 105.684 135.088 105.684 134.542 106.048C133.996 106.411 133.996 106.866 134.542 107.23C135.088 107.594 135.997 107.594 136.543 107.23C137.088 106.866 137.088 106.32 136.543 106.048Z"
          fill="#2A49F9"
        />
        <path
          d="M99.0763 116.688C98.5307 116.324 97.6213 116.324 97.0757 116.688C96.5301 117.051 96.5301 117.506 97.0757 117.87C97.6213 118.233 98.5307 118.233 99.0763 117.87C99.6219 117.506 99.6219 117.051 99.0763 116.688Z"
          fill="#2A49F9"
        />
        <path
          d="M98.3483 111.596C97.8027 111.232 96.8933 111.232 96.3477 111.596C95.8021 111.96 95.8021 112.414 96.3477 112.778C96.8933 113.142 97.8027 113.142 98.3483 112.778C98.8939 112.414 98.8939 111.96 98.3483 111.596Z"
          fill="#2A49F9"
        />
        <path
          d="M49.6066 100.046C49.061 99.6818 48.1516 99.6818 47.606 100.046C47.0604 100.409 47.0604 100.864 47.606 101.228C48.1516 101.591 49.061 101.591 49.6066 101.228C50.1523 100.955 50.1523 100.409 49.6066 100.046Z"
          fill="#2A49F9"
        />
        <path
          d="M204.563 80.7686L180.101 94.9548L155.002 97.5011L135.178 86.043L117.536 86.7705L102.35 95.5914"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M155.729 92.317L136.45 81.2226L115.807 82.0411L89.4355 97.3185"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M101.166 95.0472C101.712 94.6835 102.621 94.6835 103.167 95.0472C103.712 95.411 103.712 95.8657 103.167 96.2294C102.621 96.5932 101.712 96.5932 101.166 96.2294C100.62 95.9566 100.62 95.411 101.166 95.0472Z"
          fill="#2A49F9"
        />
        <path
          d="M88.2535 96.7732C88.7991 96.4095 89.7085 96.4095 90.2541 96.7732C90.7997 97.137 90.7997 97.5917 90.2541 97.9554C89.7085 98.3192 88.7991 98.3192 88.2535 97.9554C87.7078 97.5917 87.7078 97.137 88.2535 96.7732Z"
          fill="#2A49F9"
        />
        <path
          d="M114.807 81.4963C115.352 81.1325 116.262 81.1325 116.807 81.4963C117.353 81.86 117.353 82.3147 116.807 82.6785C116.262 83.0422 115.352 83.0422 114.807 82.6785C114.261 82.3147 114.17 81.86 114.807 81.4963Z"
          fill="#2A49F9"
        />
        <path
          d="M116.535 86.2241C117.08 85.8603 117.99 85.8603 118.535 86.2241C119.081 86.5878 119.081 87.0425 118.535 87.4063C117.99 87.77 117.08 87.77 116.535 87.4063C115.989 87.0425 115.989 86.4969 116.535 86.2241Z"
          fill="#2A49F9"
        />
        <path
          d="M154.092 96.8639C154.638 96.5002 155.547 96.5002 156.093 96.8639C156.639 97.2277 156.639 97.6824 156.093 98.0461C155.547 98.4099 154.638 98.4099 154.092 98.0461C153.547 97.6824 153.547 97.1368 154.092 96.8639Z"
          fill="#2A49F9"
        />
        <path
          d="M155.729 93.1365C156.532 93.1365 157.184 92.7701 157.184 92.3181C157.184 91.8661 156.532 91.4997 155.729 91.4997C154.925 91.4997 154.274 91.8661 154.274 92.3181C154.274 92.7701 154.925 93.1365 155.729 93.1365Z"
          fill="#2A49F9"
        />
        <path
          d="M203.562 80.223C204.107 79.8592 205.017 79.8592 205.562 80.223C206.108 80.5867 206.108 81.0414 205.562 81.4052C205.017 81.7689 204.107 81.7689 203.562 81.4052C203.016 81.0414 203.016 80.5867 203.562 80.223Z"
          fill="#2A49F9"
        />
        <path
          d="M116.627 115.233L92.1649 129.328L67.1572 131.965L47.2419 120.507L29.691 121.144L14.4136 129.965"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M67.8842 126.781L48.6055 115.596L27.9628 116.414L1.5 131.691"
          stroke="#2A49F9"
          strokeWidth="0.5349"
          strokeMiterlimit="10"
        />
        <path
          d="M13.3223 129.508C13.8679 129.145 14.7773 129.145 15.3229 129.508C15.8685 129.872 15.8685 130.327 15.3229 130.691C14.7773 131.054 13.8679 131.054 13.3223 130.691C12.7767 130.327 12.7767 129.781 13.3223 129.508Z"
          fill="#2A49F9"
        />
        <path
          d="M0.409218 131.236C0.954841 130.872 1.86423 130.872 2.40985 131.236C2.95547 131.6 2.95547 132.054 2.40985 132.418C1.86423 132.782 0.954841 132.782 0.409218 132.418C-0.136406 132.054 -0.136406 131.509 0.409218 131.236Z"
          fill="#2A49F9"
        />
        <path
          d="M26.8721 115.867C27.4177 115.504 28.3271 115.504 28.8727 115.867C29.4184 116.231 29.4184 116.686 28.8727 117.05C28.3271 117.413 27.4177 117.413 26.8721 117.05C26.3265 116.777 26.3265 116.231 26.8721 115.867Z"
          fill="#2A49F9"
        />
        <path
          d="M28.691 120.596C29.2366 120.232 30.146 120.232 30.6916 120.596C31.2372 120.96 31.2372 121.415 30.6916 121.778C30.146 122.142 29.2366 122.142 28.691 121.778C28.1453 121.415 28.1453 120.869 28.691 120.596Z"
          fill="#2A49F9"
        />
        <path
          d="M66.1568 131.236C66.7024 130.872 67.6118 130.872 68.1574 131.236C68.703 131.6 68.703 132.054 68.1574 132.418C67.6118 132.782 66.7024 132.782 66.1568 132.418C65.6112 132.145 65.6112 131.6 66.1568 131.236Z"
          fill="#2A49F9"
        />
        <path
          d="M66.8843 126.144C67.4299 125.78 68.3393 125.78 68.8849 126.144C69.4306 126.507 69.4306 126.962 68.8849 127.326C68.3393 127.69 67.4299 127.69 66.8843 127.326C66.3387 126.962 66.3387 126.507 66.8843 126.144Z"
          fill="#2A49F9"
        />
        <path
          d="M116.627 116.05C117.43 116.05 118.082 115.683 118.082 115.231C118.082 114.779 117.43 114.413 116.627 114.413C115.823 114.413 115.172 114.779 115.172 115.231C115.172 115.683 115.823 116.05 116.627 116.05Z"
          fill="#2A49F9"
        />
      </g>
      <path
        d="M135.905 78.2125C124.72 78.2125 115.626 67.8457 115.626 55.0235C115.626 42.2014 124.72 31.8345 135.905 31.8345C147.091 31.8345 156.184 42.2014 156.184 55.0235C156.184 67.8457 147.091 78.2125 135.905 78.2125Z"
        fill="url(#paint1_linear_455_18271)"
      />
      <path
        d="M115.627 55.0235C115.627 43.2017 123.357 33.4714 133.451 32.0164C132.633 31.9255 131.814 31.8345 130.996 31.8345C119.811 31.8345 110.717 42.2014 110.717 55.0235C110.717 67.8457 119.811 78.2125 130.996 78.2125C131.814 78.2125 132.633 78.1216 133.451 78.0307C123.448 76.5757 115.627 66.8454 115.627 55.0235Z"
        fill="url(#paint2_linear_455_18271)"
      />
      <g opacity="0.5">
        <path
          d="M115.628 55.8411H110.626C110.626 56.3867 110.717 56.9323 110.717 57.478H115.718C115.718 56.9323 115.628 56.3867 115.628 55.8411Z"
          fill="url(#paint3_linear_455_18271)"
        />
        <path
          d="M115.809 51.7482H110.808C110.717 52.2939 110.717 52.8395 110.626 53.3851H115.628C115.718 52.8395 115.809 52.2939 115.809 51.7482Z"
          fill="url(#paint4_linear_455_18271)"
        />
        <path
          d="M116.082 59.9331H111.081C111.172 60.4787 111.353 61.0243 111.444 61.57H116.446C116.355 61.1153 116.173 60.5696 116.082 59.9331Z"
          fill="url(#paint5_linear_455_18271)"
        />
        <path
          d="M117.264 64.1175H112.262C112.444 64.6631 112.717 65.2087 112.99 65.7543H117.991C117.718 65.2087 117.446 64.6631 117.264 64.1175Z"
          fill="url(#paint6_linear_455_18271)"
        />
        <path
          d="M116.718 47.5655H111.717C111.535 48.1112 111.444 48.6568 111.262 49.2024H116.264C116.355 48.6568 116.537 48.1112 116.718 47.5655Z"
          fill="url(#paint7_linear_455_18271)"
        />
        <path
          d="M118.356 43.4727H113.354C113.081 44.0183 112.808 44.564 112.626 45.1096H117.628C117.81 44.564 118.083 43.9274 118.356 43.4727Z"
          fill="url(#paint8_linear_455_18271)"
        />
        <path
          d="M121.72 38.4728H116.719C116.264 39.0184 115.809 39.564 115.354 40.1096H120.356C120.811 39.564 121.265 39.0184 121.72 38.4728Z"
          fill="url(#paint9_linear_455_18271)"
        />
        <path
          d="M126.813 34.3799H121.811C120.993 34.8346 120.174 35.3802 119.356 36.0168H124.358C125.085 35.3802 125.903 34.8346 126.813 34.3799Z"
          fill="url(#paint10_linear_455_18271)"
        />
        <path
          d="M119.811 69.0258H114.809C115.173 69.5715 115.628 70.1171 115.991 70.6627H120.993C120.629 70.208 120.174 69.6624 119.811 69.0258Z"
          fill="url(#paint11_linear_455_18271)"
        />
        <path
          d="M118.447 73.2094C119.083 73.846 119.811 74.3916 120.538 74.8463H125.54C124.812 74.3006 124.085 73.755 123.448 73.2094H118.447Z"
          fill="url(#paint12_linear_455_18271)"
        />
      </g>
      <path
        opacity="0.6"
        d="M136.725 73.4837C145.765 73.4837 153.093 65.2188 153.093 55.0234C153.093 44.8281 145.765 36.5632 136.725 36.5632C127.684 36.5632 120.356 44.8281 120.356 55.0234C120.356 65.2188 127.684 73.4837 136.725 73.4837Z"
        stroke="url(#paint13_linear_455_18271)"
        strokeWidth="1.0818"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.6"
        d="M136.816 71.8473C145.002 71.8473 151.639 64.3559 151.639 55.1149C151.639 45.8738 145.002 38.3824 136.816 38.3824C128.63 38.3824 121.993 45.8738 121.993 55.1149C121.993 64.3559 128.63 71.8473 136.816 71.8473Z"
        stroke="url(#paint14_linear_455_18271)"
        strokeWidth="0.3152"
        strokeMiterlimit="10"
      />
      <path
        d="M95.7108 34.652C92.7099 37.1982 87.9812 36.5617 85.0712 33.197C82.1612 29.8323 82.1612 25.0126 85.1621 22.4664C88.163 19.9201 92.8918 20.5567 95.8017 23.9214C98.6208 27.2861 98.6208 32.1057 95.7108 34.652Z"
        fill="url(#paint15_linear_455_18271)"
      />
      <path
        d="M95.711 23.8303C98.4391 26.9222 98.621 31.2872 96.2566 34.0153C96.5294 33.8334 96.7113 33.6516 96.9841 33.4697C99.9851 30.9234 99.9851 26.1038 97.0751 22.7391C94.1651 19.3744 89.3454 18.6469 86.4354 21.2841C86.2535 21.4659 85.9807 21.6478 85.7988 21.9206C88.7088 19.92 93.0738 20.7385 95.711 23.8303Z"
        fill="url(#paint16_linear_455_18271)"
      />
      <g opacity="0.5">
        <path
          d="M95.8926 24.1035C95.9835 24.2854 96.1654 24.3763 96.2563 24.5582L97.5295 23.467C97.4385 23.2851 97.2566 23.1941 97.1657 23.0123L95.8926 24.1035Z"
          fill="url(#paint17_linear_455_18271)"
        />
        <path
          d="M94.8916 23.0133C95.0735 23.1043 95.1644 23.2861 95.3463 23.3771L96.6194 22.2858C96.4376 22.1039 96.3466 22.013 96.1647 21.9221L94.8916 23.0133Z"
          fill="url(#paint18_linear_455_18271)"
        />
        <path
          d="M96.7109 25.2869C96.8019 25.4688 96.8928 25.6507 96.9838 25.8326L98.2569 24.7413C98.1659 24.5594 98.075 24.3776 97.9841 24.1957L96.7109 25.2869Z"
          fill="url(#paint19_linear_455_18271)"
        />
        <path
          d="M97.3472 26.6518C97.4381 26.8337 97.5291 27.0155 97.5291 27.2883L98.8022 26.1971C98.7112 26.0152 98.7112 25.8333 98.6203 25.5605L97.3472 26.6518Z"
          fill="url(#paint20_linear_455_18271)"
        />
        <path
          d="M93.8003 22.1037C93.9822 22.1946 94.164 22.2856 94.255 22.4675L95.5281 21.3762C95.3462 21.2853 95.1643 21.1034 95.0734 21.0125L93.8003 22.1037Z"
          fill="url(#paint21_linear_455_18271)"
        />
        <path
          d="M92.3457 21.4671C92.5276 21.558 92.7095 21.6489 92.8913 21.7399L94.1644 20.6486C93.9826 20.5577 93.8007 20.4668 93.6188 20.3758L92.3457 21.4671Z"
          fill="url(#paint22_linear_455_18271)"
        />
        <path
          d="M90.3452 20.922C90.618 20.922 90.7999 21.0129 91.0727 21.0129L92.3458 19.9216C92.073 19.8307 91.8912 19.8307 91.6184 19.8307L90.3452 20.922Z"
          fill="url(#paint23_linear_455_18271)"
        />
        <path
          d="M88.0718 20.9213C88.4355 20.8303 88.7083 20.8303 89.0721 20.8303L90.3452 19.7391C89.9815 19.7391 89.6177 19.83 89.3449 19.83L88.0718 20.9213Z"
          fill="url(#paint24_linear_455_18271)"
        />
        <path
          d="M97.8931 28.56C97.8931 28.8328 97.984 29.0147 97.984 29.2875L99.2571 28.1963C99.2571 27.9235 99.2571 27.7416 99.1662 27.4688L97.8931 28.56Z"
          fill="url(#paint25_linear_455_18271)"
        />
        <path
          d="M97.8923 30.471C97.8923 30.7438 97.8014 31.1076 97.7104 31.3804L98.9836 30.1982C99.0745 29.9254 99.0745 29.5617 99.1655 29.2888L97.8923 30.471Z"
          fill="url(#paint26_linear_455_18271)"
        />
      </g>
      <path
        d="M94.6208 33.4699C94.5298 33.5608 94.3479 33.5608 94.257 33.4699C94.1661 33.3789 94.1661 33.1971 94.257 33.0152C94.3479 32.9243 94.5298 32.7424 94.6208 32.6514C94.7117 32.5605 94.8936 32.5605 94.9845 32.6514C95.0754 32.7424 95.0754 32.9243 94.9845 33.0152C94.8936 33.1971 94.8026 33.288 94.6208 33.4699ZM93.1657 34.2883C93.0748 34.3792 93.0748 34.3792 93.1657 34.2883C92.8929 34.3792 92.7111 34.4702 92.5292 34.5611C92.3473 34.5611 92.2564 34.4702 92.1654 34.3793C92.1654 34.1974 92.2564 34.1064 92.3473 34.0155C92.5292 34.0155 92.7111 33.9246 92.8929 33.8336C93.0748 33.7427 93.1658 33.8336 93.2567 34.0155C93.2567 34.1064 93.2567 34.1974 93.1657 34.2883ZM95.9848 31.5602C95.8939 31.6511 95.8029 31.6511 95.712 31.6511C95.5301 31.5602 95.5301 31.3783 95.5301 31.2874C95.6211 31.1055 95.6211 30.9236 95.712 30.7418C95.712 30.5599 95.8939 30.469 96.0758 30.5599C96.2576 30.5599 96.3485 30.7418 96.2576 30.9236C96.1667 31.1055 96.1667 31.2874 96.0758 31.4693C95.9848 31.5602 95.9848 31.5602 95.9848 31.5602ZM90.8923 34.6521C90.8014 34.743 90.8014 34.743 90.7105 34.743C90.5286 34.743 90.3467 34.743 90.0739 34.6521C89.892 34.6521 89.8011 34.4702 89.8011 34.2883C89.8011 34.1064 89.983 34.0155 90.1648 34.0155C90.3467 34.0155 90.5286 34.1064 90.7105 34.1064C90.8923 34.1064 90.9833 34.2883 90.9833 34.3793C90.9833 34.4702 90.9833 34.5611 90.8923 34.6521ZM96.3486 29.3777C96.2576 29.3777 96.2576 29.4686 96.1667 29.4686C95.9848 29.4686 95.8939 29.3777 95.8939 29.1958C95.8939 29.014 95.8939 28.8321 95.8939 28.6502C95.8939 28.4683 95.9848 28.3774 96.1667 28.2865C96.3486 28.2865 96.4395 28.3774 96.5304 28.5593C96.5304 28.7411 96.5304 28.923 96.5304 29.1958C96.4395 29.1958 96.4395 29.2868 96.3486 29.3777ZM88.7098 34.0155C88.6189 34.1064 88.528 34.1064 88.437 34.0155C88.2552 33.9246 88.0733 33.8336 87.8914 33.7427C87.7095 33.6518 87.7095 33.4699 87.8005 33.3789C87.8914 33.1971 88.0733 33.1971 88.1642 33.288C88.3461 33.3789 88.5279 33.4699 88.6189 33.5608C88.8008 33.6517 88.8008 33.8336 88.7098 33.9246V34.0155ZM95.8939 27.1043C95.6211 27.1952 95.5301 27.1043 95.4392 27.0133C95.3482 26.8315 95.2573 26.6496 95.2573 26.5586C95.1664 26.3768 95.2573 26.2858 95.3482 26.1949C95.5301 26.104 95.6211 26.1949 95.712 26.2858C95.8029 26.4677 95.8939 26.6496 95.9848 26.8315C95.9848 26.9224 95.9848 27.0133 95.8939 27.1043ZM86.8001 32.6514C86.7092 32.7424 86.5273 32.7424 86.4364 32.6514C86.3455 32.5605 86.1636 32.3786 86.0727 32.1967C85.9817 32.1058 85.9817 31.9239 86.0727 31.833C86.1636 31.7421 86.3455 31.7421 86.5273 31.833C86.6183 31.9239 86.8001 32.1058 86.8911 32.1967C86.982 32.3786 86.982 32.5605 86.8001 32.6514ZM94.7117 25.1946C94.6208 25.2855 94.4389 25.2855 94.257 25.1946C94.1661 25.1036 93.9842 24.9218 93.8933 24.8308C93.8023 24.7399 93.8023 24.558 93.8933 24.4671C93.9842 24.3761 94.1661 24.3761 94.257 24.4671C94.4389 24.649 94.5298 24.7399 94.6208 24.9218C94.8026 24.9218 94.8026 25.1036 94.7117 25.1946ZM85.4361 30.8327C85.2542 30.9236 85.0723 30.9236 84.9814 30.7418C84.8905 30.5599 84.7995 30.378 84.7086 30.1961C84.6177 30.0143 84.7086 29.9233 84.8905 29.8324C85.0723 29.7415 85.1633 29.8324 85.2542 30.0143C85.3452 30.1961 85.4361 30.378 85.4361 30.5599C85.618 30.6508 85.618 30.7418 85.4361 30.8327ZM92.9839 23.7396C92.893 23.8305 92.802 23.8305 92.6201 23.7396C92.4382 23.6487 92.2564 23.5577 92.1654 23.4668C91.9836 23.3758 91.9836 23.194 92.0745 23.103C92.1655 22.9211 92.3473 22.9212 92.4383 23.0121C92.6201 23.103 92.802 23.194 92.9839 23.2849C93.0748 23.2849 93.0748 23.4668 92.9839 23.7396C92.9839 23.6487 92.9839 23.6487 92.9839 23.7396ZM84.7995 28.6502C84.7995 28.6502 84.7086 28.7411 84.6176 28.7411C84.4358 28.7411 84.3448 28.6502 84.2539 28.4683C84.2539 28.2865 84.2539 28.1046 84.2539 27.8318C84.2539 27.6499 84.3448 27.559 84.5267 27.559C84.7086 27.559 84.7995 27.6499 84.7995 27.8318C84.7995 28.0136 84.7995 28.1955 84.7995 28.3774C84.8905 28.4683 84.8905 28.5593 84.7995 28.6502ZM90.8014 22.9211C90.7104 23.0121 90.6195 23.0121 90.5286 23.0121C90.3467 23.0121 90.1648 22.9211 89.9829 22.9211C89.8011 22.9211 89.7101 22.7393 89.7101 22.6483C89.7101 22.4665 89.892 22.3755 89.9829 22.3755C90.1648 22.3755 90.3467 22.3755 90.6195 22.4665C90.8014 22.4665 90.8923 22.6483 90.8923 22.8302C90.8923 22.8302 90.8923 22.8302 90.8014 22.9211ZM84.9814 26.3768C84.8905 26.4677 84.7995 26.4677 84.7086 26.4677C84.5267 26.4677 84.4358 26.2858 84.5267 26.104C84.6176 25.9221 84.6177 25.7402 84.7086 25.5583C84.7995 25.3765 84.9814 25.3765 85.0723 25.3765C85.2542 25.4674 85.2542 25.6493 85.2542 25.7402C85.1633 25.9221 85.1633 26.104 85.0723 26.2858C85.0723 26.2858 85.0723 26.3768 84.9814 26.3768ZM88.5279 23.0121L88.437 23.103C88.2552 23.103 88.0733 23.194 87.8914 23.2849C87.7095 23.3758 87.6186 23.2849 87.5277 23.103C87.4367 22.9211 87.5276 22.8302 87.7095 22.7393C87.8914 22.6483 88.0733 22.6483 88.2551 22.5574C88.437 22.5574 88.5279 22.6483 88.6189 22.7393C88.6189 22.8302 88.6189 22.9212 88.5279 23.0121ZM86.0727 24.3762C85.9817 24.4671 85.7998 24.4671 85.7089 24.3762C85.618 24.2852 85.618 24.1033 85.7089 24.0124C85.7998 23.8305 85.9817 23.7396 86.1636 23.5577C86.2545 23.4668 86.4364 23.4668 86.5273 23.5577C86.6183 23.6486 86.6183 23.8305 86.5273 24.0124C86.3455 24.1033 86.2545 24.2852 86.0727 24.3762Z"
        fill="url(#paint27_linear_455_18271)"
      />
      <path
        d="M161.004 23.8315C156.548 20.1031 156.366 12.8281 160.64 7.73562C164.915 2.64313 172.099 1.55189 176.554 5.28031C181.01 9.00874 181.192 16.2837 176.918 21.3762C172.553 26.5596 165.46 27.6509 161.004 23.8315Z"
        fill="url(#paint28_linear_455_18271)"
      />
      <path
        d="M176.918 21.3765C172.917 26.1052 166.552 27.3783 162.096 24.5593C162.369 24.923 162.732 25.1958 163.005 25.4687C167.461 29.1971 174.645 28.1058 178.919 23.0134C183.193 17.9209 183.102 10.6459 178.555 6.91746C178.192 6.64465 177.828 6.37183 177.464 6.18996C181.011 10.1912 180.829 16.6477 176.918 21.3765Z"
        fill="url(#paint29_linear_455_18271)"
      />
      <g opacity="0.5">
        <path
          d="M176.646 21.7403C176.464 21.9221 176.283 22.195 176.01 22.3768L178.01 24.0137C178.192 23.8318 178.374 23.559 178.647 23.3771L176.646 21.7403Z"
          fill="url(#paint30_linear_455_18271)"
        />
        <path
          d="M177.92 20.0126C177.738 20.2854 177.556 20.4673 177.465 20.7401L179.465 22.377C179.647 22.1042 179.829 21.9223 179.92 21.6495L177.92 20.0126Z"
          fill="url(#paint31_linear_455_18271)"
        />
        <path
          d="M175.009 23.2857C174.736 23.4676 174.554 23.6494 174.281 23.8313L176.282 25.4682C176.555 25.2863 176.737 25.1044 177.009 24.9226L175.009 23.2857Z"
          fill="url(#paint32_linear_455_18271)"
        />
        <path
          d="M173.191 24.4691C172.918 24.651 172.645 24.7419 172.373 24.9238L174.373 26.5607C174.646 26.4697 174.919 26.2879 175.192 26.106L173.191 24.4691Z"
          fill="url(#paint33_linear_455_18271)"
        />
        <path
          d="M179.011 18.1018C178.92 18.3746 178.738 18.6475 178.647 18.9203L180.648 20.5571C180.83 20.2843 180.921 20.0115 181.012 19.7387L179.011 18.1018Z"
          fill="url(#paint34_linear_455_18271)"
        />
        <path
          d="M179.738 15.8299C179.647 16.1027 179.556 16.4664 179.465 16.7393L181.466 18.3761C181.557 18.1033 181.648 17.7396 181.739 17.4668L179.738 15.8299Z"
          fill="url(#paint35_linear_455_18271)"
        />
        <path
          d="M180.011 12.739C180.011 13.1028 180.011 13.4665 180.011 13.8303L182.011 15.4672C182.011 15.1034 182.011 14.7397 182.011 14.3759L180.011 12.739Z"
          fill="url(#paint36_linear_455_18271)"
        />
        <path
          d="M179.374 9.37273C179.555 9.82741 179.646 10.373 179.828 10.8277L181.829 12.4646C181.738 11.919 181.556 11.4643 181.374 11.0096L179.374 9.37273Z"
          fill="url(#paint37_linear_455_18271)"
        />
        <path
          d="M170.462 25.6508C170.099 25.7418 169.735 25.8327 169.371 25.9237L171.372 27.5605C171.735 27.4696 172.099 27.3787 172.372 27.2877L170.462 25.6508Z"
          fill="url(#paint38_linear_455_18271)"
        />
        <path
          d="M167.643 26.1061C167.189 26.1061 166.734 26.1061 166.279 26.1061L168.28 27.743C168.735 27.743 169.189 27.8339 169.644 27.743L167.643 26.1061Z"
          fill="url(#paint39_linear_455_18271)"
        />
      </g>
      <path
        d="M162.46 22.0134C162.278 21.8315 162.278 21.5587 162.46 21.3769C162.641 21.195 162.914 21.195 163.096 21.3769C163.278 21.5587 163.551 21.7406 163.733 21.8315C163.915 22.0134 164.005 22.1953 163.824 22.4681C163.733 22.65 163.46 22.7409 163.187 22.559C163.005 22.4681 162.732 22.2862 162.46 22.0134ZM160.823 20.0128L160.732 19.9219C160.55 19.649 160.459 19.3762 160.368 19.1034C160.277 18.9215 160.368 18.6487 160.641 18.5578C160.823 18.4669 161.096 18.5578 161.186 18.8306C161.277 19.1034 161.368 19.2853 161.55 19.5581C161.641 19.74 161.55 20.0128 161.368 20.1037C161.186 20.1947 161.005 20.1947 160.823 20.0128ZM165.551 23.5593C165.46 23.4684 165.37 23.2865 165.37 23.1047C165.46 22.8318 165.642 22.7409 165.915 22.7409C166.188 22.8319 166.461 22.8318 166.734 22.9228C167.006 22.9228 167.097 23.1956 167.097 23.3775C167.097 23.6503 166.825 23.7412 166.643 23.7412C166.37 23.7412 166.006 23.6503 165.733 23.5593C165.642 23.6503 165.551 23.6503 165.551 23.5593ZM159.913 16.83C159.822 16.7391 159.731 16.6481 159.731 16.5572C159.731 16.2844 159.731 15.9206 159.731 15.6478C159.731 15.375 159.913 15.1931 160.186 15.1931C160.459 15.1931 160.641 15.375 160.641 15.6478C160.641 15.9206 160.641 16.1934 160.641 16.4662C160.641 16.7391 160.459 16.9209 160.277 16.9209C160.095 16.9209 159.913 16.83 159.913 16.83ZM168.916 23.6503C168.825 23.5593 168.825 23.4684 168.734 23.3775C168.734 23.1047 168.825 22.9228 169.098 22.8319C169.371 22.7409 169.644 22.7409 169.916 22.65C170.189 22.559 170.371 22.7409 170.462 22.9228C170.553 23.1956 170.371 23.3775 170.189 23.4684C169.916 23.5594 169.644 23.6503 169.28 23.6503C169.189 23.7412 169.007 23.7412 168.916 23.6503ZM160.277 13.3744C160.186 13.2834 160.095 13.1016 160.095 12.9197C160.186 12.6469 160.277 12.3741 160.368 12.1013C160.459 11.9194 160.732 11.7375 160.914 11.8284C161.095 11.9194 161.277 12.1922 161.186 12.3741C161.096 12.6469 161.005 12.9197 160.914 13.1925C160.823 13.4653 160.641 13.5563 160.368 13.4653C160.368 13.4653 160.277 13.4653 160.277 13.3744ZM172.099 22.3772L172.008 22.2862C171.917 22.1044 171.917 21.8315 172.19 21.6497C172.463 21.4678 172.645 21.3769 172.917 21.195C173.099 21.0131 173.372 21.104 173.554 21.2859C173.736 21.4678 173.645 21.7406 173.463 21.9225C173.19 22.1044 173.008 22.2862 172.735 22.3772C172.463 22.559 172.281 22.4681 172.099 22.3772ZM161.732 10.3734C161.55 10.1916 161.55 10.0097 161.641 9.82782C161.823 9.55501 162.005 9.37314 162.187 9.19126C162.369 9.00939 162.641 9.00939 162.823 9.19126C163.005 9.37314 163.005 9.64595 162.823 9.82782C162.641 10.0097 162.46 10.2825 162.369 10.4644C162.278 10.4644 162.005 10.4644 161.732 10.3734ZM174.736 20.1947C174.554 20.0128 174.554 19.74 174.645 19.5581C174.827 19.3762 175.009 19.1034 175.1 18.9215C175.282 18.7397 175.555 18.6487 175.736 18.8306C175.918 19.0125 176.009 19.1944 175.827 19.4672C175.645 19.74 175.464 19.9219 175.282 20.1947C175.191 20.2856 174.918 20.2856 174.736 20.1947ZM164.187 7.91813C164.096 7.8272 164.096 7.91813 164.187 7.91813C164.005 7.64532 164.005 7.37251 164.187 7.28158C164.46 7.0997 164.642 6.91783 164.915 6.82689C165.097 6.73595 165.37 6.73595 165.551 7.00876C165.642 7.19064 165.642 7.46344 165.37 7.64532C165.097 7.82719 164.915 7.91813 164.642 8.10001C164.551 8.10001 164.278 8.00907 164.187 7.91813ZM176.464 17.2847C176.282 17.1937 176.282 17.0119 176.373 16.83C176.464 16.5572 176.555 16.2844 176.646 16.0116C176.737 15.7387 176.919 15.6478 177.191 15.7387C177.464 15.8297 177.555 16.0115 177.464 16.2844C177.373 16.5572 177.282 16.83 177.191 17.1028C177.1 17.2847 176.828 17.4666 176.646 17.3756C176.555 17.2847 176.464 17.2847 176.464 17.2847ZM167.188 6.46315C167.097 6.37221 167.097 6.3722 167.006 6.28126C166.915 6.00845 167.097 5.82658 167.279 5.73564C167.552 5.64471 167.825 5.55377 168.189 5.55377C168.461 5.55377 168.643 5.6447 168.734 5.91752C168.734 6.19033 168.643 6.37221 168.37 6.46315C168.098 6.55408 167.825 6.55408 167.552 6.64502C167.461 6.55408 167.279 6.55408 167.188 6.46315ZM177.1 13.92C177.01 13.8291 176.919 13.7381 176.919 13.5562C176.919 13.2834 176.919 13.0106 176.919 12.7378C176.919 12.465 177.1 12.2831 177.282 12.2831C177.555 12.2831 177.737 12.465 177.737 12.6469C177.737 12.9197 177.737 13.2834 177.737 13.5562C177.737 13.8291 177.555 14.0109 177.282 14.0109C177.282 14.0109 177.191 13.92 177.1 13.92ZM170.644 6.09939C170.553 6.00845 170.462 5.82658 170.462 5.73564C170.462 5.46283 170.735 5.37189 170.917 5.37189C171.19 5.37189 171.553 5.46284 171.826 5.55377C172.099 5.64471 172.19 5.82658 172.19 6.09939C172.099 6.3722 171.917 6.46315 171.644 6.46315C171.371 6.37221 171.099 6.3722 170.826 6.28126C170.735 6.19032 170.644 6.19033 170.644 6.09939ZM176.464 10.5553C176.373 10.5553 176.373 10.4644 176.373 10.3734C176.282 10.1006 176.191 9.91876 176.009 9.64595C175.918 9.46408 176.009 9.19126 176.191 9.10032C176.373 9.00938 176.646 9.00938 176.737 9.28219C176.919 9.555 177.01 9.82782 177.1 10.1006C177.191 10.2825 177.1 10.5553 176.828 10.6463C176.828 10.6463 176.646 10.6463 176.464 10.5553ZM173.827 7.28158C173.645 7.0997 173.645 6.91782 173.736 6.73595C173.827 6.55407 174.1 6.46314 174.372 6.64502C174.645 6.82689 174.827 7.00876 175.1 7.19063C175.282 7.37251 175.282 7.64533 175.191 7.8272C175.009 8.00908 174.736 8.00907 174.554 7.91813C174.281 7.64532 174.1 7.46345 173.827 7.28158Z"
        fill="url(#paint40_linear_455_18271)"
      />
      <path
        d="M129.449 192.246L62.0646 153.416C59.0637 151.688 58.9728 142.594 60.2459 139.502L123.447 106.765C126.903 104.764 132.268 104.491 135.269 106.31L204.2 141.412C206.746 145.413 205.291 154.87 201.835 156.871L141.362 191.791C137.815 193.792 132.45 193.974 129.449 192.246Z"
        fill="url(#paint41_linear_455_18271)"
      />
      <path
        d="M129.449 182.244L62.065 143.413C59.064 141.686 59.4278 138.594 62.8834 136.593L123.357 101.673C126.812 99.6726 132.178 99.3998 135.179 101.218L202.563 140.049C205.564 141.777 205.2 144.868 201.745 146.869L141.271 181.789C137.816 183.699 132.45 183.971 129.449 182.244Z"
        fill="url(#paint42_linear_455_18271)"
      />
      <path
        d="M129.358 177.696L69.7945 143.413C66.7935 141.685 67.1573 138.593 70.6129 136.593L123.447 106.129C126.903 104.128 132.268 103.855 135.269 105.674L194.833 139.958C197.834 141.685 197.47 144.777 194.015 146.778L141.18 177.242C137.725 179.242 132.359 179.424 129.358 177.696Z"
        fill="url(#paint43_linear_455_18271)"
      />
      <path
        d="M129.904 164.876L79.3428 135.776C77.0694 134.503 77.0694 131.32 77.9788 129.047L125.357 104.494C127.994 102.948 131.905 102.857 134.178 104.13L185.83 130.411C187.74 133.412 186.649 136.776 184.012 138.322L138.634 164.512C136.179 165.967 132.177 166.149 129.904 164.876Z"
        fill="url(#paint44_linear_455_18271)"
      />
      <path
        d="M129.904 161.056L79.3432 131.956C77.0697 130.683 77.3425 128.319 79.9797 126.864L125.357 100.674C127.995 99.1279 131.905 99.037 134.178 100.31L184.739 129.41C187.013 130.683 186.74 133.048 184.103 134.503L138.725 160.692C136.179 162.238 132.178 162.42 129.904 161.056Z"
        fill="url(#paint45_linear_455_18271)"
      />
      <path
        d="M129.813 157.691L85.163 132.047C82.8896 130.774 83.1624 128.409 85.7995 126.954L125.357 104.129C127.994 102.583 131.905 102.492 134.178 103.765L178.828 129.41C181.102 130.683 180.829 133.047 178.192 134.502L138.634 157.328C136.088 158.873 132.087 158.964 129.813 157.691Z"
        fill="url(#paint46_linear_455_18271)"
      />
      <path
        d="M129.813 149.687L82.4349 122.406C80.3433 121.224 80.2524 118.314 81.1618 116.131L125.539 93.1241C127.994 91.6691 131.723 91.5782 133.814 92.7604L182.193 117.404C184.012 120.223 183.012 123.406 180.556 124.77L138.088 149.323C135.633 150.778 131.905 150.96 129.813 149.687Z"
        fill="url(#paint47_linear_455_18271)"
      />
      <path
        d="M129.814 146.141L82.4356 118.86C80.344 117.678 80.6168 115.495 83.0721 114.04L125.54 89.4873C127.995 88.0323 131.724 87.9414 133.815 89.1236L181.193 116.405C183.285 117.587 183.012 119.769 180.557 121.224L138.089 145.778C135.634 147.233 131.905 147.414 129.814 146.141Z"
        fill="url(#paint48_linear_455_18271)"
      />
      <path
        d="M129.722 143.05L87.8906 119.043C85.7991 117.861 86.0719 115.678 88.5272 114.223L125.63 92.8528C128.085 91.3978 131.813 91.3069 133.905 92.4891L175.736 116.497C177.828 117.679 177.555 119.861 175.099 121.316L137.997 142.686C135.633 144.051 131.904 144.232 129.722 143.05Z"
        fill="url(#paint49_linear_455_18271)"
      />
      <path
        d="M129.903 135.957L85.4348 110.404C83.4342 109.222 83.4342 106.494 84.1617 104.493L125.902 82.85C128.175 81.4859 131.722 81.395 133.722 82.4862L179.191 105.675C180.828 108.312 179.919 111.313 177.645 112.586L137.724 135.594C135.45 136.958 131.904 137.14 129.903 135.957Z"
        fill="url(#paint50_linear_455_18271)"
      />
      <path
        d="M129.903 132.683L85.435 107.13C83.4343 105.948 83.7071 103.947 85.9806 102.674L125.902 79.6668C128.175 78.3027 131.722 78.2118 133.723 79.303L178.191 104.856C180.192 106.039 179.919 108.039 177.645 109.312L137.724 132.319C135.45 133.684 131.904 133.774 129.903 132.683Z"
        fill="url(#paint51_linear_455_18271)"
      />
      <path
        d="M129.903 129.683L90.6181 107.131C88.6174 105.949 88.8903 103.948 91.1637 102.675L125.993 82.5779C128.266 81.2138 131.813 81.1229 133.813 82.2141L173.098 104.767C175.099 105.949 174.826 107.949 172.553 109.222L137.724 129.32C135.359 130.684 131.904 130.866 129.903 129.683Z"
        fill="url(#paint52_linear_455_18271)"
      />
      <path
        d="M131.358 120.589L105.35 105.675C104.168 105.039 104.168 99.4004 104.622 98.2183L128.993 85.578C130.358 84.7596 132.358 84.7595 133.54 85.3961L160.094 98.9458C161.094 100.492 160.549 106.221 159.185 107.039L135.905 120.498C134.541 121.134 132.449 121.225 131.358 120.589Z"
        fill="url(#paint53_linear_455_18271)"
      />
      <path
        d="M131.358 114.587L105.35 99.6733C104.168 99.0367 104.35 97.8545 105.714 97.0361L128.993 83.5773C130.358 82.7589 132.358 82.7589 133.54 83.3955L159.548 98.3092C160.731 98.9458 160.549 100.128 159.185 100.946L135.905 114.405C134.541 115.224 132.449 115.314 131.358 114.587Z"
        fill="url(#paint54_linear_455_18271)"
      />
      <path
        d="M131.267 112.861L108.351 99.6748C107.169 99.0382 107.351 97.856 108.715 97.0376L129.085 85.3067C130.449 84.4883 132.45 84.4883 133.632 85.1248L156.548 98.3107C157.73 98.9473 157.548 100.129 156.184 100.948L135.814 112.679C134.541 113.497 132.45 113.588 131.267 112.861Z"
        fill="#C6F8FF"
      />
      <path
        opacity="0.8"
        d="M53.6987 26.1047L104.805 97.9451L130.632 112.859C132.45 113.95 134.724 113.95 136.543 112.859L162.369 97.9451L210.566 27.8325C210.566 27.8325 166.552 -1.90402 132.814 0.0966039C97.4396 2.37004 53.6987 26.1047 53.6987 26.1047Z"
        fill="url(#paint55_linear_455_18271)"
      />
      <g opacity="0.5">
        <path
          d="M168.189 56.6608H168.007C167.916 56.6608 167.916 56.5697 167.916 56.5697V56.3875C167.916 56.2964 168.007 56.2964 168.007 56.2964H168.189C168.28 56.2964 168.28 56.3875 168.28 56.3875V56.5697C168.28 56.6608 168.189 56.6608 168.189 56.6608Z"
          fill="white"
        />
        <path
          d="M166.097 84.9411H165.915C165.824 84.9411 165.824 84.8501 165.824 84.8501V84.6679C165.824 84.5768 165.915 84.5768 165.915 84.5768H166.097C166.188 84.5768 166.188 84.6679 166.188 84.6679V84.8501C166.188 84.9412 166.188 84.9411 166.097 84.9411Z"
          fill="white"
        />
        <path
          d="M153.184 78.8493H153.002C152.911 78.8493 152.911 78.7582 152.911 78.7582V78.576C152.911 78.4849 153.002 78.4849 153.002 78.4849H153.184C153.275 78.4849 153.275 78.576 153.275 78.576V78.7582L153.184 78.8493Z"
          fill="white"
        />
        <path
          d="M144.454 80.8487H144.272C144.181 80.8487 144.181 80.7576 144.181 80.7576V80.4843C144.181 80.3932 144.272 80.3932 144.272 80.3932H144.454C144.545 80.3932 144.545 80.4843 144.545 80.4843V80.6665C144.545 80.7576 144.545 80.8487 144.454 80.8487Z"
          fill="white"
        />
        <path
          d="M139.998 71.8461L139.817 71.7551C139.726 71.7551 139.726 71.6642 139.726 71.5732L139.817 71.3914C139.817 71.3004 139.907 71.3004 139.998 71.3004L140.18 71.3914C140.271 71.3914 140.271 71.4823 140.271 71.5732L140.18 71.7551C140.089 71.8461 139.998 71.8461 139.998 71.8461Z"
          fill="white"
        />
        <path
          d="M133.087 88.9431L132.905 88.8521C132.814 88.8521 132.814 88.7612 132.814 88.6703L132.905 88.4884C132.905 88.3975 132.996 88.3975 133.087 88.3975L133.269 88.4884C133.36 88.4884 133.36 88.5793 133.36 88.6703L133.269 88.8521C133.269 88.9431 133.178 89.034 133.087 88.9431Z"
          fill="white"
        />
        <path
          d="M122.629 64.2987L122.447 64.2078C122.356 64.2078 122.356 64.1168 122.356 64.0259L122.447 63.844C122.447 63.7531 122.538 63.7531 122.629 63.7531L122.811 63.844C122.902 63.844 122.902 63.9349 122.902 64.0259L122.811 64.2078C122.72 64.2987 122.72 64.3896 122.629 64.2987Z"
          fill="white"
        />
        <path
          d="M105.078 72.119L104.896 72.0281C104.805 72.0281 104.805 71.9371 104.805 71.8462L104.896 71.6643C104.896 71.5734 104.987 71.5734 105.078 71.5734L105.26 71.6643C105.351 71.6643 105.351 71.7553 105.351 71.8462L105.26 72.0281C105.169 72.119 105.169 72.119 105.078 72.119Z"
          fill="white"
        />
        <path
          d="M113.717 97.7637L113.535 97.6728C113.444 97.6728 113.444 97.5818 113.444 97.4909L113.535 97.309C113.535 97.2181 113.626 97.2181 113.717 97.2181L113.899 97.309C113.989 97.309 113.989 97.4 113.989 97.4909L113.899 97.6728C113.808 97.7637 113.717 97.8547 113.717 97.7637Z"
          fill="white"
        />
        <path
          d="M116.991 80.3039L116.809 80.2129C116.718 80.2129 116.718 80.122 116.718 80.031L116.809 79.8492C116.809 79.7582 116.9 79.7582 116.991 79.7582L117.172 79.8492C117.263 79.8492 117.263 79.9401 117.263 80.031L117.172 80.2129C117.082 80.3039 116.991 80.3039 116.991 80.3039Z"
          fill="white"
        />
        <path
          d="M105.078 59.1148L104.896 59.0239C104.805 59.0239 104.805 58.933 104.805 58.842L104.896 58.6601C104.896 58.5692 104.987 58.5692 105.078 58.5692L105.26 58.6601C105.351 58.6601 105.351 58.7511 105.351 58.842L105.26 59.0239C105.169 59.1148 105.169 59.1148 105.078 59.1148Z"
          fill="white"
        />
        <path
          d="M91.1644 76.2119L90.9825 76.1209C90.8916 76.1209 90.8916 76.03 90.8916 75.9391L90.9825 75.7572C90.9825 75.6662 91.0735 75.6662 91.1644 75.6662L91.3463 75.7572C91.4372 75.7572 91.4372 75.8481 91.4372 75.9391L91.3463 76.1209C91.2554 76.2119 91.2554 76.2119 91.1644 76.2119Z"
          fill="white"
        />
        <path
          d="M91.1644 63.2077L90.9825 63.1167C90.8916 63.1167 90.8916 63.0258 90.8916 62.9349L90.9825 62.753C90.9825 62.6621 91.0735 62.662 91.1644 62.662L91.3463 62.753C91.4372 62.753 91.4372 62.8439 91.4372 62.9349L91.3463 63.1167C91.2554 63.2077 91.2554 63.2077 91.1644 63.2077Z"
          fill="white"
        />
        <path
          d="M176.827 71.8461L176.646 71.7551C176.555 71.7551 176.555 71.6642 176.555 71.5732L176.646 71.3914C176.646 71.3004 176.737 71.3004 176.827 71.3004L177.009 71.3914C177.1 71.3914 177.1 71.4823 177.1 71.5732L177.009 71.7551C176.918 71.8461 176.827 71.8461 176.827 71.8461Z"
          fill="white"
        />
        <path
          d="M177.919 63.2077L177.737 63.1167C177.646 63.1167 177.646 63.0258 177.646 62.9349L177.737 62.753C177.737 62.6621 177.828 62.662 177.919 62.662L178.101 62.753C178.192 62.753 178.192 62.8439 178.192 62.9349L178.101 63.1167C178.101 63.2077 178.01 63.2077 177.919 63.2077Z"
          fill="white"
        />
        <path
          d="M160.823 75.4837L160.641 75.3927C160.55 75.3927 160.55 75.3018 160.55 75.2109L160.641 75.029C160.641 74.938 160.732 74.938 160.823 74.938L161.004 75.029C161.095 75.029 161.095 75.1199 161.095 75.2109L161.004 75.3927C161.004 75.4837 160.914 75.4837 160.823 75.4837Z"
          fill="white"
        />
        <path
          d="M153.638 60.2974L153.456 60.2065C153.365 60.2065 153.365 60.1155 153.365 60.0246L153.456 59.8427C153.456 59.7518 153.547 59.7518 153.638 59.7518L153.82 59.8427C153.911 59.8427 153.911 59.9337 153.911 60.0246L153.82 60.2065C153.82 60.2974 153.729 60.3884 153.638 60.2974Z"
          fill="white"
        />
        <path
          d="M134.724 104.493H134.542C134.451 104.493 134.451 104.402 134.451 104.402V104.22C134.451 104.129 134.542 104.129 134.542 104.129H134.724C134.816 104.129 134.816 104.22 134.816 104.22V104.402C134.816 104.402 134.816 104.493 134.724 104.493Z"
          fill="white"
        />
        <path
          d="M156.457 90.3978L156.275 90.3069C156.185 90.3069 156.185 90.2159 156.185 90.125L156.275 89.9431C156.275 89.8522 156.366 89.8522 156.457 89.8522L156.639 89.9431C156.73 89.9431 156.73 90.034 156.73 90.125L156.639 90.3069C156.548 90.3978 156.457 90.3978 156.457 90.3978Z"
          fill="white"
        />
        <path
          d="M105.533 83.3955L105.351 83.3046C105.26 83.3046 105.26 83.2137 105.26 83.1227L105.351 82.9408C105.351 82.8499 105.442 82.8499 105.533 82.8499L105.714 82.9408C105.805 82.9408 105.805 83.0318 105.805 83.1227L105.714 83.3046C105.624 83.3955 105.533 83.3955 105.533 83.3955Z"
          fill="white"
        />
        <path
          d="M143.09 99.1269L142.908 99.0359C142.817 99.0359 142.817 98.945 142.817 98.8541L142.908 98.6722C142.908 98.5813 142.999 98.5813 143.09 98.5813L143.272 98.6722C143.363 98.6722 143.363 98.7631 143.363 98.8541L143.272 99.0359C143.181 99.1269 143.09 99.1269 143.09 99.1269Z"
          fill="white"
        />
        <path
          d="M147.546 66.2993L147.364 66.2084C147.273 66.2084 147.273 66.1175 147.273 66.0265L147.364 65.8447C147.364 65.7537 147.455 65.7537 147.546 65.7537L147.728 65.8447C147.819 65.8447 147.819 65.9356 147.819 66.0265L147.728 66.2084C147.637 66.2993 147.546 66.2993 147.546 66.2993Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M143.271 9.6452H143.089C142.998 9.6452 142.998 9.5541 142.998 9.5541V9.3719C142.998 9.2808 143.089 9.28079 143.089 9.28079H143.271C143.362 9.28079 143.362 9.3719 143.362 9.3719V9.5541C143.362 9.5541 143.362 9.6452 143.271 9.6452Z"
          fill="white"
        />
        <path
          d="M141.272 37.9263H140.998C140.907 37.9263 140.907 37.8353 140.907 37.8353V37.653C140.907 37.5619 140.998 37.562 140.998 37.562H141.181C141.272 37.562 141.272 37.653 141.272 37.653V37.8353C141.363 37.8353 141.272 37.9263 141.272 37.9263Z"
          fill="white"
        />
        <path
          d="M129.086 23.7387H128.904C128.813 23.7387 128.812 23.6476 128.812 23.6476V23.4654C128.812 23.3743 128.904 23.3743 128.904 23.3743H129.086C129.177 23.3743 129.177 23.4654 129.177 23.4654V23.6476C129.268 23.6476 129.177 23.7387 129.086 23.7387Z"
          fill="white"
        />
        <path
          d="M119.628 33.8352H119.446C119.354 33.8352 119.354 33.7441 119.354 33.7441V33.5619C119.354 33.4708 119.446 33.4708 119.446 33.4708H119.628C119.719 33.4708 119.719 33.5619 119.719 33.5619V33.7441L119.628 33.8352Z"
          fill="white"
        />
        <path
          d="M111.625 16.1013L111.443 16.0104C111.353 16.0104 111.353 15.9194 111.353 15.8285L111.443 15.6466C111.443 15.5557 111.534 15.5557 111.625 15.5557L111.807 15.6466C111.898 15.6466 111.898 15.7376 111.898 15.8285L111.807 16.0104C111.716 16.1013 111.625 16.1922 111.625 16.1013Z"
          fill="white"
        />
        <path
          d="M108.261 41.9266L108.079 41.8357C107.988 41.8357 107.988 41.7447 107.988 41.6538L108.079 41.4719C108.079 41.381 108.17 41.381 108.261 41.381L108.442 41.4719C108.533 41.4719 108.533 41.5629 108.533 41.6538L108.442 41.8357C108.352 41.9266 108.261 42.0175 108.261 41.9266Z"
          fill="white"
        />
        <path
          d="M97.7113 17.2839L97.5294 17.193C97.4385 17.193 97.4385 17.102 97.4385 17.0111L97.5294 16.8292C97.5294 16.7383 97.6203 16.7383 97.7113 16.7383L97.8932 16.8292C97.9841 16.8292 97.9841 16.9202 97.9841 17.0111L97.8932 17.193C97.8932 17.2839 97.8022 17.2839 97.7113 17.2839Z"
          fill="white"
        />
        <path
          d="M88.8002 50.7481L88.6183 50.6571C88.5273 50.6571 88.5273 50.5662 88.5273 50.4753L88.6183 50.2934C88.6183 50.2025 88.7092 50.2025 88.8002 50.2025L88.982 50.2934C89.073 50.2934 89.073 50.3843 89.073 50.4753L88.982 50.6571C88.8911 50.7481 88.8911 50.7481 88.8002 50.7481Z"
          fill="white"
        />
        <path
          d="M92.0746 33.1973H91.8927C91.8018 33.1973 91.8018 33.1063 91.8018 33.0154L91.8927 32.8335C91.8927 32.7426 91.9836 32.7426 92.0746 32.7426L92.2564 32.8335C92.3474 32.8335 92.3474 32.9245 92.3474 33.0154L92.2564 33.1973C92.2564 33.1973 92.1655 33.2882 92.0746 33.1973Z"
          fill="white"
        />
        <path
          d="M151.91 24.8304L151.729 24.7395C151.638 24.7395 151.638 24.6485 151.638 24.5576L151.729 24.3757C151.729 24.2848 151.82 24.2848 151.91 24.2848L152.092 24.3757C152.183 24.3757 152.183 24.4667 152.183 24.5576L152.092 24.7395C152.001 24.8304 152.001 24.8304 151.91 24.8304Z"
          fill="white"
        />
        <path
          d="M159.731 42.292L159.549 42.201C159.458 42.201 159.458 42.1101 159.458 42.0192L159.549 41.8373C159.549 41.7463 159.64 41.7463 159.731 41.7463L159.913 41.8373C160.004 41.8373 160.004 41.9282 160.004 42.0192L159.913 42.201C159.822 42.292 159.731 42.3829 159.731 42.292Z"
          fill="white"
        />
        <path
          d="M178.01 40.6541L177.828 40.5632C177.737 40.5632 177.737 40.4723 177.737 40.3813L177.828 40.1994C177.828 40.1085 177.919 40.1085 178.01 40.1085L178.192 40.1994C178.283 40.1994 178.283 40.2904 178.283 40.3813L178.192 40.5632C178.101 40.6541 178.01 40.7451 178.01 40.6541Z"
          fill="white"
        />
        <path
          d="M190.105 35.2889L189.923 35.1979C189.832 35.1979 189.832 35.107 189.832 35.0161L189.923 34.8342C189.923 34.7432 190.014 34.7432 190.105 34.7432L190.287 34.8342C190.378 34.8342 190.378 34.9251 190.378 35.0161L190.287 35.1979C190.196 35.2889 190.105 35.2889 190.105 35.2889Z"
          fill="white"
        />
        <path
          d="M109.807 57.4776H109.625C109.534 57.4776 109.534 57.3865 109.534 57.3865V57.2043C109.534 57.1132 109.625 57.1132 109.625 57.1132H109.807C109.898 57.1132 109.898 57.2043 109.898 57.2043V57.3865C109.898 57.3865 109.898 57.4776 109.807 57.4776Z"
          fill="white"
        />
        <path
          d="M131.54 43.383L131.359 43.2921C131.268 43.2921 131.268 43.2011 131.268 43.1102L131.359 42.9283C131.359 42.8374 131.449 42.8374 131.54 42.8374L131.722 42.9283C131.813 42.9283 131.813 43.0192 131.813 43.1102L131.722 43.2921C131.631 43.383 131.631 43.383 131.54 43.383Z"
          fill="white"
        />
        <path
          d="M80.6156 36.3799L80.4337 36.2889C80.3428 36.2889 80.3428 36.198 80.3428 36.1071L80.4337 35.9252C80.4337 35.8343 80.5247 35.8343 80.6156 35.8343L80.7975 35.9252C80.8884 35.9252 80.8884 36.0161 80.8884 36.1071L80.7975 36.2889C80.7065 36.3799 80.7065 36.3799 80.6156 36.3799Z"
          fill="white"
        />
        <path
          d="M118.173 52.1112L117.991 52.0203C117.9 52.0203 117.9 51.9294 117.9 51.8384L117.991 51.6566C117.991 51.5656 118.082 51.5656 118.173 51.5656L118.355 51.6566C118.446 51.6566 118.446 51.7475 118.446 51.8384L118.355 52.0203C118.264 52.1112 118.264 52.1112 118.173 52.1112Z"
          fill="white"
        />
        <path
          d="M139.634 20.557L139.452 20.4661C139.361 20.4661 139.361 20.3751 139.361 20.2842L139.452 20.1023C139.452 20.0114 139.543 20.0114 139.634 20.0114L139.816 20.1023C139.906 20.1023 139.906 20.1932 139.906 20.2842L139.816 20.4661C139.816 20.557 139.725 20.557 139.634 20.557Z"
          fill="white"
        />
      </g>
      <path
        opacity="0.15"
        d="M51.788 78.0295L6.31934 104.31V63.0249L51.788 36.744V78.0295Z"
        fill="url(#paint56_linear_455_18271)"
      />
      <g opacity="0.2">
        <path
          d="M8.41064 79.4854L49.0596 56.0236"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M8.41064 70.481L49.0596 47.0192"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M8.41064 88.3948L49.0596 65.024"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M8.41064 97.3986L49.0596 74.0277"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M44.7866 76.4829L46.1507 75.6644V49.9292L44.7866 50.7476V76.4829Z"
        fill="url(#paint57_linear_455_18271)"
      />
      <path
        d="M40.5132 78.9387L41.8772 78.1202V60.1147L40.5132 60.9331V78.9387Z"
        fill="url(#paint58_linear_455_18271)"
      />
      <path
        d="M36.2388 81.3936L37.6938 80.5752V51.2025L36.2388 52.0209V81.3936Z"
        fill="url(#paint59_linear_455_18271)"
      />
      <path
        d="M32.0557 83.8493L33.4197 83.0309V72.8459L32.0557 73.5734V83.8493Z"
        fill="url(#paint60_linear_455_18271)"
      />
      <path
        d="M27.7812 86.2138L29.1453 85.4863V70.1179L27.7812 70.9363V86.2138Z"
        fill="url(#paint61_linear_455_18271)"
      />
      <path
        d="M23.5078 88.6689L24.9628 87.8505V63.4793L23.5078 64.2977V88.6689Z"
        fill="url(#paint62_linear_455_18271)"
      />
      <path
        d="M19.3242 91.1237L20.6883 90.3053V78.7563L19.3242 79.4838V91.1237Z"
        fill="url(#paint63_linear_455_18271)"
      />
      <path
        d="M15.0503 93.5788L16.5053 92.7603V80.211L15.0503 81.0294V93.5788Z"
        fill="url(#paint64_linear_455_18271)"
      />
      <path
        d="M10.8672 96.0349L12.2312 95.2164V78.2112L10.8672 79.0296V96.0349Z"
        fill="url(#paint65_linear_455_18271)"
      />
      <path
        opacity="0.15"
        d="M212.749 79.3015L258.217 105.582V64.3878L212.749 38.1069V79.3015Z"
        fill="url(#paint66_linear_455_18271)"
      />
      <g opacity="0.2">
        <path
          d="M256.126 80.7556L215.477 57.2938"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M256.126 71.7525L215.477 48.3816"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M256.126 89.7585L215.477 66.2967"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
        <path
          d="M256.126 98.7598L215.477 75.2979"
          stroke="#E2F4FF"
          strokeWidth="0.1353"
          strokeMiterlimit="10"
        />
      </g>
      <path
        opacity="0.6"
        d="M220.114 56.0193C222.115 57.2015 222.752 68.114 225.298 69.569C227.844 71.0239 226.753 60.4752 228.753 61.7483C231.209 63.2943 229.936 76.9349 233.3 78.9355C236.665 80.9361 237.756 62.4758 241.303 64.3855C244.94 66.2952 243.94 79.2083 246.486 80.6633C249.123 82.1183 248.942 78.1171 250.76 79.1174C252.397 80.0267 254.034 86.7561 254.58 89.9389L254.307 98.2142L214.658 75.298L215.659 67.9321C217.114 61.2937 218.569 55.2009 220.114 56.0193Z"
        fill="url(#paint67_linear_455_18271)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_455_18271"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(133.278 157.419) rotate(30.0007) scale(79.4006 79.4052)"
        >
          <stop stopColor="#000020" />
          <stop offset="0.2222" stopColor="#0A113B" />
          <stop offset="0.365" stopColor="#0C1340" />
          <stop offset="0.5278" stopColor="#11194D" />
          <stop offset="0.7005" stopColor="#192364" />
          <stop offset="0.8789" stopColor="#253184" />
          <stop offset="1" stopColor="#2F3C9E" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_455_18271"
          x1="130.131"
          y1="37.9266"
          x2="142.812"
          y2="75.4179"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84E4A4" />
          <stop offset="1" stopColor="#68B69D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_455_18271"
          x1="132.515"
          y1="53.6347"
          x2="108.118"
          y2="66.1776"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_455_18271"
          x1="110.688"
          y1="56.6662"
          x2="115.751"
          y2="56.6662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_455_18271"
          x1="110.725"
          y1="52.5306"
          x2="115.837"
          y2="52.5306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_455_18271"
          x1="111.14"
          y1="60.8012"
          x2="116.474"
          y2="60.8012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_455_18271"
          x1="112.294"
          y1="64.9375"
          x2="117.95"
          y2="64.9375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_455_18271"
          x1="111.307"
          y1="48.3959"
          x2="116.701"
          y2="48.3959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_455_18271"
          x1="112.621"
          y1="44.261"
          x2="118.348"
          y2="44.261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_455_18271"
          x1="115.414"
          y1="39.3006"
          x2="121.723"
          y2="39.3006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_455_18271"
          x1="119.378"
          y1="35.164"
          x2="126.78"
          y2="35.164"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_455_18271"
          x1="114.836"
          y1="69.8973"
          x2="121.022"
          y2="69.8973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_455_18271"
          x1="118.406"
          y1="74.0328"
          x2="125.468"
          y2="74.0328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_455_18271"
          x1="146.24"
          y1="39.2797"
          x2="127.145"
          y2="70.7601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" stopColor="#000067" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_455_18271"
          x1="145.337"
          y1="41.0419"
          x2="128.305"
          y2="69.1205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" stopColor="#000067" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_455_18271"
          x1="88.0013"
          y1="22.6585"
          x2="93.2127"
          y2="35.4803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84E4A4" />
          <stop offset="1" stopColor="#68B69D" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_455_18271"
          x1="90.9604"
          y1="27.3609"
          x2="100.285"
          y2="25.1054"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_455_18271"
          x1="97.4307"
          y1="23.1756"
          x2="96.0906"
          y2="24.3326"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_455_18271"
          x1="96.4753"
          y1="22.0906"
          x2="95.1222"
          y2="23.2589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_455_18271"
          x1="98.2559"
          y1="24.3748"
          x2="96.8441"
          y2="25.5938"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_455_18271"
          x1="98.8951"
          y1="25.7339"
          x2="97.398"
          y2="27.0265"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_455_18271"
          x1="95.376"
          y1="21.1289"
          x2="93.9481"
          y2="22.3618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_455_18271"
          x1="94.0837"
          y1="20.3349"
          x2="92.5679"
          y2="21.6436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_455_18271"
          x1="92.2107"
          y1="19.6603"
          x2="90.5406"
          y2="21.1022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_455_18271"
          x1="90.2162"
          y1="19.4706"
          x2="88.257"
          y2="21.1622"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_455_18271"
          x1="99.3566"
          y1="27.6267"
          x2="97.7192"
          y2="29.0404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_455_18271"
          x1="99.3559"
          y1="29.5385"
          x2="97.4866"
          y2="31.1524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_455_18271"
          x1="78.4012"
          y1="24.6212"
          x2="104.573"
          y2="33.1013"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_455_18271"
          x1="176.83"
          y1="9.69519"
          x2="159.141"
          y2="20.4458"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#84E4A4" />
          <stop offset="1" stopColor="#68B69D" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_455_18271"
          x1="170.592"
          y1="15.1848"
          x2="176.145"
          y2="28.4143"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_455_18271"
          x1="178.315"
          y1="23.7408"
          x2="176.287"
          y2="22.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_455_18271"
          x1="179.691"
          y1="22.0723"
          x2="177.644"
          y2="20.3531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_455_18271"
          x1="176.743"
          y1="25.2444"
          x2="174.606"
          y2="23.4503"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_455_18271"
          x1="174.89"
          y1="26.5136"
          x2="172.625"
          y2="24.6113"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_455_18271"
          x1="180.849"
          y1="20.2193"
          x2="178.689"
          y2="18.4048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_455_18271"
          x1="181.713"
          y1="18.1228"
          x2="179.419"
          y2="16.1966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_455_18271"
          x1="182.263"
          y1="15.1971"
          x2="179.736"
          y2="13.075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_455_18271"
          x1="182.066"
          y1="12.2059"
          x2="179.101"
          y2="9.71637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_455_18271"
          x1="172.203"
          y1="27.6458"
          x2="169.725"
          y2="25.5652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_455_18271"
          x1="169.382"
          y1="28.1018"
          x2="166.554"
          y2="25.7266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70C5A3" />
          <stop offset="0.4947" stopColor="#0A11AB" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_455_18271"
          x1="171.644"
          y1="-4.01252"
          x2="165.361"
          y2="36.65"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_455_18271"
          x1="213.046"
          y1="174.565"
          x2="71.2981"
          y2="130.055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_455_18271"
          x1="129.081"
          y1="108.512"
          x2="130.014"
          y2="193.972"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_455_18271"
          x1="72.943"
          y1="109.289"
          x2="159.567"
          y2="156.538"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.8175" stopColor="#3C53D7" />
          <stop offset="1" stopColor="#2B29C6" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_455_18271"
          x1="147.39"
          y1="165.51"
          x2="127.525"
          y2="122.819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_455_18271"
          x1="129.631"
          y1="105.83"
          x2="130.331"
          y2="169.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_455_18271"
          x1="129.894"
          y1="108.513"
          x2="130.518"
          y2="165.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_455_18271"
          x1="146.183"
          y1="150.341"
          x2="127.571"
          y2="110.343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_455_18271"
          x1="129.545"
          y1="94.4279"
          x2="130.2"
          y2="154.449"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_455_18271"
          x1="129.79"
          y1="96.9426"
          x2="130.375"
          y2="150.488"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_455_18271"
          x1="142.832"
          y1="131.244"
          x2="125.353"
          y2="93.6809"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#4F34D7" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_455_18271"
          x1="128.996"
          y1="77.0227"
          x2="129.611"
          y2="133.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0291005" stopColor="#6DC077" />
          <stop offset="0.9709" stopColor="#223DBA" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_455_18271"
          x1="122.712"
          y1="89.6361"
          x2="142.589"
          y2="125.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_455_18271"
          x1="134.242"
          y1="105.672"
          x2="122.831"
          y2="81.149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000053" />
          <stop offset="0.5425" stopColor="#23007F" />
          <stop offset="1" stopColor="#35498E" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_455_18271"
          x1="131.185"
          y1="86.2428"
          x2="131.544"
          y2="119.158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#62A4A1" />
          <stop offset="1" stopColor="#2F3C9E" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_455_18271"
          x1="131.332"
          y1="6.8447"
          x2="135.139"
          y2="100.596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1EBF9" stopOpacity="0" />
          <stop offset="0.252" stopColor="#F2EEFA" stopOpacity="0" />
          <stop offset="0.2989" stopColor="#F3F0FA" stopOpacity="0" />
          <stop offset="0.4873" stopColor="#EDF9FD" stopOpacity="0.137" />
          <stop offset="0.5741" stopColor="#E9FFFF" stopOpacity="0.2" />
          <stop offset="1" stopColor="#E6FFFF" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_455_18271"
          x1="14.553"
          y1="56.6685"
          x2="49.4158"
          y2="76.7268"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_455_18271"
          x1="45.4409"
          y1="76.6857"
          x2="34.8307"
          y2="58.3089"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_455_18271"
          x1="41.203"
          y1="79.1333"
          x2="30.5929"
          y2="60.7566"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_455_18271"
          x1="36.9641"
          y1="81.4658"
          x2="28.2926"
          y2="66.4466"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_455_18271"
          x1="32.7256"
          y1="84.0276"
          x2="22.1154"
          y2="65.6506"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_455_18271"
          x1="28.4868"
          y1="86.4747"
          x2="17.8766"
          y2="68.0979"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_455_18271"
          x1="24.2489"
          y1="88.9217"
          x2="13.6388"
          y2="70.5448"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_455_18271"
          x1="20.0098"
          y1="91.3682"
          x2="9.39969"
          y2="72.9914"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_455_18271"
          x1="15.7716"
          y1="93.8151"
          x2="5.16142"
          y2="75.4383"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_455_18271"
          x1="11.5331"
          y1="96.263"
          x2="0.922856"
          y2="77.8861"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_455_18271"
          x1="249.97"
          y1="57.9817"
          x2="215.107"
          y2="78.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_455_18271"
          x1="239.554"
          y1="72.7835"
          x2="232.615"
          y2="83.8041"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0873016" stopColor="#84E4A4" />
          <stop offset="0.9709" stopColor="#3C53D7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const Ellipse = () => {
  return (
    <svg
      width="5"
      height="4"
      viewBox="0 0 5 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2" r="2" fill="#CAC6DD" />
    </svg>
  );
};

const EllipseSlider = () => {
  return (
    <svg
      width="153"
      height="8"
      viewBox="0 0 153 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4.5" cy="4" r="3.5" stroke="url(#paint0_angular_455_18207)" />
      <circle cx="28.5" cy="4" r="3.5" stroke="#3F3A52" />
      <circle cx="52.5" cy="4" r="3.5" stroke="#3F3A52" />
      <circle cx="76.5" cy="4" r="3.5" stroke="#3F3A52" />
      <circle cx="100.5" cy="4" r="3.5" stroke="#3F3A52" />
      <circle cx="124.5" cy="4" r="3.5" stroke="#3F3A52" />
      <circle cx="148.5" cy="4" r="3.5" stroke="#3F3A52" />
      <defs>
        <radialGradient
          id="paint0_angular_455_18207"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.5 4) rotate(90) scale(4)"
        >
          <stop offset="0.046875" stopColor="#FFC876" />
          <stop offset="0.395833" stopColor="#79FFF7" />
          <stop offset="0.718753" stopColor="#0182FA" />
          <stop offset="1" stopColor="#FF98E2" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export {
  DerivableLogo,
  DerivableLogoMini,
  HomeContentHeader,
  HomeContentHeaderMobile,
  ScrollSVG,
  CardBorder,
  CardBorderHover,
  InfiniteLiquidity,
  ArrowIcon,
  ArrowRightIcon,
  RectangleGradient,
  RectangleGradientMobile,
  DiscoverBanner,
  DiscoverBannerMobile,
  Ellipse,
  EllipseSlider,
};
